/* eslint-disable */
 
export const territoriesData = {
  items: [
    {
      id: "6e978fc5-f20a-4b5f-9adf-61dd21a7672a",
      code: 1,
      name: "Adrar",
      postalCode: "1",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b9170873-bebd-40d2-98fb-96a5ace84aba",
      code: 1,
      name: "Adrar",
      postalCode: "01000",
      level: "commune",
      parentId: "6e978fc5-f20a-4b5f-9adf-61dd21a7672a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "981f136a-996f-463e-a536-8e643daab193",
      code: 2,
      name: "Chlef",
      postalCode: "2",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "bd9a789f-ea2b-40fd-9c79-ea9d6c62f264",
      code: 2,
      name: "Akabli",
      postalCode: "02000",
      level: "commune",
      parentId: "6e978fc5-f20a-4b5f-9adf-61dd21a7672a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3c53e80c-b8ca-47af-b76f-eb45ed6e6294",
      code: 3,
      name: "Aougrout",
      postalCode: "03000",
      level: "commune",
      parentId: "bcb30485-37b5-4135-a508-acad8a8a9cf8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "00b5ef4b-ae2e-4b7f-bd26-70c1a376b69b",
      code: 3,
      name: "Laghouat",
      postalCode: "3",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "37c70742-df6b-4019-981a-a16a29a14748",
      code: 4,
      name: "Oum El Bouaghi",
      postalCode: "4",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "cdb1b09b-d3cf-4c7a-979a-cb6a16ae0737",
      code: 4,
      name: "Aoulef",
      postalCode: "04000",
      level: "commune",
      parentId: "6e978fc5-f20a-4b5f-9adf-61dd21a7672a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      code: 5,
      name: "Batna",
      postalCode: "5",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      code: 6,
      name: "Bejaia",
      postalCode: "6",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b67de4b6-09f8-4fd6-a39b-6f117e006e33",
      code: 6,
      name: "Bouda",
      postalCode: "06000",
      level: "commune",
      parentId: "6e978fc5-f20a-4b5f-9adf-61dd21a7672a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "099a08c8-1d49-4beb-b3e3-06a040240a85",
      code: 7,
      name: "Charouine",
      postalCode: "07000",
      level: "commune",
      parentId: "bcb30485-37b5-4135-a508-acad8a8a9cf8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "796e70df-1102-44da-9582-2da66ead2ba6",
      code: 7,
      name: "Biskra",
      postalCode: "7",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e740c188-2bbc-4206-8999-302b17dc0e4b",
      code: 8,
      name: "Bechar",
      postalCode: "8",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8cd83a19-a896-4afa-8b7c-a33601371a0b",
      code: 8,
      name: "Deldoul",
      postalCode: "08000",
      level: "commune",
      parentId: "bcb30485-37b5-4135-a508-acad8a8a9cf8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a7e764cf-e9ca-4c1f-8232-89852d102aec",
      code: 9,
      name: "Blida",
      postalCode: "9",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4aa7999a-4b16-4f0b-8f13-8a0eeec1c344",
      code: 9,
      name: "Fenoughil",
      postalCode: "09000",
      level: "commune",
      parentId: "6e978fc5-f20a-4b5f-9adf-61dd21a7672a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6d89d4e3-10ea-4a9d-90a5-be53b3a2b1cb",
      code: 10,
      name: "In Zghmir",
      postalCode: "10000",
      level: "commune",
      parentId: "6e978fc5-f20a-4b5f-9adf-61dd21a7672a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      code: 10,
      name: "Bouira",
      postalCode: "10",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "38560f06-e049-4fd2-9664-a655e552b517",
      code: 11,
      name: "Tamanrasset",
      postalCode: "11",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7f6c89b5-2e84-4e6f-b32b-0024d0022c79",
      code: 11,
      name: "Ksar Kaddour",
      postalCode: "11000",
      level: "commune",
      parentId: "bcb30485-37b5-4135-a508-acad8a8a9cf8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5afdfab6-e505-4691-abc7-5e8bd79afad5",
      code: 12,
      name: "Tebessa",
      postalCode: "12",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1f4e2dfe-6f48-43b1-b3d8-7e46e1f37d18",
      code: 12,
      name: "Metarfa",
      postalCode: "12000",
      level: "commune",
      parentId: "bcb30485-37b5-4135-a508-acad8a8a9cf8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      code: 13,
      name: "Tlemcen",
      postalCode: "13",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a55f84eb-c1a9-4970-bbcb-c1bf62c4d78d",
      code: 13,
      name: "Ouled Ahmed Timmi",
      postalCode: "13000",
      level: "commune",
      parentId: "6e978fc5-f20a-4b5f-9adf-61dd21a7672a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      code: 14,
      name: "Tiaret",
      postalCode: "14",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6c42e122-cc0b-445e-96c9-8a467ff3af65",
      code: 14,
      name: "Ouled Aissa",
      postalCode: "14000",
      level: "commune",
      parentId: "bcb30485-37b5-4135-a508-acad8a8a9cf8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d1dae286-661e-4153-89b1-9c972a2f80f4",
      code: 15,
      name: "Ouled Said",
      postalCode: "15000",
      level: "commune",
      parentId: "bcb30485-37b5-4135-a508-acad8a8a9cf8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      code: 15,
      name: "Tizi Ouzou",
      postalCode: "15",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      code: 16,
      name: "Alger",
      postalCode: "16",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6616ee32-c281-4e7e-954a-ec295e97b888",
      code: 16,
      name: "Reggane",
      postalCode: "16000",
      level: "commune",
      parentId: "6e978fc5-f20a-4b5f-9adf-61dd21a7672a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      code: 17,
      name: "Djelfa",
      postalCode: "17",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "97629e30-cb74-483c-a773-b4f6a0022448",
      code: 17,
      name: "Sali",
      postalCode: "17000",
      level: "commune",
      parentId: "6e978fc5-f20a-4b5f-9adf-61dd21a7672a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5f95be30-bd1c-41fd-b631-937846cd7efc",
      code: 18,
      name: "Sebaa",
      postalCode: "18000",
      level: "commune",
      parentId: "6e978fc5-f20a-4b5f-9adf-61dd21a7672a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "dc851e52-55b2-4beb-a7f1-79d4e73e9458",
      code: 18,
      name: "Jijel",
      postalCode: "18",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f1b09257-66a2-4d34-afe9-86f9f9c6acf1",
      code: 19,
      name: "Talmine",
      postalCode: "19000",
      level: "commune",
      parentId: "bcb30485-37b5-4135-a508-acad8a8a9cf8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "56ee938d-7887-408e-8731-364d07ad3594",
      code: 19,
      name: "Setif",
      postalCode: "19",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3175242c-720d-4487-99e1-579d87f0e9ea",
      code: 20,
      name: "Tamantit",
      postalCode: "20000",
      level: "commune",
      parentId: "6e978fc5-f20a-4b5f-9adf-61dd21a7672a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "27b2042a-77f8-4c91-b62d-60934fa0daca",
      code: 20,
      name: "Saida",
      postalCode: "20",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "cf9be3f1-0377-40bc-9b10-0826c61d8a61",
      code: 21,
      name: "Tamest",
      postalCode: "21000",
      level: "commune",
      parentId: "6e978fc5-f20a-4b5f-9adf-61dd21a7672a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a9df7e26-1086-4319-8a93-19969c99c89b",
      code: 21,
      name: "Skikda",
      postalCode: "21",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      code: 22,
      name: "Sidi Bel Abbes",
      postalCode: "22",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6c6149d5-b34c-4e0f-af57-4b56b6179082",
      code: 22,
      name: "Timekten",
      postalCode: "22000",
      level: "commune",
      parentId: "6e978fc5-f20a-4b5f-9adf-61dd21a7672a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3fd318e8-7c24-480c-a106-21f6c842583d",
      code: 23,
      name: "Annaba",
      postalCode: "23",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      code: 24,
      name: "Guelma",
      postalCode: "24",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b6f63f60-e149-42c6-a04a-418889adfbeb",
      code: 24,
      name: "Timimoun",
      postalCode: "24000",
      level: "commune",
      parentId: "bcb30485-37b5-4135-a508-acad8a8a9cf8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e9a1e9cf-8475-4768-94cc-0888d094ff47",
      code: 25,
      name: "Constantine",
      postalCode: "25",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "10786d8c-d70b-446d-b6ce-1d41d99d64ce",
      code: 25,
      name: "Tinerkouk",
      postalCode: "25000",
      level: "commune",
      parentId: "bcb30485-37b5-4135-a508-acad8a8a9cf8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      code: 26,
      name: "Medea",
      postalCode: "26",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0cd63e5b-3055-45a8-81c9-df07b0128540",
      code: 26,
      name: "Tit",
      postalCode: "26000",
      level: "commune",
      parentId: "6e978fc5-f20a-4b5f-9adf-61dd21a7672a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "669d3f83-601b-4521-99a5-e03d2d4b8404",
      code: 27,
      name: "Tsabit",
      postalCode: "27000",
      level: "commune",
      parentId: "6e978fc5-f20a-4b5f-9adf-61dd21a7672a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      code: 27,
      name: "Mostaganem",
      postalCode: "27",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "09f82491-7fda-489d-88e8-f5c07386ca8d",
      code: 28,
      name: "Zaouiet Kounta",
      postalCode: "28000",
      level: "commune",
      parentId: "6e978fc5-f20a-4b5f-9adf-61dd21a7672a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      code: 28,
      name: "MSila",
      postalCode: "28",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      code: 29,
      name: "Mascara",
      postalCode: "29",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3e3e67ed-63a8-42e4-8ab0-b9f4f5c4e046",
      code: 29,
      name: "Abou El Hassane",
      postalCode: "29000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ada333a0-708d-476e-a97d-fd70fe661b09",
      code: 30,
      name: "Ouargla",
      postalCode: "30",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "11919c5f-d73d-459b-a01f-75818d49814f",
      code: 30,
      name: "Ain Merane",
      postalCode: "30000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e772eb46-276a-4f41-bae7-3b67e1bdc616",
      code: 31,
      name: "Oran",
      postalCode: "31",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6a3435f2-b577-4fed-acc5-524c598ebb80",
      code: 31,
      name: "Benairia",
      postalCode: "31000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "dca8b699-ce8b-4ad7-b8f2-560e63911383",
      code: 32,
      name: "El Bayadh",
      postalCode: "32",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6b142d38-22f9-4e4a-a0d3-be7491ccc63d",
      code: 32,
      name: "Beni  Bouattab",
      postalCode: "32000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "32660d04-6a57-4524-aff3-baf43ee6bc31",
      code: 33,
      name: "Beni Haoua",
      postalCode: "33000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      code: 34,
      name: "Bordj Bou Arreridj",
      postalCode: "34",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3dc54b12-c898-4b61-8acc-bc3c6e5d7d26",
      code: 34,
      name: "Beni Rached",
      postalCode: "34000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f823492c-f79d-4c2d-befe-933bf9917a65",
      code: 35,
      name: "Boumerdes",
      postalCode: "35",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "622a68f1-473b-406f-9268-2456dd9b7671",
      code: 35,
      name: "Boukadir",
      postalCode: "35000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d4b26a15-0f6c-4cba-b0dd-bd434db51526",
      code: 36,
      name: "Bouzeghaia",
      postalCode: "36000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e6f4b09c-f63e-42af-92bc-dab9b422c34d",
      code: 36,
      name: "El Tarf",
      postalCode: "36",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "359c4465-4608-4c04-b3a7-ca3193c2b3f2",
      code: 37,
      name: "Breira",
      postalCode: "37000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "fb1a9f7a-81a2-4825-af92-79f9d187637f",
      code: 38,
      name: "Tissemsilt",
      postalCode: "38",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "dc44eb7c-2ace-4b63-b15a-34f493bde8d8",
      code: 38,
      name: "Chettia",
      postalCode: "38000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "cd82549a-b1f7-48c1-9a25-2f3f05b80b1d",
      code: 39,
      name: "El Oued",
      postalCode: "39",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "fc22bf39-a1f5-44bf-ac5e-b25280768926",
      code: 39,
      name: "Chlef",
      postalCode: "39000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d4549528-8327-4a3f-9732-5a5462c84b8d",
      code: 40,
      name: "Khenchela",
      postalCode: "40",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "df5bb079-a2b8-41b5-80fa-e621bfe61690",
      code: 40,
      name: "Dahra",
      postalCode: "40000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6de43d4d-338a-4cb0-a68e-e2d635d8f0ab",
      code: 41,
      name: "El Hadjadj",
      postalCode: "41000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "56d30b7a-465a-462c-bc2a-3e132c89be63",
      code: 41,
      name: "Souk Ahras",
      postalCode: "41",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c405f087-4eb6-409a-9977-ef43a6219a4c",
      code: 42,
      name: "El Karimia",
      postalCode: "42000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1435179a-6dbb-4d9c-a186-c521b2a57319",
      code: 42,
      name: "Tipaza",
      postalCode: "42",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c0d06b1b-1bfc-47ac-83e1-315b18d0fe2f",
      code: 43,
      name: "El Marsa",
      postalCode: "43000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      code: 43,
      name: "Mila",
      postalCode: "43",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8d2d130f-460c-4867-85ef-641341a4d586",
      code: 44,
      name: "Ain Defla",
      postalCode: "44",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3a824969-9ffb-49ac-9722-bfb325073c19",
      code: 44,
      name: "Harchoun",
      postalCode: "44000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ecdf0888-0470-4b2f-beb8-24c99b6fc9cb",
      code: 45,
      name: "Naama",
      postalCode: "45",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0d056318-f761-482c-938c-0c3326c63e80",
      code: 45,
      name: "Herenfa",
      postalCode: "45000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "320dd6a2-d8ae-49a1-9832-82b03505d687",
      code: 46,
      name: "Labiod Medjadja",
      postalCode: "46000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "fc460ec5-3e71-489c-b95b-e5301ea68341",
      code: 46,
      name: "Ain Temouchent",
      postalCode: "46",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0693b196-8177-4b0a-b6cf-0951f7531177",
      code: 47,
      name: "Moussadek",
      postalCode: "47000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e7b51620-74f4-4748-85c5-216fb9b01b03",
      code: 47,
      name: "Ghardaia",
      postalCode: "47",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "adec6ba3-0e4a-4ff4-b90a-335f94cbb85e",
      code: 48,
      name: "Oued Fodda",
      postalCode: "48000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      code: 48,
      name: "Relizane",
      postalCode: "48",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "fc12e8bb-399c-4fde-b82a-21467e3a4abf",
      code: 49,
      name: "Oued Goussine",
      postalCode: "49000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "bcb30485-37b5-4135-a508-acad8a8a9cf8",
      code: 49,
      name: "Timimoun",
      postalCode: "49",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "50d15975-0d39-4c57-969f-7e9d2ada74e3",
      code: 50,
      name: "Oued Sly",
      postalCode: "50000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "09995504-3bb4-4929-8551-3be9ed34c8a3",
      code: 51,
      name: "Ouled Abbes",
      postalCode: "51000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0f2dab00-094c-412c-a7d0-ebd0268d3d3c",
      code: 51,
      name: "Ouled Djellal",
      postalCode: "51",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "910e38a2-6552-4a8c-b12a-bfce6ba8e607",
      code: 52,
      name: "Ouled Ben Abdelkader",
      postalCode: "52000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ba12c65c-de9e-4f30-a449-6ba0b27dd7d7",
      code: 52,
      name: "Beni Abbes",
      postalCode: "52",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6ba259fb-c054-4ac5-8b21-ac50961db13c",
      code: 53,
      name: "Ouled Fares",
      postalCode: "53000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7c752560-8412-4e11-8c75-ed7cd9c22be2",
      code: 53,
      name: "In Salah",
      postalCode: "53",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: false,
      },
    },
    {
      id: "397a4ba3-4713-44f8-88c5-71653b3e8e33",
      code: 54,
      name: "Oum Drou",
      postalCode: "54000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f30136dc-3012-4ac7-912c-33eab37393a9",
      code: 54,
      name: "In Guezzam",
      postalCode: "54",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: false,
      },
    },
    {
      id: "442d8a1c-2e12-4a8a-9c7e-8618aac20280",
      code: 55,
      name: "Touggourt",
      postalCode: "55",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "255d3721-0cdb-4f72-8d18-c1d7b552629f",
      code: 55,
      name: "Sendjas",
      postalCode: "55000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "da7620f2-efbf-44d6-99e4-53f7de29e1ca",
      code: 56,
      name: "Sidi Abderrahmane",
      postalCode: "56000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "eabb6505-5eef-479f-b6a3-36ba282d5237",
      code: 57,
      name: "El Meghaier",
      postalCode: "57",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: false,
      },
    },
    {
      id: "8f5cbc9a-59e2-49c4-b0e9-b812ab4fe8c4",
      code: 57,
      name: "Sidi Akkacha",
      postalCode: "57000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3d19d427-08f3-492c-a1d0-e7ace3516ed2",
      code: 58,
      name: "El Menia",
      postalCode: "58",
      level: "wilaya",
      parentId: null,
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: false,
      },
    },
    {
      id: "103f2081-934f-4a95-8610-511dd1385299",
      code: 58,
      name: "Sobha",
      postalCode: "58000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "289df37c-c3e2-45f4-811d-6308dda00ad3",
      code: 59,
      name: "Tadjena",
      postalCode: "59000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9ea10c9d-30a5-43aa-ab2c-2f0365399e7d",
      code: 60,
      name: "Talassa",
      postalCode: "60000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "845c89e0-f04a-496f-a87c-8273affa7611",
      code: 61,
      name: "Taougrit",
      postalCode: "61000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8f556564-064c-4bd8-a720-234fb16251c8",
      code: 62,
      name: "Tenes",
      postalCode: "62000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "95e259c9-f2fe-4569-b741-7e4b5a14896b",
      code: 63,
      name: "Zeboudja",
      postalCode: "63000",
      level: "commune",
      parentId: "981f136a-996f-463e-a536-8e643daab193",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "634e772e-7717-4e57-a495-ef60d5507aa4",
      code: 64,
      name: "Aflou",
      postalCode: "64000",
      level: "commune",
      parentId: "00b5ef4b-ae2e-4b7f-bd26-70c1a376b69b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "06903f83-151e-44c7-9d32-a27a038f4d36",
      code: 65,
      name: "Ain Madhi",
      postalCode: "65000",
      level: "commune",
      parentId: "00b5ef4b-ae2e-4b7f-bd26-70c1a376b69b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d7964522-52f8-45b9-ac97-2b9346b9de0c",
      code: 66,
      name: "Ain Sidi Ali",
      postalCode: "66000",
      level: "commune",
      parentId: "00b5ef4b-ae2e-4b7f-bd26-70c1a376b69b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4d84fa8c-ff4d-46c4-87d9-c4a0d9b7edfa",
      code: 67,
      name: "El Beidha",
      postalCode: "67000",
      level: "commune",
      parentId: "00b5ef4b-ae2e-4b7f-bd26-70c1a376b69b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1efa04e0-a97b-4491-a49c-2c9c202b1d2b",
      code: 68,
      name: "Benacer Benchohra",
      postalCode: "68000",
      level: "commune",
      parentId: "00b5ef4b-ae2e-4b7f-bd26-70c1a376b69b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7ebd963e-9ba3-4a97-82f2-f0df29b1718d",
      code: 69,
      name: "Brida",
      postalCode: "69000",
      level: "commune",
      parentId: "00b5ef4b-ae2e-4b7f-bd26-70c1a376b69b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5390da7e-90e9-40e0-8051-3b2ab64b79af",
      code: 70,
      name: "El Assafia",
      postalCode: "70000",
      level: "commune",
      parentId: "00b5ef4b-ae2e-4b7f-bd26-70c1a376b69b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7ae49d98-85b5-4bac-8be4-9a84254da4d8",
      code: 71,
      name: "El Ghicha",
      postalCode: "71000",
      level: "commune",
      parentId: "00b5ef4b-ae2e-4b7f-bd26-70c1a376b69b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "022d2789-04dc-46ab-8dbb-3444e5cfe4ea",
      code: 72,
      name: "El Haouaita",
      postalCode: "72000",
      level: "commune",
      parentId: "00b5ef4b-ae2e-4b7f-bd26-70c1a376b69b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "23b26c4b-6c06-43cf-a2fc-2fcc6ea0805f",
      code: 73,
      name: "Gueltat Sidi Saad",
      postalCode: "73000",
      level: "commune",
      parentId: "00b5ef4b-ae2e-4b7f-bd26-70c1a376b69b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "92ad069a-6696-499c-b35a-5915b05a9645",
      code: 74,
      name: "Hadj Mechri",
      postalCode: "74000",
      level: "commune",
      parentId: "00b5ef4b-ae2e-4b7f-bd26-70c1a376b69b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3d051cd5-38c5-4042-b73a-9635ea2126a7",
      code: 75,
      name: "Hassi Delaa",
      postalCode: "75000",
      level: "commune",
      parentId: "00b5ef4b-ae2e-4b7f-bd26-70c1a376b69b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ac24a80b-4caa-48ef-97ce-9ad54c5cfa32",
      code: 76,
      name: "Hassi R'mel",
      postalCode: "76000",
      level: "commune",
      parentId: "00b5ef4b-ae2e-4b7f-bd26-70c1a376b69b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8e5d56ff-97e6-4297-a350-8c95c4c9cfc1",
      code: 77,
      name: "Kheneg",
      postalCode: "77000",
      level: "commune",
      parentId: "00b5ef4b-ae2e-4b7f-bd26-70c1a376b69b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7d745351-6ee4-4a44-8891-56c1109afb53",
      code: 78,
      name: "Ksar El Hirane",
      postalCode: "78000",
      level: "commune",
      parentId: "00b5ef4b-ae2e-4b7f-bd26-70c1a376b69b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5966de94-d813-4e57-aee2-42566cc48be6",
      code: 79,
      name: "Laghouat",
      postalCode: "79000",
      level: "commune",
      parentId: "00b5ef4b-ae2e-4b7f-bd26-70c1a376b69b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8cc7e2e0-f103-4186-bf51-be00e78af529",
      code: 80,
      name: "Oued Morra",
      postalCode: "80000",
      level: "commune",
      parentId: "00b5ef4b-ae2e-4b7f-bd26-70c1a376b69b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f272cc93-9cfe-4763-b58a-a07432fe722c",
      code: 81,
      name: "Oued M'zi",
      postalCode: "81000",
      level: "commune",
      parentId: "00b5ef4b-ae2e-4b7f-bd26-70c1a376b69b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "478c4de4-a1dc-4bc4-b6b5-a651e9514a23",
      code: 82,
      name: "Sebgag",
      postalCode: "82000",
      level: "commune",
      parentId: "00b5ef4b-ae2e-4b7f-bd26-70c1a376b69b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2403c760-d0fa-454f-abed-b7b0511dfeba",
      code: 83,
      name: "Sidi Bouzid",
      postalCode: "83000",
      level: "commune",
      parentId: "00b5ef4b-ae2e-4b7f-bd26-70c1a376b69b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "55d77aa1-909b-4dbd-99fd-d69316b2651a",
      code: 84,
      name: "Sidi Makhlouf",
      postalCode: "84000",
      level: "commune",
      parentId: "00b5ef4b-ae2e-4b7f-bd26-70c1a376b69b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "832fb1aa-7241-489e-9909-ac97942e339f",
      code: 85,
      name: "Tadjemout",
      postalCode: "85000",
      level: "commune",
      parentId: "00b5ef4b-ae2e-4b7f-bd26-70c1a376b69b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "deb80a97-1251-494e-9ac1-e197152d62a6",
      code: 86,
      name: "Tadjrouna",
      postalCode: "86000",
      level: "commune",
      parentId: "00b5ef4b-ae2e-4b7f-bd26-70c1a376b69b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "69f4464d-a157-44d6-8ba8-365af224a844",
      code: 87,
      name: "Taouiala",
      postalCode: "87000",
      level: "commune",
      parentId: "00b5ef4b-ae2e-4b7f-bd26-70c1a376b69b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f7dc5a01-2ca3-4443-bcda-6d570fe85913",
      code: 88,
      name: "Ain Babouche",
      postalCode: "88000",
      level: "commune",
      parentId: "37c70742-df6b-4019-981a-a16a29a14748",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6e743974-1d6d-44d2-9d65-475debc85350",
      code: 89,
      name: "Ain Beida",
      postalCode: "89000",
      level: "commune",
      parentId: "37c70742-df6b-4019-981a-a16a29a14748",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "fc9c30a5-8324-4db1-8562-f0ed366a1277",
      code: 90,
      name: "Ain Diss",
      postalCode: "90000",
      level: "commune",
      parentId: "37c70742-df6b-4019-981a-a16a29a14748",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5e20a3f2-23d7-4c6b-add3-06d1c068b1e2",
      code: 91,
      name: "Ain Fekroun",
      postalCode: "91000",
      level: "commune",
      parentId: "37c70742-df6b-4019-981a-a16a29a14748",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7d6c04e3-712b-4271-b6a9-9e26d5128c9a",
      code: 92,
      name: "Ain Kercha",
      postalCode: "92000",
      level: "commune",
      parentId: "37c70742-df6b-4019-981a-a16a29a14748",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "eb3ee5ff-1bdb-4e5f-b54b-4fe0a83b6e9a",
      code: 93,
      name: "Ain M'lila",
      postalCode: "93000",
      level: "commune",
      parentId: "37c70742-df6b-4019-981a-a16a29a14748",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7185bafa-8b32-4c56-a3da-9ec78177654e",
      code: 94,
      name: "Ain Zitoun",
      postalCode: "94000",
      level: "commune",
      parentId: "37c70742-df6b-4019-981a-a16a29a14748",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f2e399a5-ca3d-4d3a-bf5c-dd4bc9b1da24",
      code: 95,
      name: "Behir Chergui",
      postalCode: "95000",
      level: "commune",
      parentId: "37c70742-df6b-4019-981a-a16a29a14748",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d21d54fa-942e-4e5b-905a-cda21658a5fe",
      code: 96,
      name: "Berriche",
      postalCode: "96000",
      level: "commune",
      parentId: "37c70742-df6b-4019-981a-a16a29a14748",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "368adda5-2a58-4582-942a-d2db72a21820",
      code: 97,
      name: "Bir Chouhada",
      postalCode: "97000",
      level: "commune",
      parentId: "37c70742-df6b-4019-981a-a16a29a14748",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "81947893-494a-4fda-8ff7-7ba1b30e5eb0",
      code: 98,
      name: "Dhalaa",
      postalCode: "98000",
      level: "commune",
      parentId: "37c70742-df6b-4019-981a-a16a29a14748",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "08de6d4e-18da-4874-95af-cbfedec14009",
      code: 99,
      name: "El Amiria",
      postalCode: "99000",
      level: "commune",
      parentId: "37c70742-df6b-4019-981a-a16a29a14748",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e0353951-f88a-44ac-9e72-4e35d6a15dbe",
      code: 100,
      name: "El Belala",
      postalCode: "100000",
      level: "commune",
      parentId: "37c70742-df6b-4019-981a-a16a29a14748",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "bb5cf597-ca98-4939-ac83-2f0900733f46",
      code: 101,
      name: "El Djazia",
      postalCode: "101000",
      level: "commune",
      parentId: "37c70742-df6b-4019-981a-a16a29a14748",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0a3e00ec-2cb9-4493-a3a0-c5193115c406",
      code: 102,
      name: "El Fedjoudj Boughrara Sa",
      postalCode: "102000",
      level: "commune",
      parentId: "37c70742-df6b-4019-981a-a16a29a14748",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f63f567c-52fa-436c-835e-4f57cf28f3f7",
      code: 103,
      name: "El Harmilia",
      postalCode: "103000",
      level: "commune",
      parentId: "37c70742-df6b-4019-981a-a16a29a14748",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "fc6385b7-7681-44be-aeae-8d387d2edb06",
      code: 104,
      name: "Fkirina",
      postalCode: "104000",
      level: "commune",
      parentId: "37c70742-df6b-4019-981a-a16a29a14748",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "25472508-3030-42ab-a3d0-ddd340650411",
      code: 105,
      name: "Hanchir Toumghani",
      postalCode: "105000",
      level: "commune",
      parentId: "37c70742-df6b-4019-981a-a16a29a14748",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "add35d14-e74d-4c12-920e-c394d25f66b6",
      code: 106,
      name: "Ksar Sbahi",
      postalCode: "106000",
      level: "commune",
      parentId: "37c70742-df6b-4019-981a-a16a29a14748",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "fb09fbf1-7a25-430e-8bc7-2dfd9ab17ab1",
      code: 107,
      name: "Meskiana",
      postalCode: "107000",
      level: "commune",
      parentId: "37c70742-df6b-4019-981a-a16a29a14748",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7bb21ec1-d02a-458c-8cc2-a63a3a817feb",
      code: 108,
      name: "Oued Nini",
      postalCode: "108000",
      level: "commune",
      parentId: "37c70742-df6b-4019-981a-a16a29a14748",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "cdeffd46-b8ad-42c6-ae12-9014dfcffb0f",
      code: 109,
      name: "Ouled Gacem",
      postalCode: "109000",
      level: "commune",
      parentId: "37c70742-df6b-4019-981a-a16a29a14748",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "adb87515-9b05-40e1-a0e4-087eb74da1f7",
      code: 110,
      name: "Ouled Hamla",
      postalCode: "110000",
      level: "commune",
      parentId: "37c70742-df6b-4019-981a-a16a29a14748",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2b05c952-e28b-410c-8254-e3b8d62a224b",
      code: 111,
      name: "Ouled Zouai",
      postalCode: "111000",
      level: "commune",
      parentId: "37c70742-df6b-4019-981a-a16a29a14748",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "340d6a99-c51e-4875-bbbe-fd4434aafa80",
      code: 112,
      name: "Oum El Bouaghi",
      postalCode: "112000",
      level: "commune",
      parentId: "37c70742-df6b-4019-981a-a16a29a14748",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4f9caecf-8879-4a45-baa9-8d3b896b93a4",
      code: 113,
      name: "Rahia",
      postalCode: "113000",
      level: "commune",
      parentId: "37c70742-df6b-4019-981a-a16a29a14748",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e4203248-90be-48f6-ba97-dd3290521704",
      code: 114,
      name: "Sigus",
      postalCode: "114000",
      level: "commune",
      parentId: "37c70742-df6b-4019-981a-a16a29a14748",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ff5a8323-5712-4e80-baef-172238d93daa",
      code: 115,
      name: "Souk Naamane",
      postalCode: "115000",
      level: "commune",
      parentId: "37c70742-df6b-4019-981a-a16a29a14748",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c66489d2-7133-4342-9bf3-9a325e11fa4a",
      code: 116,
      name: "Zorg",
      postalCode: "116000",
      level: "commune",
      parentId: "37c70742-df6b-4019-981a-a16a29a14748",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "35f9ddc2-97db-402b-b287-af4952c7addc",
      code: 117,
      name: "Ain Djasser",
      postalCode: "117000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "85b9d2da-987a-476c-8556-e728b7dad412",
      code: 118,
      name: "Ain Touta",
      postalCode: "118000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e80f3ce6-376e-48f6-b293-fee67b763955",
      code: 119,
      name: "Ain Yagout",
      postalCode: "119000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0048d3b8-92ea-4322-be54-902fc4bd1c72",
      code: 120,
      name: "Arris",
      postalCode: "120000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d3fb1ccb-33d5-4997-b63f-6e3d18eff211",
      code: 121,
      name: "Azil Abedelkader",
      postalCode: "121000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "dfc5084e-d106-40ce-8fa0-e9f468ea29f5",
      code: 122,
      name: "Barika",
      postalCode: "122000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "37f5389c-ee2d-4dec-81dc-058d8cc15098",
      code: 123,
      name: "Batna",
      postalCode: "123000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d009393b-1744-4131-8583-bd789bc9f67d",
      code: 124,
      name: "Beni Foudhala El Hakania",
      postalCode: "124000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "eb68ab6c-dd69-4cd0-aa0e-ba72ea789ca4",
      code: 125,
      name: "Bitam",
      postalCode: "125000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ef7a6a53-dd64-42b6-bac3-85d139f37092",
      code: 126,
      name: "Boulhilat",
      postalCode: "126000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7831b984-a920-4131-82a9-dabf661f4504",
      code: 127,
      name: "Boumagueur",
      postalCode: "127000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d9008737-2cc3-48a0-b861-af38f05f34ed",
      code: 128,
      name: "Boumia",
      postalCode: "128000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "fff3127a-494f-4bed-a99f-a7076b7c0a6f",
      code: 129,
      name: "Bouzina",
      postalCode: "129000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f1a62d37-07d8-499b-8014-e0711d2e193e",
      code: 130,
      name: "Chemora",
      postalCode: "130000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1f0a58dc-722d-4462-93f5-ad93d5ce937b",
      code: 131,
      name: "Chir",
      postalCode: "131000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "592885b2-7cfe-445d-a4dd-6bcc40075d92",
      code: 132,
      name: "Djerma",
      postalCode: "132000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "51f42947-0c6b-422c-a5c5-abdbde155cc4",
      code: 133,
      name: "Djezzar",
      postalCode: "133000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "891d4701-f5c5-4f5a-afc0-bfe2fc3a9ea4",
      code: 134,
      name: "El Hassi",
      postalCode: "134000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "81766aac-bf6b-4312-9b3a-36d1bfc8c370",
      code: 135,
      name: "El Madher",
      postalCode: "135000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "77a6aa13-14f3-4155-875e-c6cde844c304",
      code: 136,
      name: "Fesdis",
      postalCode: "136000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "66ab2668-769b-48b0-8416-c5168458f09e",
      code: 137,
      name: "Foum Toub",
      postalCode: "137000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "381ff92a-6b4f-4f8c-8dde-4f3529762592",
      code: 138,
      name: "Ghassira",
      postalCode: "138000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c858d926-c468-48b7-9586-cb0a89613435",
      code: 139,
      name: "Gosbat",
      postalCode: "139000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ed700470-baea-4be8-8300-d0e7a5b6a264",
      code: 140,
      name: "Guigba",
      postalCode: "140000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "40049720-ec07-4ac9-b53d-99bd4ca2f4e7",
      code: 141,
      name: "Hidoussa",
      postalCode: "141000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4424ea26-451a-4ece-be43-a10cedb06f40",
      code: 142,
      name: "Ichemoul",
      postalCode: "142000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d8944c3f-5f44-4d4e-81d4-3a7797e7bed7",
      code: 143,
      name: "Inoughissen",
      postalCode: "143000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2d472b15-e03a-46fe-ad30-3e0910252508",
      code: 144,
      name: "Kimmel",
      postalCode: "144000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f4a818f0-4785-452c-a835-a2c690665138",
      code: 145,
      name: "Ksar Bellezma",
      postalCode: "145000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b1053caa-6b7d-429c-b40e-fec2419928ec",
      code: 146,
      name: "Larbaa",
      postalCode: "146000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4d535fda-4016-4424-be8f-237f68034845",
      code: 147,
      name: "Lazrou",
      postalCode: "147000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e2b45f68-5320-4314-8651-ddeaa31afdef",
      code: 148,
      name: "Lemcene",
      postalCode: "148000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c71870ad-6c77-4411-aae5-ff764e15e7b5",
      code: 149,
      name: "M Doukal",
      postalCode: "149000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3b85c669-2964-473a-af3c-b293cb41bc8d",
      code: 150,
      name: "Maafa",
      postalCode: "150000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "74ff93ef-f07d-4e95-a8b9-0811398467fc",
      code: 151,
      name: "Menaa",
      postalCode: "151000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7a103eae-df22-4357-8ffa-ab4f5e8016c9",
      code: 152,
      name: "Merouana",
      postalCode: "152000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c105f0df-f10d-4cb4-ad3a-0820af51f751",
      code: 153,
      name: "N Gaous",
      postalCode: "153000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d04454c7-c0c1-4b42-b5a5-411770966d6a",
      code: 154,
      name: "Oued Chaaba",
      postalCode: "154000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "be9a4021-9840-4c82-808a-ca07290879c7",
      code: 155,
      name: "Oued El Ma",
      postalCode: "155000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6dbf77e8-094c-41e6-870f-f24a94e661e8",
      code: 156,
      name: "Oued Taga",
      postalCode: "156000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "fbb0b705-ed9f-461c-a748-bf4a3a2e7a48",
      code: 157,
      name: "Ouled Ammar",
      postalCode: "157000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f14c5532-4e25-4a20-b5a8-5b2453d76772",
      code: 158,
      name: "Ouled Aouf",
      postalCode: "158000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7f5b4284-c595-40ac-8807-e10b8c2b7743",
      code: 159,
      name: "Ouled Fadel",
      postalCode: "159000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0fd19bde-6f66-431e-9cf5-e441e05da35f",
      code: 160,
      name: "Ouled Sellem",
      postalCode: "160000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c37ab15c-36eb-4de6-a30f-5dd3ba6deb91",
      code: 161,
      name: "Ouled Si Slimane",
      postalCode: "161000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c3c9a43f-0073-4f37-8932-41d7e9b75c45",
      code: 162,
      name: "Ouyoun El Assafir",
      postalCode: "162000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7c1c3d54-96c3-43de-ab2a-8989dcf4ae2d",
      code: 163,
      name: "Rahbat",
      postalCode: "163000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "db3730bb-e70d-4a1d-ae18-356fefe438fc",
      code: 164,
      name: "Ras El Aioun",
      postalCode: "164000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "02e6ad51-adb7-4fd7-8541-cddc29487e37",
      code: 165,
      name: "Sefiane",
      postalCode: "165000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "93f42882-c1f9-4d23-acf0-e82cd774b99f",
      code: 166,
      name: "Seggana",
      postalCode: "166000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5ff5adff-66e3-48eb-87b0-f1fd9f0de6cf",
      code: 167,
      name: "Seriana",
      postalCode: "167000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c6075fe7-4c1d-4581-b4c3-2e3792f1672e",
      code: 168,
      name: "T Kout",
      postalCode: "168000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d57aa0ea-f2ad-4ee5-bdf2-c1178121de68",
      code: 169,
      name: "Talkhamt",
      postalCode: "169000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2d0a598a-48f5-4d33-9339-742931bbfa20",
      code: 170,
      name: "Taxlent",
      postalCode: "170000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c142c6af-63de-49d2-9987-d07385502b29",
      code: 171,
      name: "Tazoult",
      postalCode: "171000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ef5a2b18-fb3c-4688-9093-7192fac5bf58",
      code: 172,
      name: "Teniet El Abed",
      postalCode: "172000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d53f0c25-7d36-46d7-a80e-10ac6a8860af",
      code: 173,
      name: "Tighanimine",
      postalCode: "173000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7f95e48e-6007-4ede-86b1-8d62d5f4f290",
      code: 174,
      name: "Tigharghar",
      postalCode: "174000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c49c6245-e54a-4832-92d4-1c180fc5ff25",
      code: 175,
      name: "Tilatou",
      postalCode: "175000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "61ec30d0-6282-4414-ad32-ef3ce6930e02",
      code: 176,
      name: "Timgad",
      postalCode: "176000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e29317dc-5276-449f-953b-85b5dceeb0e7",
      code: 177,
      name: "Zanet El Beida",
      postalCode: "177000",
      level: "commune",
      parentId: "a8c05822-e30a-4d5a-bcb3-3b3bb23c079b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4e5bb389-73a6-4378-a44d-c6e08dc7a1ce",
      code: 178,
      name: "Adekar",
      postalCode: "178000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e937f2d8-8b7c-41b2-b45d-fed9d81650bd",
      code: 179,
      name: "Ait R'zine",
      postalCode: "179000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b61da9c9-ece2-43fc-9dba-b3f9ea04a1f9",
      code: 180,
      name: "Ait-Smail",
      postalCode: "180000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5d964794-b12a-4cd2-8793-78d192723e96",
      code: 181,
      name: "Akbou",
      postalCode: "181000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d043663e-7d13-4d3f-927e-ca28744de574",
      code: 182,
      name: "Akfadou",
      postalCode: "182000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7d3a3c7a-3c1a-4bcc-b3ce-cf8b53df6051",
      code: 183,
      name: "Amalou",
      postalCode: "183000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5f44157b-0250-4345-b7d5-a79c9569a74c",
      code: 184,
      name: "Amizour",
      postalCode: "184000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "fe7c7318-bc11-42fe-93a0-224c5a68a393",
      code: 185,
      name: "Aokas",
      postalCode: "185000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6c99fce4-8b85-4e4b-a340-6da2cb37aa7d",
      code: 186,
      name: "Barbacha",
      postalCode: "186000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "caa7d1a7-4d2c-4d5e-83f1-fb9f09554544",
      code: 187,
      name: "Bejaia",
      postalCode: "187000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e0a71cbd-38ec-44ab-b994-cde9f638c5dc",
      code: 188,
      name: "Beni Djellil",
      postalCode: "188000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "48a1a613-b521-4702-bc9f-fce586aba992",
      code: 189,
      name: "Beni K'sila",
      postalCode: "189000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5abfac39-ccdf-4d3e-ad8b-99f09051912e",
      code: 190,
      name: "Beni-Mallikeche",
      postalCode: "190000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8392bac4-d3d5-4465-ab49-753a26d505b5",
      code: 191,
      name: "Benimaouche",
      postalCode: "191000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5446923c-c7a6-405e-b168-8c06cb860ea6",
      code: 192,
      name: "Boudjellil",
      postalCode: "192000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "bba025fe-98ce-4cb6-a765-73afa0d419c1",
      code: 193,
      name: "Bouhamza",
      postalCode: "193000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8a7b1e73-ee62-4ea5-b25c-9a1e9b4435a3",
      code: 194,
      name: "Boukhelifa",
      postalCode: "194000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6b65c9cd-86b7-4fd4-a3b5-e770ea8a147f",
      code: 195,
      name: "Chellata",
      postalCode: "195000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6e52d885-ab7d-4bed-9489-e62fc5a2911a",
      code: 196,
      name: "Chemini",
      postalCode: "196000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "120a8af5-5749-4804-956a-a5f270168af2",
      code: 197,
      name: "Darguina",
      postalCode: "197000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "61ca4682-dd5a-445a-b611-a41940c47221",
      code: 198,
      name: "Dra El Caid",
      postalCode: "198000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "93cd279e-b1ac-4bf2-ad38-724f3ddaa986",
      code: 199,
      name: "Leflaye",
      postalCode: "199000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d50f9a0a-7f5a-466f-ba92-0c48c1b85a99",
      code: 200,
      name: "El Kseur",
      postalCode: "200000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d1dda21a-faa8-4627-8af9-f809fc76edc0",
      code: 201,
      name: "Fenaia Il Maten",
      postalCode: "201000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ca429526-1714-49f6-ab59-5aaffc25fc29",
      code: 202,
      name: "Feraoun",
      postalCode: "202000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ee54755b-fa20-4bfc-98b5-eb2da1c6e1d0",
      code: 203,
      name: "Ouzellaguen",
      postalCode: "203000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c08a0789-a464-4910-870a-4b7bb5cf113f",
      code: 204,
      name: "Ighil-Ali",
      postalCode: "204000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f8be9a73-9af7-4dda-b2d3-59d7eeac58ed",
      code: 205,
      name: "Ighram",
      postalCode: "205000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "92b79288-2250-43d2-a225-81204885da94",
      code: 206,
      name: "Kendira",
      postalCode: "206000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6e77e44c-5e48-45d2-836a-ddda11feaae6",
      code: 207,
      name: "Kherrata",
      postalCode: "207000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6733c856-e804-422c-ae0e-45cb070f841f",
      code: 208,
      name: "M'cisna",
      postalCode: "208000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7f6a348f-e4ce-41b5-9f5d-03cceb5c4dc6",
      code: 209,
      name: "Melbou",
      postalCode: "209000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "40b386f5-c352-473f-abbd-cc0337a743aa",
      code: 210,
      name: "Oued Ghir",
      postalCode: "210000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c052d1d0-f1d0-486d-a7d1-5da923f20b7c",
      code: 211,
      name: "Seddouk",
      postalCode: "211000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3afe3204-3851-4667-beeb-94482f658fb6",
      code: 212,
      name: "Sidi Ayad",
      postalCode: "212000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "16a639ed-ef03-4716-b966-11c2d5d12f6a",
      code: 213,
      name: "Sidi-Aich",
      postalCode: "213000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "69999bdf-a404-4329-ad6e-87f8ca5c433b",
      code: 214,
      name: "Smaoun",
      postalCode: "214000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d37d5514-3da5-458b-b18c-2899d9685a21",
      code: 215,
      name: "Souk El Tenine",
      postalCode: "215000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "12116dd6-a258-4009-aada-aaf07d1f890b",
      code: 216,
      name: "Souk Oufella",
      postalCode: "216000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "62a012c8-f3b4-4390-a2af-1edc7d69ad6f",
      code: 217,
      name: "Tala Hamza",
      postalCode: "217000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c374198d-4e96-4878-917a-ccb653b06e2f",
      code: 218,
      name: "Tamokra",
      postalCode: "218000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "388685ff-bbe6-4fff-a869-be80103bfefd",
      code: 219,
      name: "Tamridjet",
      postalCode: "219000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3f3a1a6f-cff3-4f78-a2dc-b5b5aa5751da",
      code: 220,
      name: "Taourit Ighil",
      postalCode: "220000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ea85b215-6276-47d8-b47a-23bcbd896c6a",
      code: 221,
      name: "Taskriout",
      postalCode: "221000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f725deee-c076-4a42-aba3-16e6f1661793",
      code: 222,
      name: "Tazmalt",
      postalCode: "222000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c886da60-9c55-4b4c-bf7f-e776b2df417e",
      code: 223,
      name: "Tibane",
      postalCode: "223000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "31287f86-0513-4233-94cb-c99d88be5518",
      code: 224,
      name: "Tichy",
      postalCode: "224000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a732eb12-ac57-4c3b-8a12-106a17cf1b47",
      code: 225,
      name: "Tifra",
      postalCode: "225000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b8c0dd06-b04c-4a18-a397-b97b5921a2de",
      code: 226,
      name: "Timezrit",
      postalCode: "226000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "51c46222-d00a-417a-b9ef-dfe8391e1c0c",
      code: 227,
      name: "Tinebdar",
      postalCode: "227000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f59e4239-a76d-4387-973c-89f6afd829f4",
      code: 228,
      name: "Tizi-N'berber",
      postalCode: "228000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "44887e63-0534-45f8-b18a-9f77e0356e96",
      code: 229,
      name: "Toudja",
      postalCode: "229000",
      level: "commune",
      parentId: "295585ad-4cf4-4b7e-b276-9bb62d019749",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "72bfc682-3a31-4f11-aa05-c0dbcbded326",
      code: 230,
      name: "Ain Naga",
      postalCode: "230000",
      level: "commune",
      parentId: "796e70df-1102-44da-9582-2da66ead2ba6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9491a98a-ebe4-4a86-acab-6eb7eec18816",
      code: 231,
      name: "Ain Zaatout",
      postalCode: "231000",
      level: "commune",
      parentId: "796e70df-1102-44da-9582-2da66ead2ba6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9c2d90b7-e126-4d6f-9058-a7d8d4908729",
      code: 232,
      name: "Besbes",
      postalCode: "232000",
      level: "commune",
      parentId: "0f2dab00-094c-412c-a7d0-ebd0268d3d3c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b68fb438-5998-491d-9aed-5588cc7f7d1d",
      code: 233,
      name: "Biskra",
      postalCode: "233000",
      level: "commune",
      parentId: "796e70df-1102-44da-9582-2da66ead2ba6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "73e4a2f8-deae-4bb6-834e-bb9249a49224",
      code: 234,
      name: "Bordj Ben Azzouz",
      postalCode: "234000",
      level: "commune",
      parentId: "796e70df-1102-44da-9582-2da66ead2ba6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "97e3ef29-f469-4a6c-b626-1c03593a175d",
      code: 235,
      name: "Bouchakroun",
      postalCode: "235000",
      level: "commune",
      parentId: "796e70df-1102-44da-9582-2da66ead2ba6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1b0d9b05-d437-474b-b214-47f56f345b38",
      code: 236,
      name: "Branis",
      postalCode: "236000",
      level: "commune",
      parentId: "796e70df-1102-44da-9582-2da66ead2ba6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b0d3eb9a-bfc9-4aea-bba9-3526dd85b10c",
      code: 237,
      name: "Chaiba",
      postalCode: "237000",
      level: "commune",
      parentId: "0f2dab00-094c-412c-a7d0-ebd0268d3d3c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e4c02d48-8a04-4127-81e7-c2f8e8909f16",
      code: 238,
      name: "Chetma",
      postalCode: "238000",
      level: "commune",
      parentId: "796e70df-1102-44da-9582-2da66ead2ba6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "141f37d0-f0c8-4de8-9bb4-8800cc74749d",
      code: 239,
      name: "Djemorah",
      postalCode: "239000",
      level: "commune",
      parentId: "796e70df-1102-44da-9582-2da66ead2ba6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8bc9b68b-22b0-48ba-9ed6-59230a7af1d7",
      code: 240,
      name: "Doucen",
      postalCode: "240000",
      level: "commune",
      parentId: "0f2dab00-094c-412c-a7d0-ebd0268d3d3c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3937ef8d-963f-4584-8e98-fc911759bef0",
      code: 241,
      name: "El Feidh",
      postalCode: "241000",
      level: "commune",
      parentId: "796e70df-1102-44da-9582-2da66ead2ba6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "65d536a7-1276-4681-a6ff-49df423ac44d",
      code: 242,
      name: "El Ghrous",
      postalCode: "242000",
      level: "commune",
      parentId: "796e70df-1102-44da-9582-2da66ead2ba6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ded1b1c8-10b5-47dc-8a7c-c8b752cdab3e",
      code: 243,
      name: "El Hadjab",
      postalCode: "243000",
      level: "commune",
      parentId: "796e70df-1102-44da-9582-2da66ead2ba6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d2a0ea8e-167b-4e2f-8781-c18dc4a5485f",
      code: 244,
      name: "El Haouch",
      postalCode: "244000",
      level: "commune",
      parentId: "796e70df-1102-44da-9582-2da66ead2ba6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "37d0aade-3b27-4ad7-ae08-1b75cbeb6577",
      code: 245,
      name: "El Kantara",
      postalCode: "245000",
      level: "commune",
      parentId: "796e70df-1102-44da-9582-2da66ead2ba6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7e05fb5d-781b-423a-96fc-c699ffdc4c8c",
      code: 246,
      name: "El Outaya",
      postalCode: "246000",
      level: "commune",
      parentId: "796e70df-1102-44da-9582-2da66ead2ba6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b82240e6-bb6d-48e0-8f6f-9f609f978946",
      code: 247,
      name: "Foughala",
      postalCode: "247000",
      level: "commune",
      parentId: "796e70df-1102-44da-9582-2da66ead2ba6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9067092f-db70-45b2-8413-2432751e7110",
      code: 248,
      name: "Khenguet Sidi Nadji",
      postalCode: "248000",
      level: "commune",
      parentId: "796e70df-1102-44da-9582-2da66ead2ba6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3ff23d85-b5aa-4e22-851d-0a767bfe3638",
      code: 249,
      name: "Lichana",
      postalCode: "249000",
      level: "commune",
      parentId: "796e70df-1102-44da-9582-2da66ead2ba6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "820efd36-3218-47c9-9d8c-aedf1d6c01ce",
      code: 250,
      name: "Lioua",
      postalCode: "250000",
      level: "commune",
      parentId: "796e70df-1102-44da-9582-2da66ead2ba6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f67ae22d-eba3-49b5-95b8-67c2c53e1eb2",
      code: 251,
      name: "M'chouneche",
      postalCode: "251000",
      level: "commune",
      parentId: "796e70df-1102-44da-9582-2da66ead2ba6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "875c3baa-1a13-4d85-9bc7-44a004625393",
      code: 252,
      name: "Mekhadma",
      postalCode: "252000",
      level: "commune",
      parentId: "796e70df-1102-44da-9582-2da66ead2ba6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "50f5fd44-e9d6-4de6-acef-80b0117a1082",
      code: 253,
      name: "Meziraa",
      postalCode: "253000",
      level: "commune",
      parentId: "796e70df-1102-44da-9582-2da66ead2ba6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d5276558-ff2b-4146-b6b5-3d50ddaa3580",
      code: 254,
      name: "M'lili",
      postalCode: "254000",
      level: "commune",
      parentId: "796e70df-1102-44da-9582-2da66ead2ba6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f65f6d03-b3de-4dbb-ad77-c9f0f6a5f041",
      code: 255,
      name: "Ouled Djellal",
      postalCode: "255000",
      level: "commune",
      parentId: "0f2dab00-094c-412c-a7d0-ebd0268d3d3c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "15d41e6b-fa6d-4f7e-9076-ee712714226a",
      code: 256,
      name: "Oumache",
      postalCode: "256000",
      level: "commune",
      parentId: "796e70df-1102-44da-9582-2da66ead2ba6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "de09cf47-bc0e-47ab-94f0-587e5130a675",
      code: 257,
      name: "Ourlal",
      postalCode: "257000",
      level: "commune",
      parentId: "796e70df-1102-44da-9582-2da66ead2ba6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "aff09f34-2d21-460f-a4e3-b7c7ca08d9f4",
      code: 258,
      name: "Ras El Miad",
      postalCode: "258000",
      level: "commune",
      parentId: "0f2dab00-094c-412c-a7d0-ebd0268d3d3c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f1828ccf-5f14-4cf4-8158-4d0c02b18af9",
      code: 259,
      name: "Sidi Khaled",
      postalCode: "259000",
      level: "commune",
      parentId: "0f2dab00-094c-412c-a7d0-ebd0268d3d3c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "82de2232-2543-45a1-85c3-7e82c81e8ece",
      code: 260,
      name: "Sidi Okba",
      postalCode: "260000",
      level: "commune",
      parentId: "796e70df-1102-44da-9582-2da66ead2ba6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f48544d0-8d0d-4362-9f2a-fff1f8991e9a",
      code: 261,
      name: "Tolga",
      postalCode: "261000",
      level: "commune",
      parentId: "796e70df-1102-44da-9582-2da66ead2ba6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f676bc07-7656-4479-858c-e38b29db3f41",
      code: 262,
      name: "Zeribet El Oued",
      postalCode: "262000",
      level: "commune",
      parentId: "796e70df-1102-44da-9582-2da66ead2ba6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2712e0f6-787d-4ee6-9eae-d843c3888985",
      code: 263,
      name: "Abadla",
      postalCode: "263000",
      level: "commune",
      parentId: "e740c188-2bbc-4206-8999-302b17dc0e4b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "fbd1d735-fbd9-47f1-a785-dc0fcaf37e5f",
      code: 264,
      name: "Bechar",
      postalCode: "264000",
      level: "commune",
      parentId: "e740c188-2bbc-4206-8999-302b17dc0e4b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e5dccfc2-d778-48a8-9295-0570f16766e4",
      code: 265,
      name: "Beni-Abbes",
      postalCode: "265000",
      level: "commune",
      parentId: "ba12c65c-de9e-4f30-a449-6ba0b27dd7d7",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f684e81f-d80b-473e-8f2f-732f44a0eec6",
      code: 266,
      name: "Beni-Ikhlef",
      postalCode: "266000",
      level: "commune",
      parentId: "ba12c65c-de9e-4f30-a449-6ba0b27dd7d7",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "90ffa0c0-a045-4a93-9b6d-fcc35be02c23",
      code: 267,
      name: "Beni-Ounif",
      postalCode: "267000",
      level: "commune",
      parentId: "e740c188-2bbc-4206-8999-302b17dc0e4b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "740b44fa-b240-45ab-a576-1d6230306633",
      code: 268,
      name: "Boukais",
      postalCode: "268000",
      level: "commune",
      parentId: "e740c188-2bbc-4206-8999-302b17dc0e4b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "063fd029-7155-458c-9981-c61a28f10783",
      code: 269,
      name: "El Ouata",
      postalCode: "269000",
      level: "commune",
      parentId: "ba12c65c-de9e-4f30-a449-6ba0b27dd7d7",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5211ad4a-a21d-4840-9370-81f1b1ffbd62",
      code: 270,
      name: "Erg-Ferradj",
      postalCode: "270000",
      level: "commune",
      parentId: "e740c188-2bbc-4206-8999-302b17dc0e4b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "63ca947f-cf7d-48aa-bc99-783ef9152211",
      code: 271,
      name: "Igli",
      postalCode: "271000",
      level: "commune",
      parentId: "ba12c65c-de9e-4f30-a449-6ba0b27dd7d7",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f6d90bf8-dc73-449e-89e0-09149c914122",
      code: 272,
      name: "Kenadsa",
      postalCode: "272000",
      level: "commune",
      parentId: "e740c188-2bbc-4206-8999-302b17dc0e4b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7b3826f7-49b6-4cfa-9242-d8634d31b730",
      code: 273,
      name: "Kerzaz",
      postalCode: "273000",
      level: "commune",
      parentId: "ba12c65c-de9e-4f30-a449-6ba0b27dd7d7",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2d6789e4-30ad-42ad-8844-a958c7a1d0ec",
      code: 274,
      name: "Ksabi",
      postalCode: "274000",
      level: "commune",
      parentId: "ba12c65c-de9e-4f30-a449-6ba0b27dd7d7",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0136e51f-f1c3-4d05-baf9-43307d3e6fb6",
      code: 275,
      name: "Lahmar",
      postalCode: "275000",
      level: "commune",
      parentId: "e740c188-2bbc-4206-8999-302b17dc0e4b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "17c7eee9-1fe2-44c0-baed-4f42ba02a209",
      code: 276,
      name: "Machraa-Houari-Boumediene",
      postalCode: "276000",
      level: "commune",
      parentId: "e740c188-2bbc-4206-8999-302b17dc0e4b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "810d660f-1ce3-4129-8971-553ddf18c8f1",
      code: 277,
      name: "Meridja",
      postalCode: "277000",
      level: "commune",
      parentId: "e740c188-2bbc-4206-8999-302b17dc0e4b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c541c47c-b24e-4552-b512-c38b883bc4c3",
      code: 278,
      name: "Mogheul",
      postalCode: "278000",
      level: "commune",
      parentId: "e740c188-2bbc-4206-8999-302b17dc0e4b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "44e629de-7ae6-4125-8ca6-2f7e3f772af2",
      code: 279,
      name: "Ouled-Khodeir",
      postalCode: "279000",
      level: "commune",
      parentId: "ba12c65c-de9e-4f30-a449-6ba0b27dd7d7",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c98bb44e-bb3e-4621-a285-008875b47323",
      code: 280,
      name: "Tabelbala",
      postalCode: "280000",
      level: "commune",
      parentId: "e740c188-2bbc-4206-8999-302b17dc0e4b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7f3f10ef-15f5-4f05-9844-db00999d9c8b",
      code: 281,
      name: "Taghit",
      postalCode: "281000",
      level: "commune",
      parentId: "e740c188-2bbc-4206-8999-302b17dc0e4b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "409a0997-b0d5-4f6c-910d-60bbc064c3ee",
      code: 282,
      name: "Tamtert",
      postalCode: "282000",
      level: "commune",
      parentId: "ba12c65c-de9e-4f30-a449-6ba0b27dd7d7",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f94e277e-ad61-4005-bcd6-c405a376f934",
      code: 283,
      name: "Timoudi",
      postalCode: "283000",
      level: "commune",
      parentId: "ba12c65c-de9e-4f30-a449-6ba0b27dd7d7",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d36a5648-d4e2-494a-9c23-8d4b9edb3057",
      code: 284,
      name: "Ain Romana",
      postalCode: "284000",
      level: "commune",
      parentId: "a7e764cf-e9ca-4c1f-8232-89852d102aec",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5f1db7bb-5d56-4a4e-9357-914be6495358",
      code: 285,
      name: "Beni Mered",
      postalCode: "285000",
      level: "commune",
      parentId: "a7e764cf-e9ca-4c1f-8232-89852d102aec",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2c44eee8-ff68-4494-ba68-47164d0e4fdc",
      code: 286,
      name: "Beni-Tamou",
      postalCode: "286000",
      level: "commune",
      parentId: "a7e764cf-e9ca-4c1f-8232-89852d102aec",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c733fc61-3f6b-4782-9fef-672d18647b0f",
      code: 287,
      name: "Benkhelil",
      postalCode: "287000",
      level: "commune",
      parentId: "a7e764cf-e9ca-4c1f-8232-89852d102aec",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d3866552-a62a-46e6-a6b2-8f9eb0c0249d",
      code: 288,
      name: "Blida",
      postalCode: "288000",
      level: "commune",
      parentId: "a7e764cf-e9ca-4c1f-8232-89852d102aec",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "83cfe6cf-5379-48e5-b604-c00f3820263d",
      code: 289,
      name: "Bouarfa",
      postalCode: "289000",
      level: "commune",
      parentId: "a7e764cf-e9ca-4c1f-8232-89852d102aec",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "860a1bdd-3104-4bae-9317-d7a69e129a85",
      code: 290,
      name: "Boufarik",
      postalCode: "290000",
      level: "commune",
      parentId: "a7e764cf-e9ca-4c1f-8232-89852d102aec",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a4246326-eb05-4cc1-b7c3-2ce76949f3e8",
      code: 291,
      name: "Bougara",
      postalCode: "291000",
      level: "commune",
      parentId: "a7e764cf-e9ca-4c1f-8232-89852d102aec",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6460f5c7-299f-4fa7-bcd3-6c539eba39a8",
      code: 292,
      name: "Bouinan",
      postalCode: "292000",
      level: "commune",
      parentId: "a7e764cf-e9ca-4c1f-8232-89852d102aec",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "bb2a3701-8620-4a01-a4fe-3715ec8d72df",
      code: 293,
      name: "Chebli",
      postalCode: "293000",
      level: "commune",
      parentId: "a7e764cf-e9ca-4c1f-8232-89852d102aec",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "364bd59d-2173-44fd-9ade-44527d4b87ed",
      code: 294,
      name: "Chiffa",
      postalCode: "294000",
      level: "commune",
      parentId: "a7e764cf-e9ca-4c1f-8232-89852d102aec",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2ed440e3-e266-4471-a853-0c3b2b1d27d2",
      code: 295,
      name: "Chrea",
      postalCode: "295000",
      level: "commune",
      parentId: "a7e764cf-e9ca-4c1f-8232-89852d102aec",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "aed06435-462a-475d-82f5-63bf39d2fafa",
      code: 296,
      name: "Djebabra",
      postalCode: "296000",
      level: "commune",
      parentId: "a7e764cf-e9ca-4c1f-8232-89852d102aec",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7beb4d37-592f-48f9-ad54-a7b2835bc724",
      code: 297,
      name: "El-Affroun",
      postalCode: "297000",
      level: "commune",
      parentId: "a7e764cf-e9ca-4c1f-8232-89852d102aec",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "cbdf9adc-a15e-497c-86fe-5c0a8ddaf7fb",
      code: 298,
      name: "Guerrouaou",
      postalCode: "298000",
      level: "commune",
      parentId: "a7e764cf-e9ca-4c1f-8232-89852d102aec",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c7c251f6-d64b-4bd0-9227-8b9a1aabcf43",
      code: 299,
      name: "Hammam Elouane",
      postalCode: "299000",
      level: "commune",
      parentId: "a7e764cf-e9ca-4c1f-8232-89852d102aec",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "eb48a3ef-c0c7-452b-9a48-4b450bab21ca",
      code: 300,
      name: "Larbaa",
      postalCode: "300000",
      level: "commune",
      parentId: "a7e764cf-e9ca-4c1f-8232-89852d102aec",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1d70c1c9-1bed-46c8-977a-bdd64915793f",
      code: 301,
      name: "Meftah",
      postalCode: "301000",
      level: "commune",
      parentId: "a7e764cf-e9ca-4c1f-8232-89852d102aec",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ca13ad49-0831-4129-9667-e7fc0163407b",
      code: 302,
      name: "Mouzaia",
      postalCode: "302000",
      level: "commune",
      parentId: "a7e764cf-e9ca-4c1f-8232-89852d102aec",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7e8c6e89-e161-4257-8e90-de24023a247f",
      code: 303,
      name: "Oued  Djer",
      postalCode: "303000",
      level: "commune",
      parentId: "a7e764cf-e9ca-4c1f-8232-89852d102aec",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ed9c7e3d-c24b-4098-b904-88005082563d",
      code: 304,
      name: "Oued El Alleug",
      postalCode: "304000",
      level: "commune",
      parentId: "a7e764cf-e9ca-4c1f-8232-89852d102aec",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "72675e4c-d871-4a8b-8d39-746c8e3d7254",
      code: 305,
      name: "Ouled Slama",
      postalCode: "305000",
      level: "commune",
      parentId: "a7e764cf-e9ca-4c1f-8232-89852d102aec",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "08a1631f-1949-462b-94a6-01f212d869e1",
      code: 306,
      name: "Ouled Yaich",
      postalCode: "306000",
      level: "commune",
      parentId: "a7e764cf-e9ca-4c1f-8232-89852d102aec",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6b9536c6-9715-4022-9ad9-e2aa8a181f74",
      code: 307,
      name: "Souhane",
      postalCode: "307000",
      level: "commune",
      parentId: "a7e764cf-e9ca-4c1f-8232-89852d102aec",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e2df13dc-1635-4226-a6d1-77e6cd0ab536",
      code: 308,
      name: "Soumaa",
      postalCode: "308000",
      level: "commune",
      parentId: "a7e764cf-e9ca-4c1f-8232-89852d102aec",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "68f4ae1c-56ba-4072-a85a-6ecb295cdaaa",
      code: 309,
      name: "Aghbalou",
      postalCode: "309000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6fb99ff8-cebf-4ff4-ab28-8e1e6111ff58",
      code: 310,
      name: "Ahl El Ksar",
      postalCode: "310000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6177ae10-cd9b-4d65-9711-3aa1d263c373",
      code: 311,
      name: "Ain El Hadjar",
      postalCode: "311000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4d6652b1-5dca-461f-bb20-e12e7a015118",
      code: 312,
      name: "Ain Laloui",
      postalCode: "312000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "540ed93f-4b1b-47cb-8f11-0535ce439949",
      code: 313,
      name: "Ain Turk",
      postalCode: "313000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "62741818-2e2b-4043-9838-646be5dfae8f",
      code: 314,
      name: "Ain-Bessem",
      postalCode: "314000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f2571236-f041-4afc-baa9-b731c9fa65d4",
      code: 315,
      name: "Ait Laaziz",
      postalCode: "315000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a738fc1b-86dd-4a70-a005-09ead7f5187e",
      code: 316,
      name: "Aomar",
      postalCode: "316000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a4bab5b1-7e6e-479d-b9a7-548a8061b3a6",
      code: 317,
      name: "Bechloul",
      postalCode: "317000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "50f27247-b73e-41dc-8892-824c5be993a5",
      code: 318,
      name: "Bir Ghbalou",
      postalCode: "318000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6cb8f239-eb5b-4b21-bb50-90b6c5227326",
      code: 319,
      name: "Bordj Okhriss",
      postalCode: "319000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9a9da4d5-e695-49af-b34a-ad0b2f726bfb",
      code: 320,
      name: "Bouderbala",
      postalCode: "320000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "200547e7-e8f0-44e0-8953-cd89cbd76ca9",
      code: 321,
      name: "Bouira",
      postalCode: "321000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "389fa2b8-c411-4e1b-a45e-b60285bf960b",
      code: 322,
      name: "Boukram",
      postalCode: "322000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8c4751ef-24f0-45db-bf06-3c52e861980f",
      code: 323,
      name: "Chorfa",
      postalCode: "323000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f6c725a7-2333-42e5-956b-824ce2477c1d",
      code: 324,
      name: "Dechmia",
      postalCode: "324000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6f78eebb-2011-4ad9-acfa-e9be8d81d17c",
      code: 325,
      name: "Dirah",
      postalCode: "325000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2d701837-60cf-4a9c-93d2-f0a3ee1ded1e",
      code: 326,
      name: "Djebahia",
      postalCode: "326000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0dcf2773-4dc9-468d-aa7a-b98d382a7fcc",
      code: 327,
      name: "El Adjiba",
      postalCode: "327000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "44575b5a-b66b-4929-adf3-df46054bd5ce",
      code: 328,
      name: "El Asnam",
      postalCode: "328000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ace40929-9c9f-4c78-92ec-7b323edf11e5",
      code: 329,
      name: "El Hachimia",
      postalCode: "329000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "55af365d-939c-4375-8614-8290997d9252",
      code: 330,
      name: "El Khabouzia",
      postalCode: "330000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4fef306d-6fee-40ad-ae13-47f544907456",
      code: 331,
      name: "El-Hakimia",
      postalCode: "331000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "04ef3825-eb71-4fb1-aec6-0851fe9d9439",
      code: 332,
      name: "El-Mokrani",
      postalCode: "332000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8a6ff68e-d773-4d94-a3e2-5a8082698484",
      code: 333,
      name: "Guerrouma",
      postalCode: "333000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9bb00777-c251-4f0d-9ae9-05ca959a14ae",
      code: 334,
      name: "Hadjera Zerga",
      postalCode: "334000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0dde4967-ba92-4542-9a1e-fa36c7db26ca",
      code: 335,
      name: "Haizer",
      postalCode: "335000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1f787a6e-baf6-4bbc-b935-a8d9f2b347e3",
      code: 336,
      name: "Hanif",
      postalCode: "336000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8e001eca-1a69-4183-95bf-4bfb8dcbce46",
      code: 337,
      name: "Kadiria",
      postalCode: "337000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f8539881-4462-4610-bf40-c54a1dbb3ec4",
      code: 338,
      name: "Lakhdaria",
      postalCode: "338000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f88e2ff0-631e-4109-9309-211b4e5cc745",
      code: 339,
      name: "M Chedallah",
      postalCode: "339000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d5ae8fea-8539-45d1-957a-801fbc8fb68f",
      code: 340,
      name: "Maala",
      postalCode: "340000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b0ccd655-88d1-4744-948b-21e4d9d1e59b",
      code: 341,
      name: "Maamora",
      postalCode: "341000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "fda6f3b7-057b-4b48-9a6f-8336dbfadb21",
      code: 342,
      name: "Mezdour",
      postalCode: "342000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "58f31412-0288-4890-a567-de548f3ec459",
      code: 343,
      name: "Oued El Berdi",
      postalCode: "343000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "70a4711f-29e1-4b2b-8300-72d0a83a694a",
      code: 344,
      name: "Ouled Rached",
      postalCode: "344000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "39933a9f-e41d-40b9-89a2-832fc0eda6af",
      code: 345,
      name: "Raouraoua",
      postalCode: "345000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "deec885e-547e-4681-8d60-488a0f289d8b",
      code: 346,
      name: "Ridane",
      postalCode: "346000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2e13ba5a-cf90-435c-8f58-897eb054fef5",
      code: 347,
      name: "Saharidj",
      postalCode: "347000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9edc228e-14aa-46ad-ba26-8aa5410c35f4",
      code: 348,
      name: "Souk El Khemis",
      postalCode: "348000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "be896a97-dbc1-41aa-95c7-6242b3b18726",
      code: 349,
      name: "Sour El Ghozlane",
      postalCode: "349000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5354b782-3ae3-4769-89d2-71ef2207402a",
      code: 350,
      name: "Taghzout",
      postalCode: "350000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "dfeca2e5-e8e4-44c9-a5cb-a6b0dae2865c",
      code: 351,
      name: "Taguedite",
      postalCode: "351000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2552fc56-f620-4d00-9673-48bb1739f790",
      code: 352,
      name: "Ath Mansour",
      postalCode: "352000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "19fb8bc6-24f1-45c4-b0e6-d78f2062d585",
      code: 353,
      name: "Z'barbar (El Isseri )",
      postalCode: "353000",
      level: "commune",
      parentId: "a1f0229c-4f34-40aa-9238-fadde6757cba",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f57f2bb0-bdcc-45cb-a609-9b6a9eddfa8a",
      code: 354,
      name: "Abelsa",
      postalCode: "354000",
      level: "commune",
      parentId: "38560f06-e049-4fd2-9664-a655e552b517",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2623cfcb-78da-43bc-9733-0953b1c2a896",
      code: 355,
      name: "Ain Amguel",
      postalCode: "355000",
      level: "commune",
      parentId: "38560f06-e049-4fd2-9664-a655e552b517",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5d7f6ee0-fd28-4b04-92b2-c6012b66e737",
      code: 356,
      name: "Ain Guezzam",
      postalCode: "356000",
      level: "commune",
      parentId: "f30136dc-3012-4ac7-912c-33eab37393a9",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: false,
      },
    },
    {
      id: "81622af1-2248-4042-a054-b9059b38572a",
      code: 357,
      name: "Ain Salah",
      postalCode: "357000",
      level: "commune",
      parentId: "7c752560-8412-4e11-8c75-ed7cd9c22be2",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: false,
      },
    },
    {
      id: "e08d1a13-40c5-42ad-8902-be8d4c016a3e",
      code: 358,
      name: "Foggaret Ezzoua",
      postalCode: "358000",
      level: "commune",
      parentId: "7c752560-8412-4e11-8c75-ed7cd9c22be2",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: false,
      },
    },
    {
      id: "70380bfe-f435-437b-a623-b0a53cfaecb4",
      code: 359,
      name: "Idles",
      postalCode: "359000",
      level: "commune",
      parentId: "38560f06-e049-4fd2-9664-a655e552b517",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c19f1edd-c294-4323-a3f6-5983c285bf4f",
      code: 360,
      name: "Inghar",
      postalCode: "360000",
      level: "commune",
      parentId: "7c752560-8412-4e11-8c75-ed7cd9c22be2",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: false,
      },
    },
    {
      id: "1ef7801a-95bf-442f-8530-5481d6c1b96e",
      code: 361,
      name: "Tamanrasset",
      postalCode: "361000",
      level: "commune",
      parentId: "38560f06-e049-4fd2-9664-a655e552b517",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "48e266da-4e42-48b0-b8ea-87aae5fecd53",
      code: 362,
      name: "Tazrouk",
      postalCode: "362000",
      level: "commune",
      parentId: "38560f06-e049-4fd2-9664-a655e552b517",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3d6a326d-f46d-4a24-b3b6-937df621e0bd",
      code: 363,
      name: "Tin Zouatine",
      postalCode: "363000",
      level: "commune",
      parentId: "f30136dc-3012-4ac7-912c-33eab37393a9",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: false,
      },
    },
    {
      id: "0bcf48b9-02f4-4ebc-aa3c-f6a4e504e1da",
      code: 364,
      name: "Ain Zerga",
      postalCode: "364000",
      level: "commune",
      parentId: "5afdfab6-e505-4691-abc7-5e8bd79afad5",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "262d2d99-8285-4b1f-9ab2-5b835178040e",
      code: 365,
      name: "Bedjene",
      postalCode: "365000",
      level: "commune",
      parentId: "5afdfab6-e505-4691-abc7-5e8bd79afad5",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c52f77a5-1af3-4ef2-830d-00eac292308a",
      code: 366,
      name: "Bekkaria",
      postalCode: "366000",
      level: "commune",
      parentId: "5afdfab6-e505-4691-abc7-5e8bd79afad5",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "afa5f187-ef1a-46d6-bf36-275dab96dcef",
      code: 367,
      name: "Bir Dheheb",
      postalCode: "367000",
      level: "commune",
      parentId: "5afdfab6-e505-4691-abc7-5e8bd79afad5",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4dee2a3b-66c5-486f-b1a3-8686b35cfa81",
      code: 368,
      name: "Bir Mokkadem",
      postalCode: "368000",
      level: "commune",
      parentId: "5afdfab6-e505-4691-abc7-5e8bd79afad5",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "95ef0717-3a3f-4d9f-a6e7-f693dd1b4a7e",
      code: 369,
      name: "Bir-El-Ater",
      postalCode: "369000",
      level: "commune",
      parentId: "5afdfab6-e505-4691-abc7-5e8bd79afad5",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b61b992a-88a4-43e7-95e8-54c20cf5ede9",
      code: 370,
      name: "Boukhadra",
      postalCode: "370000",
      level: "commune",
      parentId: "5afdfab6-e505-4691-abc7-5e8bd79afad5",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "bfa2968c-f257-42c3-a765-b309864dc3ed",
      code: 371,
      name: "Boulhaf Dyr",
      postalCode: "371000",
      level: "commune",
      parentId: "5afdfab6-e505-4691-abc7-5e8bd79afad5",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "19f1ba69-9fcb-415c-8aef-d0ee77bb3424",
      code: 372,
      name: "Cheria",
      postalCode: "372000",
      level: "commune",
      parentId: "5afdfab6-e505-4691-abc7-5e8bd79afad5",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "bf9c3595-3479-45b0-87f4-ef69761b314f",
      code: 373,
      name: "El Kouif",
      postalCode: "373000",
      level: "commune",
      parentId: "5afdfab6-e505-4691-abc7-5e8bd79afad5",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "669ad8bb-28ae-4597-9055-fa91aad5061c",
      code: 374,
      name: "El Malabiod",
      postalCode: "374000",
      level: "commune",
      parentId: "5afdfab6-e505-4691-abc7-5e8bd79afad5",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4a3d7cfe-4b9f-4209-96e0-8280018227df",
      code: 375,
      name: "El Meridj",
      postalCode: "375000",
      level: "commune",
      parentId: "5afdfab6-e505-4691-abc7-5e8bd79afad5",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9471af94-f9f7-4a5c-919f-b497b53f1d5a",
      code: 376,
      name: "El Mezeraa",
      postalCode: "376000",
      level: "commune",
      parentId: "5afdfab6-e505-4691-abc7-5e8bd79afad5",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0d643bd0-070e-4f57-bc90-afbec2053c48",
      code: 377,
      name: "El Ogla",
      postalCode: "377000",
      level: "commune",
      parentId: "5afdfab6-e505-4691-abc7-5e8bd79afad5",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3e1a6f65-385e-4b7c-ae88-0ba3e6fbef22",
      code: 378,
      name: "El Ogla El Malha",
      postalCode: "378000",
      level: "commune",
      parentId: "5afdfab6-e505-4691-abc7-5e8bd79afad5",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5fe11740-cc14-4987-b44e-9ea860851bda",
      code: 379,
      name: "El-Aouinet",
      postalCode: "379000",
      level: "commune",
      parentId: "5afdfab6-e505-4691-abc7-5e8bd79afad5",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "467eb646-4dcc-4d00-976c-5c2af2d674c3",
      code: 380,
      name: "El-Houidjbet",
      postalCode: "380000",
      level: "commune",
      parentId: "5afdfab6-e505-4691-abc7-5e8bd79afad5",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "91ac38fd-147e-42e0-b5ce-dedf226e7c0d",
      code: 381,
      name: "Ferkane",
      postalCode: "381000",
      level: "commune",
      parentId: "5afdfab6-e505-4691-abc7-5e8bd79afad5",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "47d7ef41-31b0-4760-9d6c-36ddf618ae02",
      code: 382,
      name: "Guorriguer",
      postalCode: "382000",
      level: "commune",
      parentId: "5afdfab6-e505-4691-abc7-5e8bd79afad5",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1a538787-1f22-4637-a458-30f844ee2309",
      code: 383,
      name: "Hammamet",
      postalCode: "383000",
      level: "commune",
      parentId: "5afdfab6-e505-4691-abc7-5e8bd79afad5",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ee305435-78c5-4f82-966e-681ec7645494",
      code: 384,
      name: "Morsott",
      postalCode: "384000",
      level: "commune",
      parentId: "5afdfab6-e505-4691-abc7-5e8bd79afad5",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "df2486d2-53d6-4489-aeee-00cdee010751",
      code: 385,
      name: "Negrine",
      postalCode: "385000",
      level: "commune",
      parentId: "5afdfab6-e505-4691-abc7-5e8bd79afad5",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b86dc46b-a9b2-4da8-8336-5c17047a7834",
      code: 386,
      name: "Ouenza",
      postalCode: "386000",
      level: "commune",
      parentId: "5afdfab6-e505-4691-abc7-5e8bd79afad5",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a05cb28c-98eb-47e6-b0c3-5ee7f3f7d34e",
      code: 387,
      name: "Oum Ali",
      postalCode: "387000",
      level: "commune",
      parentId: "5afdfab6-e505-4691-abc7-5e8bd79afad5",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "20d34425-f650-4b04-8eb9-7c017f5eae7c",
      code: 388,
      name: "Saf Saf El Ouesra",
      postalCode: "388000",
      level: "commune",
      parentId: "5afdfab6-e505-4691-abc7-5e8bd79afad5",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6d5f9bc8-08a7-4f86-be3e-c65bac4a369e",
      code: 389,
      name: "Stah Guentis",
      postalCode: "389000",
      level: "commune",
      parentId: "5afdfab6-e505-4691-abc7-5e8bd79afad5",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e944ad9c-f555-4b6c-a6e2-ca17d95df2cc",
      code: 390,
      name: "Tebessa",
      postalCode: "390000",
      level: "commune",
      parentId: "5afdfab6-e505-4691-abc7-5e8bd79afad5",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b4b4fbd3-532f-41ff-ba56-ec447d002d59",
      code: 391,
      name: "Telidjen",
      postalCode: "391000",
      level: "commune",
      parentId: "5afdfab6-e505-4691-abc7-5e8bd79afad5",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "72832049-1813-4bdf-8664-d8360dd83bc4",
      code: 392,
      name: "Ain Fetah",
      postalCode: "392000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e81f5b39-ef03-4ae8-b785-95a31c6dca6b",
      code: 393,
      name: "Ain Fezza",
      postalCode: "393000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a2a6f0e0-649e-419b-866d-568c6be72091",
      code: 394,
      name: "Ain Ghoraba",
      postalCode: "394000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "231cad69-894d-46d2-bd63-e2b9b6d791c6",
      code: 395,
      name: "Ain Kebira",
      postalCode: "395000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "118d58dd-7a97-4426-aba5-d3c82490c754",
      code: 396,
      name: "Ain Nehala",
      postalCode: "396000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "23763cea-650f-4966-b67b-35c1c4088f33",
      code: 397,
      name: "Ain Tellout",
      postalCode: "397000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ad669bf7-20dc-46f1-ad3a-c6f1f4d1f310",
      code: 398,
      name: "Ain Youcef",
      postalCode: "398000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "aaaee354-2bb6-491e-baa7-4fab5fcf5042",
      code: 399,
      name: "Amieur",
      postalCode: "399000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8d0b6cd9-7712-47d2-9ea4-460246494c32",
      code: 400,
      name: "Bab El Assa",
      postalCode: "400000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c9719809-60c1-4c0f-b376-4552e0ae4c3e",
      code: 401,
      name: "Beni Bahdel",
      postalCode: "401000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3faba91c-8232-44a4-8258-73ba8a998f33",
      code: 402,
      name: "Beni Boussaid",
      postalCode: "402000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9c1ab33e-b0cb-46f8-8ce4-4bedc420f854",
      code: 403,
      name: "Beni Khellad",
      postalCode: "403000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "676d55cc-8cec-4870-ba4f-926b71d32bcb",
      code: 404,
      name: "Beni Mester",
      postalCode: "404000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "55e7d1b1-96be-471b-afc4-9755e43b4b0b",
      code: 405,
      name: "Beni Ouarsous",
      postalCode: "405000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f7cc97fa-5e95-4185-8851-c9c63852dcb2",
      code: 406,
      name: "Beni Smiel",
      postalCode: "406000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "727724f2-48bc-4912-96f1-0bc7f1e1739d",
      code: 407,
      name: "Beni Snous",
      postalCode: "407000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3afc226f-66f8-4202-953e-3f235ec0ca66",
      code: 408,
      name: "Bensekrane",
      postalCode: "408000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9e23ff32-5416-43ff-af94-49d4bdee49c3",
      code: 409,
      name: "Bouhlou",
      postalCode: "409000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b7853cd7-a6a6-42ec-bd92-aa83523fdd66",
      code: 410,
      name: "Bouihi",
      postalCode: "410000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "85e5fbe6-e0a9-4fe1-aa62-6271eb83edb7",
      code: 411,
      name: "Chetouane",
      postalCode: "411000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7cdf618f-cf6c-45a4-a6f1-8de2a76a936c",
      code: 412,
      name: "Dar Yaghmoracen",
      postalCode: "412000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9b4626bc-5327-4098-aa78-b2540696b50c",
      code: 413,
      name: "Djebala",
      postalCode: "413000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a76cfc96-e3c5-41bd-8154-c82bbb7764fb",
      code: 414,
      name: "El Aricha",
      postalCode: "414000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "00b6827b-2784-4535-b3fe-c1bda626e69d",
      code: 415,
      name: "Azail",
      postalCode: "415000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "47cc8431-1a9e-434a-96b3-4726eda9bca3",
      code: 416,
      name: "El Fehoul",
      postalCode: "416000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "72383385-ec4d-49eb-b65f-b678eced78c9",
      code: 417,
      name: "El Gor",
      postalCode: "417000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b1a9b6e3-3400-4f99-b0af-c874f2fd9eac",
      code: 418,
      name: "Fellaoucene",
      postalCode: "418000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "cdf2c1a8-8c72-4b14-8cef-91e95cfaaec4",
      code: 419,
      name: "Ghazaouet",
      postalCode: "419000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "fe1ce9bb-cb62-4192-b271-08a05a85f160",
      code: 420,
      name: "Hammam Boughrara",
      postalCode: "420000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "64d78abc-f6d4-4250-a909-6fb80ce2dbef",
      code: 421,
      name: "Hennaya",
      postalCode: "421000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2ff90eb8-ce31-4736-aaa5-580392536620",
      code: 422,
      name: "Honnaine",
      postalCode: "422000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "845792eb-d72d-4e81-8d37-bdc409a1fb9f",
      code: 423,
      name: "Maghnia",
      postalCode: "423000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "cd4baaa2-fd46-4e1d-94b6-50ac300441e1",
      code: 424,
      name: "Mansourah",
      postalCode: "424000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "94cd30eb-12c8-4212-a195-45399cf476a9",
      code: 425,
      name: "Marsa Ben M'hidi",
      postalCode: "425000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a0634d93-21a0-49d2-886b-cf056a3f1fc3",
      code: 426,
      name: "M'sirda Fouaga",
      postalCode: "426000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ff611340-215e-48ad-a3d6-2ca830735c27",
      code: 427,
      name: "Nedroma",
      postalCode: "427000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5dd55656-caf1-4e4a-bd04-f9eb28b80c2f",
      code: 428,
      name: "Oued Lakhdar",
      postalCode: "428000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f9451d90-f1ef-4a3a-b76c-1160e35c7806",
      code: 429,
      name: "Ouled Mimoun",
      postalCode: "429000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9316140e-a2f8-4ae8-a514-a5b078a0e1f6",
      code: 430,
      name: "Ouled Riyah",
      postalCode: "430000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6373e97b-79e5-4ae3-8ee5-1b8606d32fdd",
      code: 431,
      name: "Remchi",
      postalCode: "431000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5175315a-6f30-46df-a40f-45deeaa3a6b4",
      code: 432,
      name: "Sabra",
      postalCode: "432000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e97b2cfa-aca0-4cd6-9591-64973609bc80",
      code: 433,
      name: "Sebbaa Chioukh",
      postalCode: "433000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "99d574ec-238a-4269-bfa8-57f909ee1987",
      code: 434,
      name: "Sebdou",
      postalCode: "434000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7abae998-0d79-4281-907a-e63c2ea3f691",
      code: 435,
      name: "Sidi Abdelli",
      postalCode: "435000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "179403b8-2702-49f6-8640-0852ce1af57c",
      code: 436,
      name: "Sidi Djillali",
      postalCode: "436000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "449c49e3-9ab6-4378-b9e0-8809d7d6f4f3",
      code: 437,
      name: "Sidi Medjahed",
      postalCode: "437000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0bf6176f-5cf1-461a-908b-cb6393b919a2",
      code: 438,
      name: "Souahlia",
      postalCode: "438000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6f0232e6-042a-4e73-9717-04b990a60943",
      code: 439,
      name: "Souani",
      postalCode: "439000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9de82afe-5066-42ea-80d8-7835e05c5a40",
      code: 440,
      name: "Souk Tleta",
      postalCode: "440000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "de91b71d-1a6f-486d-b1d4-37a399367667",
      code: 441,
      name: "Terny Beni Hediel",
      postalCode: "441000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a1042aeb-7ff5-4e2b-a331-f5b2a5b18f42",
      code: 442,
      name: "Tianet",
      postalCode: "442000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "626c17f7-faef-4efb-ac92-65246033892d",
      code: 443,
      name: "Tlemcen",
      postalCode: "443000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a3d97c75-1ce9-44c6-b210-fa6381ce2665",
      code: 444,
      name: "Zenata",
      postalCode: "444000",
      level: "commune",
      parentId: "53c9e062-9c4e-4c77-8b71-55eabf887f83",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a44b0253-516a-475a-bf92-aa8733539408",
      code: 445,
      name: "Ain Bouchekif",
      postalCode: "445000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "bfcbe612-d129-423d-bccb-aaab5bb0bb41",
      code: 446,
      name: "Ain Deheb",
      postalCode: "446000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f80a61f4-ca7a-4a6d-ba47-1e83bcc24bf6",
      code: 447,
      name: "Ain Dzarit",
      postalCode: "447000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4485e241-5fc0-49c6-9ba5-ba91efc07c08",
      code: 448,
      name: "Ain El Hadid",
      postalCode: "448000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4bd7b96d-d3c9-47e7-86df-b605de327ea2",
      code: 449,
      name: "Ain Kermes",
      postalCode: "449000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1d28d57d-9620-4af0-bbb7-d6112c47e28d",
      code: 450,
      name: "Bougara",
      postalCode: "450000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "fccfdd88-5468-4176-adfa-b801446b75fe",
      code: 451,
      name: "Chehaima",
      postalCode: "451000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "028b82e7-3502-41ab-afd1-5fa382ae24bf",
      code: 452,
      name: "Dahmouni",
      postalCode: "452000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c6762f65-270f-4b64-a128-e406851cd7e8",
      code: 453,
      name: "Djebilet Rosfa",
      postalCode: "453000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "fc702495-c277-4821-815b-64b9240e77fa",
      code: 454,
      name: "Djillali Ben Amar",
      postalCode: "454000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8b68923d-13f0-4795-a484-9ea0471554fa",
      code: 455,
      name: "Faidja",
      postalCode: "455000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3b0b9eb3-e566-475d-8480-032ea0031a02",
      code: 456,
      name: "Frenda",
      postalCode: "456000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e349a9f3-f027-4e61-9daa-1e3ee54ae624",
      code: 457,
      name: "Guertoufa",
      postalCode: "457000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c39f7417-70b5-40c4-ba71-e14366eda6a4",
      code: 458,
      name: "Hamadia",
      postalCode: "458000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9911e2ac-a631-4b58-a76b-2365a661b179",
      code: 459,
      name: "Ksar Chellala",
      postalCode: "459000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "132998e9-2217-4bad-bf37-fcb5251551ba",
      code: 460,
      name: "Madna",
      postalCode: "460000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "660dcf93-5d29-4c58-a60f-5cb32f4a7e03",
      code: 461,
      name: "Mahdia",
      postalCode: "461000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1ca9760f-89ca-4422-9357-d59fc5fcc0e6",
      code: 462,
      name: "Mechraa Safa",
      postalCode: "462000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3486bf04-59b9-4807-b597-22ad410eb506",
      code: 463,
      name: "Medrissa",
      postalCode: "463000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "48fb2f23-3c17-4e32-a10e-65db5163f596",
      code: 464,
      name: "Medroussa",
      postalCode: "464000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "18884efd-5e0e-43ec-a176-186a43ac0bac",
      code: 465,
      name: "Meghila",
      postalCode: "465000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "090962c1-7e2d-4699-ac42-4151e0c825e1",
      code: 466,
      name: "Mellakou",
      postalCode: "466000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b8a1bdf8-8fbc-425a-a3a1-34667223214e",
      code: 467,
      name: "Nadorah",
      postalCode: "467000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "92fcf433-4cce-4089-b56e-199baed95410",
      code: 468,
      name: "Naima",
      postalCode: "468000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "53983d69-ad8c-4192-8ad9-cb59bac05ff1",
      code: 469,
      name: "Oued Lilli",
      postalCode: "469000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1aa6599c-2559-414f-9aa4-7e1e8bbb6492",
      code: 470,
      name: "Rahouia",
      postalCode: "470000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5e783153-802b-4874-83e6-c2be9b260dbb",
      code: 471,
      name: "Rechaiga",
      postalCode: "471000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "518b3d6f-eb9d-4ece-879e-514411980b0c",
      code: 472,
      name: "Sebaine",
      postalCode: "472000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "68ad083b-f385-42ee-97f0-0be88a4320d0",
      code: 473,
      name: "Sebt",
      postalCode: "473000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "19bdc5ba-0da7-4914-bc6c-500d4a41a2a2",
      code: 474,
      name: "Serghine",
      postalCode: "474000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9d08107b-90b2-4d01-ad92-12aa24d5d0a8",
      code: 475,
      name: "Si Abdelghani",
      postalCode: "475000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e8c44e7f-7b16-4e6b-912a-337ef13dcdf9",
      code: 476,
      name: "Sidi Abderrahmane",
      postalCode: "476000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e8a3f02c-b4d2-4bab-beca-2a126566e198",
      code: 477,
      name: "Sidi Ali Mellal",
      postalCode: "477000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "73d5e864-f9c4-4ac8-9779-ccbb0be3abff",
      code: 478,
      name: "Sidi Bakhti",
      postalCode: "478000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "26d8fc17-ae8d-4449-80c4-bdb72cffef54",
      code: 479,
      name: "Sidi Hosni",
      postalCode: "479000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4e77a3e0-a17c-44d3-851c-795f44aaea4d",
      code: 480,
      name: "Sougueur",
      postalCode: "480000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5038ef48-50c7-4392-9d55-613b482c1b33",
      code: 481,
      name: "Tagdempt",
      postalCode: "481000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "97ad1714-de49-4f22-92a4-cb154d6a5dd5",
      code: 482,
      name: "Takhemaret",
      postalCode: "482000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "12959b60-f371-4c4b-9d97-152018576232",
      code: 483,
      name: "Tiaret",
      postalCode: "483000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "64157c35-1b1f-46db-a822-3c8953181553",
      code: 484,
      name: "Tidda",
      postalCode: "484000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "55a107ec-8b82-490e-b18c-25c6a14ba1b4",
      code: 485,
      name: "Tousnina",
      postalCode: "485000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d005c810-2230-4d71-bebd-027a7d2978aa",
      code: 486,
      name: "Zmalet El Emir Abdelkade",
      postalCode: "486000",
      level: "commune",
      parentId: "ada5bb27-ffe5-4977-a917-3105c2b3d9c6",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f8f75c19-3d2e-4961-af94-9b8413f23095",
      code: 487,
      name: "Abi-Youcef",
      postalCode: "487000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8c25e353-23ff-40d4-a4e5-52bb0df1b3d2",
      code: 488,
      name: "Aghribs",
      postalCode: "488000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3d9458cb-118b-448c-b3f2-3c70fb8a4c3f",
      code: 489,
      name: "Agouni-Gueghrane",
      postalCode: "489000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4611bc0b-338d-493b-8338-db81a3d0fc6e",
      code: 490,
      name: "Ain-El-Hammam",
      postalCode: "490000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "57b880a6-de08-46a0-96da-f9963578a61a",
      code: 491,
      name: "Ain-Zaouia",
      postalCode: "491000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "537b51dc-9292-451b-b046-1d3ee5b4d657",
      code: 492,
      name: "Ait Aggouacha",
      postalCode: "492000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ddcdc30d-9429-44c1-bcd2-91ee1c6eaf4c",
      code: 493,
      name: "Ait Bouaddou",
      postalCode: "493000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3b5d32d3-c3fe-4cad-92b5-ba99aeff7c4f",
      code: 494,
      name: "Ait Boumahdi",
      postalCode: "494000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "95d346cd-4c52-4792-bcce-1db80d4567a1",
      code: 495,
      name: "Ait Khellili",
      postalCode: "495000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7e5cc9b2-0006-4420-8c95-2e33536898bb",
      code: 496,
      name: "Ait Yahia Moussa",
      postalCode: "496000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e88c9247-4afa-493e-9d87-6d6623ac028f",
      code: 497,
      name: "Ait-Aissa-Mimoun",
      postalCode: "497000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "198ac4a1-6bb6-4f24-81ed-78a3bc4ca7ea",
      code: 498,
      name: "Ait-Chafaa",
      postalCode: "498000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4b1ed109-6313-4930-807e-9597196bb3b9",
      code: 499,
      name: "Ait-Mahmoud",
      postalCode: "499000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "39d1f955-48bd-412b-96c5-53cf85dcd596",
      code: 500,
      name: "Ait-Oumalou",
      postalCode: "500000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "45e8bc48-003a-41a4-9b45-2167ac0974f2",
      code: 501,
      name: "Ait-Toudert",
      postalCode: "501000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5a77e57a-5af7-4a13-bcdf-f420c1dae435",
      code: 502,
      name: "Ait-Yahia",
      postalCode: "502000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d870a80d-f349-4dfd-b3bf-5c4e467e4858",
      code: 503,
      name: "Akbil",
      postalCode: "503000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5d481060-ce3b-40b2-aec9-4295f5150fab",
      code: 504,
      name: "Akerrou",
      postalCode: "504000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "44fb5617-6c97-4f32-ace5-b52fcf6916c8",
      code: 505,
      name: "Assi-Youcef",
      postalCode: "505000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8c5c394a-d951-4a3f-bcb7-720aff5144bd",
      code: 506,
      name: "Azazga",
      postalCode: "506000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4156ca4f-91bd-4450-9d23-51f9d966dd34",
      code: 507,
      name: "Azeffoun",
      postalCode: "507000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "35990b21-d309-4408-a4b5-b60dea82be89",
      code: 508,
      name: "Beni Zmenzer",
      postalCode: "508000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "13661d09-57fd-43bc-bdc5-84114aa210b6",
      code: 509,
      name: "Beni-Aissi",
      postalCode: "509000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6a85ad11-875d-4efa-bb61-89404be8d926",
      code: 510,
      name: "Beni-Douala",
      postalCode: "510000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4de10b07-a2cb-494a-9db2-d876e47eb16d",
      code: 511,
      name: "Beni-Yenni",
      postalCode: "511000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "348c29bd-fb06-4f75-8160-dcef2489d303",
      code: 512,
      name: "Beni-Zikki",
      postalCode: "512000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c7d8326f-74ec-4932-bb39-2bcbacacaab8",
      code: 513,
      name: "Boghni",
      postalCode: "513000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "261f0c52-8653-48b6-b453-13e32be09a11",
      code: 514,
      name: "Boudjima",
      postalCode: "514000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "00c30f68-86f6-45f7-8976-f7f5a179f885",
      code: 515,
      name: "Bounouh",
      postalCode: "515000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5cff1f32-d20d-493e-ac77-702951cd3c99",
      code: 516,
      name: "Bouzeguene",
      postalCode: "516000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "31b8958a-22cb-4285-a073-945a575cad8f",
      code: 517,
      name: "Draa-Ben-Khedda",
      postalCode: "517000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "dd3af9bb-e7ec-4462-abd2-2e645a1fe216",
      code: 518,
      name: "Draa-El-Mizan",
      postalCode: "518000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1b08a5b2-aaa6-4f5b-838e-761a88c97680",
      code: 519,
      name: "Freha",
      postalCode: "519000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "83b4c392-17dc-4728-a98a-6a5165eee88b",
      code: 520,
      name: "Frikat",
      postalCode: "520000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "12542af1-fc1c-454e-af26-2d7cdb2eadc7",
      code: 521,
      name: "Iboudrarene",
      postalCode: "521000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "24582ba6-5772-4f5b-ac5b-d358f6764071",
      code: 522,
      name: "Idjeur",
      postalCode: "522000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8df159d0-b06a-4e4e-af5e-3440125561e8",
      code: 523,
      name: "Iferhounene",
      postalCode: "523000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "86ea600f-d841-4a83-8d23-f97310aca00a",
      code: 524,
      name: "Ifigha",
      postalCode: "524000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "76ba6b08-0faa-463d-a126-908abfde147a",
      code: 525,
      name: "Iflissen",
      postalCode: "525000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1615bb64-592e-4a88-bb31-406bfcb29637",
      code: 526,
      name: "Illilten",
      postalCode: "526000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "dacf107e-3542-4ee4-8587-76aea25ded28",
      code: 527,
      name: "Illoula Oumalou",
      postalCode: "527000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e823458c-8b96-4762-aaec-c301963191c8",
      code: 528,
      name: "Imsouhal",
      postalCode: "528000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8243b33f-4b71-40a2-a512-ac0fa638aab1",
      code: 529,
      name: "Irdjen",
      postalCode: "529000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "af9aba9c-a1f7-4ce1-80b1-880fb518709c",
      code: 530,
      name: "Larbaa Nath Irathen",
      postalCode: "530000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7db9d3c3-dfa1-4264-8156-1083c9d03c44",
      code: 531,
      name: "Maatkas",
      postalCode: "531000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d028ce6f-d080-46d4-b352-a3601b00d490",
      code: 532,
      name: "Makouda",
      postalCode: "532000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "abc65fa8-e4dd-4c2f-81d5-da79abcf5f40",
      code: 533,
      name: "Mechtras",
      postalCode: "533000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "81e41522-61c0-4140-912c-59a8c5206091",
      code: 534,
      name: "Mekla",
      postalCode: "534000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "705abddd-59e6-4358-a75f-15958619e7c9",
      code: 535,
      name: "Mizrana",
      postalCode: "535000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0b39c2a9-4d50-4246-81c1-349cc112932d",
      code: 536,
      name: "M'kira",
      postalCode: "536000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8f8e35a8-bdb3-4cdb-b9dd-c0755078665e",
      code: 537,
      name: "Ouacif",
      postalCode: "537000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b45401a2-ff02-4772-b3a2-01f71fe5634f",
      code: 538,
      name: "Ouadhias",
      postalCode: "538000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2dafda2c-fe5a-4c0a-9033-08775296efa5",
      code: 539,
      name: "Ouaguenoun",
      postalCode: "539000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "31a80903-36d8-420e-bffd-22fdc6372ade",
      code: 540,
      name: "Sidi Namane",
      postalCode: "540000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "bfb70cb7-9cd7-4f69-85a2-d9dde4ef7f3e",
      code: 541,
      name: "Souama",
      postalCode: "541000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5a1e32a3-6e11-4c88-be7c-b967f1e55dff",
      code: 542,
      name: "Souk-El-Tenine",
      postalCode: "542000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d850517d-2bb2-4bae-be3f-dd408e1a8220",
      code: 543,
      name: "Tadmait",
      postalCode: "543000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "768860b3-ea69-47ec-a04e-033c6c1aa953",
      code: 544,
      name: "Tigzirt",
      postalCode: "544000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7411f919-15e2-48d1-b3c0-a53af1a3fab1",
      code: 545,
      name: "Timizart",
      postalCode: "545000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5dd5c4fb-ea2f-4dec-88af-2969ee4de49e",
      code: 546,
      name: "Tirmitine",
      postalCode: "546000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a048d32a-84ab-4e16-a8f4-094f6c33e977",
      code: 547,
      name: "Tizi N'tleta",
      postalCode: "547000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "645bebb6-849e-4727-9f39-a97af106e845",
      code: 548,
      name: "Tizi-Gheniff",
      postalCode: "548000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "66d8b00b-2172-42ae-8c7f-f993ac9c819e",
      code: 549,
      name: "Tizi-Ouzou",
      postalCode: "549000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0c7acb35-fa5c-484c-98bd-a2e8554846db",
      code: 550,
      name: "Tizi-Rached",
      postalCode: "550000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "45505e84-2261-43c8-8009-13ee28c56ff3",
      code: 551,
      name: "Yakourene",
      postalCode: "551000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "73d1afc4-d901-4f5e-9ec9-5e0e596d47c8",
      code: 552,
      name: "Yatafene",
      postalCode: "552000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "871e6983-baef-4135-876a-ad7d975c246b",
      code: 553,
      name: "Zekri",
      postalCode: "553000",
      level: "commune",
      parentId: "5bef8e95-fad8-4a15-95f0-8d6f5c80f69e",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6bc1447c-ebef-4806-8c16-bd5f3ebbedc8",
      code: 554,
      name: "Ain Benian",
      postalCode: "554000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "844298a3-9355-459a-a12c-3e95e0d6abd6",
      code: 555,
      name: "Ain Taya",
      postalCode: "555000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8c97a133-681b-4da4-8466-2f6110557fa2",
      code: 556,
      name: "Alger Centre",
      postalCode: "556000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "efd8d844-f39d-45eb-bf12-58bfb64c52e5",
      code: 557,
      name: "Bab El Oued",
      postalCode: "557000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "398eca7c-75bf-409e-ba27-9d93e21b0cf3",
      code: 558,
      name: "Bab Ezzouar",
      postalCode: "558000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "99423e96-2073-4513-9a71-221cad6ca182",
      code: 559,
      name: "Baba Hassen",
      postalCode: "559000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d75877e4-1e21-4525-b5f4-3ed551d67c3e",
      code: 560,
      name: "Bachedjerah",
      postalCode: "560000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "192e4026-0e46-43e0-9685-02122af81f80",
      code: 561,
      name: "Baraki",
      postalCode: "561000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e999d03d-9cc6-46ef-a4e1-f75c92a1315e",
      code: 562,
      name: "Ben Aknoun",
      postalCode: "562000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "47bb6b7e-05a8-4e13-9c64-3e43cb1a5dcb",
      code: 563,
      name: "Beni Messous",
      postalCode: "563000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "195a5cf5-dd2b-4bca-80e5-e5dd3f9fb3f3",
      code: 564,
      name: "Bir Mourad Rais",
      postalCode: "564000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "85fa42cc-3d00-4984-8da9-b192351a8ee1",
      code: 565,
      name: "Birkhadem",
      postalCode: "565000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "17b37af7-497c-49b1-bf39-5e4630d266ce",
      code: 566,
      name: "Bir Touta",
      postalCode: "566000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6e658712-a791-4e73-8468-d8b8ca73c1d7",
      code: 567,
      name: "Bologhine Ibnou Ziri",
      postalCode: "567000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7a925e67-4508-49ad-adca-40496cd95cc8",
      code: 568,
      name: "Bordj El Bahri",
      postalCode: "568000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d8be2c16-186e-4d85-bd70-9676b18b61e2",
      code: 569,
      name: "Bordj El Kiffan",
      postalCode: "569000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3bcc7209-e42e-4178-ba39-d763aa9807d1",
      code: 570,
      name: "Bourouba",
      postalCode: "570000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "51285c76-9c0e-4314-b5da-6f023e113543",
      code: 571,
      name: "Bouzareah",
      postalCode: "571000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "bab87ee4-353a-4098-99c3-9a572945f682",
      code: 572,
      name: "Casbah",
      postalCode: "572000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "50a7b05d-dad7-4d8a-9424-2ba0ee796eee",
      code: 573,
      name: "Cheraga",
      postalCode: "573000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5bcbb04a-6ecc-4644-9adc-11154333976d",
      code: 574,
      name: "Dar El Beida",
      postalCode: "574000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "05540a76-bb99-4bb6-8d72-5bf763625ea3",
      code: 575,
      name: "Dely Ibrahim",
      postalCode: "575000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9726f197-b080-4d72-9f07-b27ec16f0f78",
      code: 576,
      name: "Djasr Kasentina",
      postalCode: "576000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8fdb99d2-d678-4d93-9074-36540c89e8b8",
      code: 577,
      name: "Douira",
      postalCode: "577000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "960c775f-793f-4457-9588-aea1718a3853",
      code: 578,
      name: "Draria",
      postalCode: "578000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d769a6b7-3691-4c1e-b062-6d7e33a9d2f2",
      code: 579,
      name: "El Achour",
      postalCode: "579000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a9ac4059-259e-4b0b-bb7c-6927583df361",
      code: 580,
      name: "El Biar",
      postalCode: "580000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "99f0bcae-ba98-4a6a-adc7-695de1e077f8",
      code: 581,
      name: "El Harrach",
      postalCode: "581000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "609795e8-6203-41d3-a585-a036c1fed07b",
      code: 582,
      name: "El Madania",
      postalCode: "582000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a321dd4d-5867-465e-83cb-4c89db65c7d9",
      code: 583,
      name: "El Magharia",
      postalCode: "583000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "87c4bc1f-5736-418f-8fe5-7d75ddcebd1c",
      code: 584,
      name: "El Marsa",
      postalCode: "584000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "bdcaad23-4736-400e-997c-5b23537147b0",
      code: 585,
      name: "El Mouradia",
      postalCode: "585000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1f041748-5109-4a31-8d3a-6fedad1d9c7d",
      code: 586,
      name: "Hammamet",
      postalCode: "586000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "adaabd18-c76c-4b41-bcd0-40de6e9beee7",
      code: 587,
      name: "Herraoua",
      postalCode: "587000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "43027cb3-b424-46e7-841b-cf2908783fde",
      code: 588,
      name: "Hussein Dey",
      postalCode: "588000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "54ce3f0f-f3e4-4374-acf1-4c3e490cd794",
      code: 589,
      name: "Hydra",
      postalCode: "589000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "303afb7a-d02e-459d-96f5-9aff719b7f19",
      code: 590,
      name: "Khraissia",
      postalCode: "590000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b8dab885-69ce-4651-b04f-eb3b33f15792",
      code: 591,
      name: "Kouba",
      postalCode: "591000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "68a7377a-1fa3-427a-b136-f5c1842cffc2",
      code: 592,
      name: "Les Eucalyptus",
      postalCode: "592000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8e66a587-82ea-47a8-8400-92f2458ada94",
      code: 593,
      name: "Maalma",
      postalCode: "593000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "43e2fb24-4e8c-4f41-991f-5b34a848bcb2",
      code: 594,
      name: "Mohamed Belouzdad",
      postalCode: "594000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1adde934-fc18-48a1-805f-728569f44e18",
      code: 595,
      name: "Mohammadia",
      postalCode: "595000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2c0d14de-f01b-4652-8c8a-7fc31f58d7b0",
      code: 596,
      name: "Oued Koriche",
      postalCode: "596000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c857f256-2d10-4278-8d9c-1560a8fef68e",
      code: 597,
      name: "Oued Smar",
      postalCode: "597000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "72eb3395-7595-49e0-86aa-836fd234eb37",
      code: 598,
      name: "Ouled Chebel",
      postalCode: "598000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "16749b16-884c-4562-8c69-87186c0c4792",
      code: 599,
      name: "Ouled Fayet",
      postalCode: "599000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1a1af3e3-f3b4-4e48-bb4f-340958baa407",
      code: 600,
      name: "Rahmania",
      postalCode: "600000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "22c19663-7cf5-4547-9d53-e197e898ccf3",
      code: 601,
      name: "Rais Hamidou",
      postalCode: "601000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ff17d058-ac0d-4d6f-bfcf-7d38ba1124dd",
      code: 602,
      name: "Reghaia",
      postalCode: "602000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f55ea1df-b887-4af5-84d8-5840e1835894",
      code: 603,
      name: "Rouiba",
      postalCode: "603000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "af44d58b-5f59-4538-84ee-6f5574d40d30",
      code: 604,
      name: "Sehaoula",
      postalCode: "604000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0b93d266-f7d8-4e87-98dc-9ea01cf8ed9c",
      code: 605,
      name: "Sidi M'hamed",
      postalCode: "605000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "33dc9591-6563-4842-ae19-1f0867b02c61",
      code: 606,
      name: "Sidi Moussa",
      postalCode: "606000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "93b352eb-a63c-4239-8eb6-624a5f371d14",
      code: 607,
      name: "Souidania",
      postalCode: "607000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a2f3a538-1294-470f-9bd2-7be31d049269",
      code: 608,
      name: "Staoueli",
      postalCode: "608000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "75896e17-87b6-415c-a965-038e6f9c3809",
      code: 609,
      name: "Tessala El Merdja",
      postalCode: "609000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "832d63fd-5509-4f3b-b1c5-8e4d2898f36f",
      code: 610,
      name: "Zeralda",
      postalCode: "610000",
      level: "commune",
      parentId: "d134c182-7dac-4655-9d9b-bbdb62aa2ec4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3057fed3-e947-454e-857f-3d092b57f890",
      code: 611,
      name: "Ain Chouhada",
      postalCode: "611000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4773dfb9-f709-4eda-901a-425342948842",
      code: 612,
      name: "Ain El Ibel",
      postalCode: "612000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b64649a7-28a2-44ac-affd-b0535e2ea9c4",
      code: 613,
      name: "Ain Fekka",
      postalCode: "613000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "53603004-e032-4d37-8298-d7c2edc58939",
      code: 614,
      name: "Ain Maabed",
      postalCode: "614000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7a8642bf-567f-4a9c-a356-caaf5b13db89",
      code: 615,
      name: "Ain Oussera",
      postalCode: "615000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "35cee308-14f6-41f7-83fd-d768b8109b00",
      code: 616,
      name: "Amourah",
      postalCode: "616000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "71403d4c-8957-45b2-82a5-26cfbf5d085c",
      code: 617,
      name: "Benhar",
      postalCode: "617000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "92763540-78dc-4772-b328-5db76d2fbbf7",
      code: 618,
      name: "Benyagoub",
      postalCode: "618000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1f8d405c-3b15-43f3-a3a5-c71b10ed1cfb",
      code: 619,
      name: "Birine",
      postalCode: "619000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1e26af75-5696-4663-8594-810717e4459c",
      code: 620,
      name: "Bouira Lahdab",
      postalCode: "620000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "87242bb1-1459-4133-ae4a-03283cb317b8",
      code: 621,
      name: "Charef",
      postalCode: "621000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f9d26ad9-3dd2-4617-9f35-165c2bb47c96",
      code: 622,
      name: "Dar Chioukh",
      postalCode: "622000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "04f01a73-4fc0-4188-b97c-10374fddae87",
      code: 623,
      name: "Deldoul",
      postalCode: "623000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "71e815a4-6f1d-4bc7-815c-5a45cc4153d1",
      code: 624,
      name: "Djelfa",
      postalCode: "624000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d8fa63ab-b187-4100-afd7-2db5da97cf70",
      code: 625,
      name: "Douis",
      postalCode: "625000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "cd4613ca-5197-464d-98ff-405797099356",
      code: 626,
      name: "El Guedid",
      postalCode: "626000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1c009513-e4d7-4de3-a109-8bea76104f94",
      code: 627,
      name: "El Idrissia",
      postalCode: "627000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7bf2a1f0-5ff3-4097-b479-8da59132def9",
      code: 628,
      name: "El Khemis",
      postalCode: "628000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5bf79468-e223-4f5d-ab31-e3c4490eaae7",
      code: 629,
      name: "Faidh El Botma",
      postalCode: "629000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "232fdd71-1259-456d-a157-d0914d52d52d",
      code: 630,
      name: "Guernini",
      postalCode: "630000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "dd3d6284-e3d6-4fe4-b58d-6e47db32cffc",
      code: 631,
      name: "Guettara",
      postalCode: "631000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b3b91d2e-14b2-4745-ae3a-4f1fd019d1a9",
      code: 632,
      name: "Had Sahary",
      postalCode: "632000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "28ff9434-3b0f-441f-8e2c-7caeaec19d27",
      code: 633,
      name: "Hassi Bahbah",
      postalCode: "633000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a2da2244-979f-445f-905b-409a04587ae5",
      code: 634,
      name: "Hassi El Euch",
      postalCode: "634000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "fbe3edc5-8cd6-4fbe-9c54-596817cf3dc5",
      code: 635,
      name: "Hassi Fedoul",
      postalCode: "635000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4342da4b-3869-4c4c-ba51-e6483eba778d",
      code: 636,
      name: "Messaad",
      postalCode: "636000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8536796f-1371-4cb5-9656-c618c1df05ea",
      code: 637,
      name: "M'liliha",
      postalCode: "637000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "bc348d89-60c2-4cef-ae8e-1de738e2eff4",
      code: 638,
      name: "Moudjebara",
      postalCode: "638000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1e2981c0-d88e-4266-a1c8-b8eb5ceb3db9",
      code: 639,
      name: "Oum Laadham",
      postalCode: "639000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "bd302611-b078-4d60-b26d-87b3d32cf68a",
      code: 640,
      name: "Sed Rahal",
      postalCode: "640000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1b487f47-f977-48fd-804b-405825775980",
      code: 641,
      name: "Selmana",
      postalCode: "641000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f6eb05c0-4d69-4139-9ce8-55e0f7585bc9",
      code: 642,
      name: "Sidi Baizid",
      postalCode: "642000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8d976991-64f7-4114-9814-cb1fb82c9326",
      code: 643,
      name: "Sidi Laadjel",
      postalCode: "643000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "869d81c5-fe4a-424c-8539-6180246b3326",
      code: 644,
      name: "Taadmit",
      postalCode: "644000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "86545337-257d-4723-b269-2830ec064d49",
      code: 645,
      name: "Zaafrane",
      postalCode: "645000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "749cf9aa-5332-4e89-95e2-0db8b7b9a870",
      code: 646,
      name: "Zaccar",
      postalCode: "646000",
      level: "commune",
      parentId: "9ee8eac2-77e5-4d70-ac49-bde455d06bee",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "87f4da58-1c60-412a-a8eb-2da51170620e",
      code: 647,
      name: "Bordj T'har",
      postalCode: "647000",
      level: "commune",
      parentId: "dc851e52-55b2-4beb-a7f1-79d4e73e9458",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9291deba-296b-451b-967e-9ea180b872bc",
      code: 648,
      name: "Boudria Beniyadjis",
      postalCode: "648000",
      level: "commune",
      parentId: "dc851e52-55b2-4beb-a7f1-79d4e73e9458",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b0c0af5b-d447-4fec-abf0-21212fe13619",
      code: 649,
      name: "Bouraoui Belhadef",
      postalCode: "649000",
      level: "commune",
      parentId: "dc851e52-55b2-4beb-a7f1-79d4e73e9458",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "47cfac95-2963-4187-851b-d3df78c733d6",
      code: 650,
      name: "Boussif Ouled Askeur",
      postalCode: "650000",
      level: "commune",
      parentId: "dc851e52-55b2-4beb-a7f1-79d4e73e9458",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ef7cbc72-a2a2-4e01-b06e-19924e7fe889",
      code: 651,
      name: "Chahna",
      postalCode: "651000",
      level: "commune",
      parentId: "dc851e52-55b2-4beb-a7f1-79d4e73e9458",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4dd40022-50e1-481a-a5e9-abaf0fd99cb8",
      code: 652,
      name: "Chekfa",
      postalCode: "652000",
      level: "commune",
      parentId: "dc851e52-55b2-4beb-a7f1-79d4e73e9458",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f1ba7ff4-2835-4851-ba40-090876e812a6",
      code: 653,
      name: "Djemaa Beni Habibi",
      postalCode: "653000",
      level: "commune",
      parentId: "dc851e52-55b2-4beb-a7f1-79d4e73e9458",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6e6eddae-ea10-4706-895e-8f33f2195630",
      code: 654,
      name: "Djimla",
      postalCode: "654000",
      level: "commune",
      parentId: "dc851e52-55b2-4beb-a7f1-79d4e73e9458",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f92a0b30-e913-4a19-9a78-5a572c54689b",
      code: 655,
      name: "El Ancer",
      postalCode: "655000",
      level: "commune",
      parentId: "dc851e52-55b2-4beb-a7f1-79d4e73e9458",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "088a5fd1-d278-49e9-a604-70a38cadd871",
      code: 656,
      name: "El Aouana",
      postalCode: "656000",
      level: "commune",
      parentId: "dc851e52-55b2-4beb-a7f1-79d4e73e9458",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "efd56215-c5be-4856-b27f-547f5807a350",
      code: 657,
      name: "El Kennar Nouchfi",
      postalCode: "657000",
      level: "commune",
      parentId: "dc851e52-55b2-4beb-a7f1-79d4e73e9458",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "de818328-8722-46ac-a74a-631a7e8ebc81",
      code: 658,
      name: "El Milia",
      postalCode: "658000",
      level: "commune",
      parentId: "dc851e52-55b2-4beb-a7f1-79d4e73e9458",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8d67a81d-250d-43fa-ae22-09effc6b5506",
      code: 659,
      name: "Emir Abdelkader",
      postalCode: "659000",
      level: "commune",
      parentId: "dc851e52-55b2-4beb-a7f1-79d4e73e9458",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f76479b1-6bbb-4b5f-8bde-89e607b9b5e8",
      code: 660,
      name: "Erraguene Souissi",
      postalCode: "660000",
      level: "commune",
      parentId: "dc851e52-55b2-4beb-a7f1-79d4e73e9458",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5e9e1418-773b-44a9-b726-fa99aaa3d3e4",
      code: 661,
      name: "Ghebala",
      postalCode: "661000",
      level: "commune",
      parentId: "dc851e52-55b2-4beb-a7f1-79d4e73e9458",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "265156d8-3b41-4323-b627-43143e351c96",
      code: 662,
      name: "Jijel",
      postalCode: "662000",
      level: "commune",
      parentId: "dc851e52-55b2-4beb-a7f1-79d4e73e9458",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8923fe53-621a-4764-a818-c58134a17d3d",
      code: 663,
      name: "Kaous",
      postalCode: "663000",
      level: "commune",
      parentId: "dc851e52-55b2-4beb-a7f1-79d4e73e9458",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "02024e1d-3abd-4251-985d-ee77bf69aafd",
      code: 664,
      name: "Khiri Oued Adjoul",
      postalCode: "664000",
      level: "commune",
      parentId: "dc851e52-55b2-4beb-a7f1-79d4e73e9458",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f20b0192-cdf8-4a3e-a0b9-863cfb3bb21a",
      code: 665,
      name: "Oudjana",
      postalCode: "665000",
      level: "commune",
      parentId: "dc851e52-55b2-4beb-a7f1-79d4e73e9458",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "81803f7a-e41b-4068-959f-f301f21b4b15",
      code: 666,
      name: "Ouled Rabah",
      postalCode: "666000",
      level: "commune",
      parentId: "dc851e52-55b2-4beb-a7f1-79d4e73e9458",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3407c4e0-d66d-43d0-98e2-0d4709e2f011",
      code: 667,
      name: "Ouled Yahia Khadrouch",
      postalCode: "667000",
      level: "commune",
      parentId: "dc851e52-55b2-4beb-a7f1-79d4e73e9458",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "91ce57fd-4b7b-4f06-8983-6d48b7b35360",
      code: 668,
      name: "Selma Benziada",
      postalCode: "668000",
      level: "commune",
      parentId: "dc851e52-55b2-4beb-a7f1-79d4e73e9458",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2911dae3-34e6-45bd-8694-1e0b6c75ace9",
      code: 669,
      name: "Settara",
      postalCode: "669000",
      level: "commune",
      parentId: "dc851e52-55b2-4beb-a7f1-79d4e73e9458",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0b9ad6a5-32a6-4ade-aeed-d9ac1cdb68cc",
      code: 670,
      name: "Sidi Abdelaziz",
      postalCode: "670000",
      level: "commune",
      parentId: "dc851e52-55b2-4beb-a7f1-79d4e73e9458",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "10724d00-e01b-4be8-b348-4b4f18578cf4",
      code: 671,
      name: "Sidi Marouf",
      postalCode: "671000",
      level: "commune",
      parentId: "dc851e52-55b2-4beb-a7f1-79d4e73e9458",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e1dd5ed6-4a25-4cce-80e9-70a1fa705cfd",
      code: 672,
      name: "Taher",
      postalCode: "672000",
      level: "commune",
      parentId: "dc851e52-55b2-4beb-a7f1-79d4e73e9458",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7b4853e6-5aa9-4b97-8491-60543c5869a8",
      code: 673,
      name: "Texenna",
      postalCode: "673000",
      level: "commune",
      parentId: "dc851e52-55b2-4beb-a7f1-79d4e73e9458",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "292a00d3-c29a-4ce6-8bb8-c04ea8a64503",
      code: 674,
      name: "Ziama Mansouriah",
      postalCode: "674000",
      level: "commune",
      parentId: "dc851e52-55b2-4beb-a7f1-79d4e73e9458",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f31c850b-539f-4c9b-b60c-2bb7988dc881",
      code: 675,
      name: "Ain Abessa",
      postalCode: "675000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "95fbe866-c39b-4fe8-91db-765cfa9743ef",
      code: 676,
      name: "Ain Arnat",
      postalCode: "676000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3c81659f-7f97-424b-9a22-c3d24919faed",
      code: 677,
      name: "Ain Azel",
      postalCode: "677000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d93ca4a9-6328-4df9-85e8-641e8db40404",
      code: 678,
      name: "Ain El Kebira",
      postalCode: "678000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "689c7f30-8f15-4bfd-9c5d-0e9c0d941718",
      code: 679,
      name: "Ain Lahdjar",
      postalCode: "679000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1878ed8c-8413-4b5b-beaa-6b1ce8614fa9",
      code: 680,
      name: "Ain Oulmene",
      postalCode: "680000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3b6bbfc7-37f3-41f2-aee4-3bd21d58fb78",
      code: 681,
      name: "Ain-Legradj",
      postalCode: "681000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3894cd05-25ad-47bc-acde-92d0e02c7096",
      code: 682,
      name: "Ain-Roua",
      postalCode: "682000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3d2228d3-caa7-4d46-a80e-9184e3b018d4",
      code: 683,
      name: "Ain-Sebt",
      postalCode: "683000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b96f958e-75f1-4b61-a39f-c1229b5ff28b",
      code: 684,
      name: "Ait Naoual Mezada",
      postalCode: "684000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a2f84770-7b41-40ee-9ff6-95afce2440eb",
      code: 685,
      name: "Ait-Tizi",
      postalCode: "685000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "002796c1-5802-4d02-af32-e57a459fcfcb",
      code: 686,
      name: "Amoucha",
      postalCode: "686000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f94acef9-eab6-45ae-9293-ce56ec8ecf91",
      code: 687,
      name: "Babor",
      postalCode: "687000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f423f52d-5292-47a2-bd27-a07a887c87b0",
      code: 688,
      name: "Bazer-Sakra",
      postalCode: "688000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7d30b19d-0729-4654-893a-0e7c48090337",
      code: 689,
      name: "Beidha Bordj",
      postalCode: "689000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8290409c-c582-4742-9531-2ac5e3d39c0c",
      code: 690,
      name: "Bellaa",
      postalCode: "690000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "787a6ba4-3bc4-404c-8c00-497f205aae47",
      code: 691,
      name: "Beni Chebana",
      postalCode: "691000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a57b2e14-6dbf-40de-847d-87cc3313fd2e",
      code: 692,
      name: "Beni Fouda",
      postalCode: "692000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "91c6ebdc-5325-4a97-ad94-376f7457c259",
      code: 693,
      name: "Beni Ourtilane",
      postalCode: "693000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9aacd4f4-2eda-4c20-a2e8-e5ccf53d7f07",
      code: 694,
      name: "Beni Oussine",
      postalCode: "694000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8f0cca7b-83b9-4a43-ad30-ac37db490cad",
      code: 695,
      name: "Beni-Aziz",
      postalCode: "695000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "47b839a7-cfca-4f4d-b1fd-a95a19ec0f6e",
      code: 696,
      name: "Beni-Mouhli",
      postalCode: "696000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ad57a8d0-8146-48a1-80aa-42c137a24726",
      code: 697,
      name: "Bir Haddada",
      postalCode: "697000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "bf289b27-80d3-4f8c-b3b2-e678a41e4dff",
      code: 698,
      name: "Bir-El-Arch",
      postalCode: "698000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ff3fe168-e701-49de-bb2f-1e5104290f6a",
      code: 699,
      name: "Bouandas",
      postalCode: "699000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "190c52f1-7192-472c-be68-f45bd42be39b",
      code: 700,
      name: "Bougaa",
      postalCode: "700000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6dd6b8d3-d63f-44d6-a850-1eaef98cef3f",
      code: 701,
      name: "Bousselam",
      postalCode: "701000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ab5e5e18-0c85-4ff6-b9c9-5f7a7ee45c3f",
      code: 702,
      name: "Boutaleb",
      postalCode: "702000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ccdf19c6-f59b-4555-9628-7ab0f790c22f",
      code: 703,
      name: "Dehamcha",
      postalCode: "703000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ee5a5f8a-de86-4fa1-9563-060ed7629f6c",
      code: 704,
      name: "Djemila",
      postalCode: "704000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b8accc2b-720f-48ba-953d-6eb2f885ed97",
      code: 705,
      name: "Draa-Kebila",
      postalCode: "705000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "62762808-0c86-4c6a-a605-146a6d124fa3",
      code: 706,
      name: "El Eulma",
      postalCode: "706000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5613c0de-d9b8-4aa0-90d6-60fe0b2ebca9",
      code: 707,
      name: "El Ouricia",
      postalCode: "707000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "54ee3066-5f7e-4405-8c7b-dd4042c2e879",
      code: 708,
      name: "El-Ouldja",
      postalCode: "708000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9c7e3529-ff92-45ba-8307-89358ad8813c",
      code: 709,
      name: "Guellal",
      postalCode: "709000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "188fa54f-232b-45e1-afe6-b2e279678953",
      code: 710,
      name: "Guelta Zerka",
      postalCode: "710000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ce7c712c-5f80-49d3-b28f-0ee349b1896e",
      code: 711,
      name: "Guenzet",
      postalCode: "711000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "fb670c62-4163-4f88-8ef0-85950c882044",
      code: 712,
      name: "Guidjel",
      postalCode: "712000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "cb8a5b03-8374-404e-b4e4-bb68b7089475",
      code: 713,
      name: "Hamam Soukhna",
      postalCode: "713000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b37607fc-145c-4785-af30-84051549eafc",
      code: 714,
      name: "Hamma",
      postalCode: "714000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "25bf3c19-c40d-41ef-8831-a83095a6dbf8",
      code: 715,
      name: "Hammam Guergour",
      postalCode: "715000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4c964c5f-5942-4035-a08a-2a9ed997bbac",
      code: 716,
      name: "Harbil",
      postalCode: "716000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "84841b36-efff-4231-a70c-742dca3d77ec",
      code: 717,
      name: "Kasr El Abtal",
      postalCode: "717000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "88b53a42-bac4-4731-b08f-949913077a9f",
      code: 718,
      name: "Maaouia",
      postalCode: "718000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a8a57322-9a21-4994-a097-d3620e7dd932",
      code: 719,
      name: "Maouaklane",
      postalCode: "719000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "cad05bf4-a243-47f6-ac28-f5c514919c45",
      code: 720,
      name: "Mezloug",
      postalCode: "720000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0facbea3-3f6e-44e9-a6c2-bccec1446c13",
      code: 721,
      name: "Oued El Bared",
      postalCode: "721000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "11800d0d-a577-4558-8ab9-da0df4af05c2",
      code: 722,
      name: "Ouled Addouane",
      postalCode: "722000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1d3501f9-9630-4899-8dbf-4938050d71d9",
      code: 723,
      name: "Ouled Sabor",
      postalCode: "723000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "eff027a0-1038-4cbe-943d-adba33a055fa",
      code: 724,
      name: "Ouled Si Ahmed",
      postalCode: "724000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a1ab01af-1445-4f6a-ab86-b33652ee8c65",
      code: 725,
      name: "Ouled Tebben",
      postalCode: "725000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3149fecc-b7de-458a-8fff-101b6c7f0253",
      code: 726,
      name: "Rosfa",
      postalCode: "726000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f2c4947d-1f3d-425d-a809-170c93cc7f73",
      code: 727,
      name: "Salah Bey",
      postalCode: "727000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "933558ce-1bf6-4c4b-a4f1-558daa5e5e7b",
      code: 728,
      name: "Serdj-El-Ghoul",
      postalCode: "728000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4ecfb321-0c02-4391-b35f-c59672ebb364",
      code: 729,
      name: "Setif",
      postalCode: "729000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "67dcf4c1-c67d-4d0b-87e8-9d152336492e",
      code: 730,
      name: "Tachouda",
      postalCode: "730000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5771b298-50c8-4745-8700-95c10cf12ff8",
      code: 731,
      name: "Tala-Ifacene",
      postalCode: "731000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a97100d1-1642-434c-b0ed-837c3fcdc22f",
      code: 732,
      name: "Taya",
      postalCode: "732000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "934b69b4-31bd-4477-bd6a-b9d19487ad83",
      code: 733,
      name: "Tella",
      postalCode: "733000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c8a0c710-e237-4d55-92b8-42c623c7f590",
      code: 734,
      name: "Tizi N'bechar",
      postalCode: "734000",
      level: "commune",
      parentId: "56ee938d-7887-408e-8731-364d07ad3594",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3a7118e8-aabe-4096-a2d8-eba3ace094c9",
      code: 735,
      name: "Ain El Hadjar",
      postalCode: "735000",
      level: "commune",
      parentId: "27b2042a-77f8-4c91-b62d-60934fa0daca",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a64793dc-d307-4ec8-892d-4cfcfb0577ba",
      code: 736,
      name: "Ain Sekhouna",
      postalCode: "736000",
      level: "commune",
      parentId: "27b2042a-77f8-4c91-b62d-60934fa0daca",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a259e199-36cd-4a9b-a897-a5f55e2669dc",
      code: 737,
      name: "Ain Soltane",
      postalCode: "737000",
      level: "commune",
      parentId: "27b2042a-77f8-4c91-b62d-60934fa0daca",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "55c66eb9-1026-4ad7-a9a8-379dec3d7b8e",
      code: 738,
      name: "Doui Thabet",
      postalCode: "738000",
      level: "commune",
      parentId: "27b2042a-77f8-4c91-b62d-60934fa0daca",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0844f12a-8ed8-44e1-bbaf-6431a122b6de",
      code: 739,
      name: "El Hassasna",
      postalCode: "739000",
      level: "commune",
      parentId: "27b2042a-77f8-4c91-b62d-60934fa0daca",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "996a492d-9061-4029-819c-793a4f2ad893",
      code: 740,
      name: "Hounet",
      postalCode: "740000",
      level: "commune",
      parentId: "27b2042a-77f8-4c91-b62d-60934fa0daca",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "afd38330-2c00-4626-a59d-a8e9ee0a8aff",
      code: 741,
      name: "Maamora",
      postalCode: "741000",
      level: "commune",
      parentId: "27b2042a-77f8-4c91-b62d-60934fa0daca",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "06ca5444-fa0f-4c9c-b3a9-b2dd70e8a741",
      code: 742,
      name: "Moulay Larbi",
      postalCode: "742000",
      level: "commune",
      parentId: "27b2042a-77f8-4c91-b62d-60934fa0daca",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b6ac24eb-201c-458c-82e1-406be2481040",
      code: 743,
      name: "Ouled Brahim",
      postalCode: "743000",
      level: "commune",
      parentId: "27b2042a-77f8-4c91-b62d-60934fa0daca",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "cc176402-3c0f-48d9-ac56-05a1ac4cc29d",
      code: 744,
      name: "Ouled Khaled",
      postalCode: "744000",
      level: "commune",
      parentId: "27b2042a-77f8-4c91-b62d-60934fa0daca",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "96f2733c-a1ac-40d7-9c64-21258d5ec29a",
      code: 745,
      name: "Saida",
      postalCode: "745000",
      level: "commune",
      parentId: "27b2042a-77f8-4c91-b62d-60934fa0daca",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "206f1ef8-3a63-447d-952b-79606b8ce8f3",
      code: 746,
      name: "Sidi Ahmed",
      postalCode: "746000",
      level: "commune",
      parentId: "27b2042a-77f8-4c91-b62d-60934fa0daca",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0efdcba3-2805-4470-9250-d059171c734e",
      code: 747,
      name: "Sidi Amar",
      postalCode: "747000",
      level: "commune",
      parentId: "27b2042a-77f8-4c91-b62d-60934fa0daca",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7f88c99d-0931-4035-85a4-8e24719c3c13",
      code: 748,
      name: "Sidi Boubekeur",
      postalCode: "748000",
      level: "commune",
      parentId: "27b2042a-77f8-4c91-b62d-60934fa0daca",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "72602a74-4048-4f80-8998-0d076838d511",
      code: 749,
      name: "Tircine",
      postalCode: "749000",
      level: "commune",
      parentId: "27b2042a-77f8-4c91-b62d-60934fa0daca",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "90268069-6658-4ea6-b835-f416ba0598f3",
      code: 750,
      name: "Youb",
      postalCode: "750000",
      level: "commune",
      parentId: "27b2042a-77f8-4c91-b62d-60934fa0daca",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "63147735-5b19-47cc-bb11-fcc7901fee5b",
      code: 751,
      name: "Ain Bouziane",
      postalCode: "751000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "671285e3-ef51-4461-b9c8-5488b0a03d76",
      code: 752,
      name: "Ain Charchar",
      postalCode: "752000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "bfac032f-3d69-4a13-a72f-c08b2341cf18",
      code: 753,
      name: "Ain Kechra",
      postalCode: "753000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0af3cfef-0eab-455b-8d78-fec491d2fbb0",
      code: 754,
      name: "Ain Zouit",
      postalCode: "754000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f40a6d43-72cf-4267-9ba9-2f97f516912d",
      code: 755,
      name: "Azzaba",
      postalCode: "755000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0d320ee3-668a-4381-9e3e-951c6897559d",
      code: 756,
      name: "Bekkouche Lakhdar",
      postalCode: "756000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "84e2a703-650d-48f0-9bdc-24e24dfa2768",
      code: 757,
      name: "Ben Azzouz",
      postalCode: "757000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3a91c3a5-64c8-4b7f-a3c5-e908d3842c34",
      code: 758,
      name: "Beni Bechir",
      postalCode: "758000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "619dc5e7-b9f8-4699-ac1b-f49b65f2823a",
      code: 759,
      name: "Beni Oulbane",
      postalCode: "759000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "99c40c2f-7d02-46bd-8c6a-6deb96b35b64",
      code: 760,
      name: "Beni Zid",
      postalCode: "760000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "917e1bd2-8a6e-4101-ba51-1a73f99000dd",
      code: 761,
      name: "Bin El Ouiden",
      postalCode: "761000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "13da1b6a-c236-48f7-bb99-85850b8c81a6",
      code: 762,
      name: "Bouchetata",
      postalCode: "762000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "061959ca-19d6-4614-baa7-30ee9216fbb6",
      code: 763,
      name: "Cheraia",
      postalCode: "763000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e1070a72-47ba-4186-8f07-88fd9aa7908c",
      code: 764,
      name: "Collo",
      postalCode: "764000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4c4c527d-d8ba-47ba-9aec-b7bec4915f33",
      code: 765,
      name: "Djendel Saadi Mohamed",
      postalCode: "765000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b21a500f-0e04-438d-9b53-dffe503b9d59",
      code: 766,
      name: "El Arrouch",
      postalCode: "766000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "96f6219b-12a5-474f-9749-88180b7c9a63",
      code: 767,
      name: "El Ghedir",
      postalCode: "767000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f6fef8a6-efa7-4b3b-be07-c70254927d1e",
      code: 768,
      name: "El Hadaiek",
      postalCode: "768000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "458a294f-daa0-491f-bc75-2004d73d05f8",
      code: 769,
      name: "El Marsa",
      postalCode: "769000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "21e0f67b-f07f-436d-a5e7-585af462f4ce",
      code: 770,
      name: "Emjez Edchich",
      postalCode: "770000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c596a9be-fe92-4b95-abea-d1f03e28592f",
      code: 771,
      name: "Es Sebt",
      postalCode: "771000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8054834e-3493-4b09-a8e3-88ba923c9031",
      code: 772,
      name: "Filfila",
      postalCode: "772000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5b514acd-953b-4f4c-999c-9e0204ce6962",
      code: 773,
      name: "Hammadi Krouma",
      postalCode: "773000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "722b62e2-b7c5-4cae-9270-223ae456f1b0",
      code: 774,
      name: "Kanoua",
      postalCode: "774000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f8964976-1762-4c14-973a-7ef4d96561d8",
      code: 775,
      name: "Kerkara",
      postalCode: "775000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a70c1243-e045-405b-bea3-dec063698ae6",
      code: 776,
      name: "Khenag Maoune",
      postalCode: "776000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6ebd2305-9a65-4ec1-b344-9af619fbd73d",
      code: 777,
      name: "Oued Zhour",
      postalCode: "777000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4efb789b-8ac5-4c37-8c97-45ab5b84dc75",
      code: 778,
      name: "Ouldja Boulbalout",
      postalCode: "778000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4c18de3c-eeac-4058-a414-b9d4a6997d80",
      code: 779,
      name: "Ouled Attia",
      postalCode: "779000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5dfeeeda-efea-435f-a885-972f02f87b39",
      code: 780,
      name: "Ouled Habbaba",
      postalCode: "780000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "26efec94-57a7-40db-a03a-29c073709da7",
      code: 781,
      name: "Oum Toub",
      postalCode: "781000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "297db5bc-5fde-49f7-b013-91bd7991e18b",
      code: 782,
      name: "Ramdane Djamel",
      postalCode: "782000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ef2b40ae-3441-4f59-a5a9-0068b735357f",
      code: 783,
      name: "Salah Bouchaour",
      postalCode: "783000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d825ef68-1836-48aa-9f97-ad4dd62c5da2",
      code: 784,
      name: "Sidi Mezghiche",
      postalCode: "784000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "60904459-b12f-4981-be5c-cb411be40939",
      code: 785,
      name: "Skikda",
      postalCode: "785000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0a423fd0-5c79-4b21-b07c-bbf24ab4d541",
      code: 786,
      name: "Tamalous",
      postalCode: "786000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "fff5c219-f3e4-4e3f-94db-ba685e74e463",
      code: 787,
      name: "Zerdezas",
      postalCode: "787000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3df10e9a-d38c-4acc-b21a-8f6cea1dacc9",
      code: 788,
      name: "Zitouna",
      postalCode: "788000",
      level: "commune",
      parentId: "a9df7e26-1086-4319-8a93-19969c99c89b",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b4d64f15-ce5d-42e5-86a6-344943b8b108",
      code: 789,
      name: "Ain El Berd",
      postalCode: "789000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1de681a9-3669-45fd-abf2-d7ac85308267",
      code: 790,
      name: "Ain Kada",
      postalCode: "790000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a35311fd-7f73-416c-b5df-af873ab4d846",
      code: 791,
      name: "Ain Thrid",
      postalCode: "791000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c65b8aa4-2f01-464d-b45c-33f80ee6ceb0",
      code: 792,
      name: "Ain Tindamine",
      postalCode: "792000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c72836ec-db3a-47e5-a6de-1a93ac4f317c",
      code: 793,
      name: "Ain- Adden",
      postalCode: "793000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "74c4be87-39f3-402f-94f8-854eb4e523fb",
      code: 794,
      name: "Amarnas",
      postalCode: "794000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3d97e17f-ccbf-4612-a0ef-d86cb8da55ad",
      code: 795,
      name: "Bedrabine El Mokrani",
      postalCode: "795000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2e91ef13-668f-4ddc-a340-ad0acc8c6073",
      code: 796,
      name: "Belarbi",
      postalCode: "796000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "de46b03f-4ad9-42b2-ba1d-65527280e37b",
      code: 797,
      name: "Ben Badis",
      postalCode: "797000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b10c6623-265c-47e9-97fb-179264287ef8",
      code: 798,
      name: "Benachiba Chelia",
      postalCode: "798000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "691d19f9-dc00-408f-bea4-bd225ed36863",
      code: 799,
      name: "Bir El Hammam",
      postalCode: "799000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a063d287-c851-4194-9907-77b5898a8d46",
      code: 800,
      name: "Boudjebaa El Bordj",
      postalCode: "800000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3f9435b3-0236-4490-a88f-94f3396944e3",
      code: 801,
      name: "Boukhanefis",
      postalCode: "801000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "607c8e1a-eaab-4b5b-9374-80d3dfb3788f",
      code: 802,
      name: "Chetouane Belaila",
      postalCode: "802000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d06b64cf-074b-4b56-a815-4c1aefe50405",
      code: 803,
      name: "Dhaya",
      postalCode: "803000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d56c0ed9-9d7b-4af4-a4bc-559110ceaac9",
      code: 804,
      name: "El Hacaiba",
      postalCode: "804000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6afc0e70-eecb-450d-b176-840d8184811a",
      code: 805,
      name: "Hassi Dahou",
      postalCode: "805000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "964b010d-d335-445f-b19f-83b8ac0db1d9",
      code: 806,
      name: "Hassi Zahana",
      postalCode: "806000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e08538d7-e689-420e-bca6-aedc77f6772c",
      code: 807,
      name: "Lamtar",
      postalCode: "807000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6cb97171-1d52-4bc1-9592-2512e06ebb2b",
      code: 808,
      name: "Makedra",
      postalCode: "808000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b8a1f16d-e9f6-445b-9aa7-d1f98d41789e",
      code: 809,
      name: "Marhoum",
      postalCode: "809000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1bd77432-e9fe-4c47-8dad-7d67c4eb8153",
      code: 810,
      name: "M'cid",
      postalCode: "810000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "dee0488b-89fe-49a9-867d-af90327c8ad4",
      code: 811,
      name: "Merine",
      postalCode: "811000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4cf191fb-5d1e-4406-aff7-826db8bd84fc",
      code: 812,
      name: "Mezaourou",
      postalCode: "812000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d9b58473-2eef-405f-b7bc-40d1904d2b39",
      code: 813,
      name: "Mostefa  Ben Brahim",
      postalCode: "813000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8a8ec89e-c6b0-456d-b5d0-15d07fa07b13",
      code: 814,
      name: "Moulay Slissen",
      postalCode: "814000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "73dfac5e-9483-4642-946c-cc5e93173100",
      code: 815,
      name: "Oued Sebaa",
      postalCode: "815000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1fda230b-05eb-46c7-abe0-df8b95f1ef7a",
      code: 816,
      name: "Oued Sefioun",
      postalCode: "816000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7f7b2d2b-e29c-46a1-a3bd-846c6bd16c18",
      code: 817,
      name: "Oued Taourira",
      postalCode: "817000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "248216bf-0dfa-40f9-853b-d5b4bcce170a",
      code: 818,
      name: "Ras El Ma",
      postalCode: "818000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "db893977-166b-4470-83f1-06ee99ecf6a8",
      code: 819,
      name: "Redjem Demouche",
      postalCode: "819000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "44bdc58a-c6de-462c-9f37-682a440baa52",
      code: 820,
      name: "Sehala Thaoura",
      postalCode: "820000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "22321bce-7543-424c-905a-b21d4cac18f1",
      code: 821,
      name: "Sfisef",
      postalCode: "821000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "83aa3a72-3d4d-44b9-a857-75a5d667d596",
      code: 822,
      name: "Sidi Ali Benyoub",
      postalCode: "822000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "55d30e29-7401-4c37-84b4-81c2a9e27d0d",
      code: 823,
      name: "Sidi Ali Boussidi",
      postalCode: "823000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "25a2fad5-86bf-49a0-a589-4c17bf45eed5",
      code: 824,
      name: "Sidi Bel-Abbes",
      postalCode: "824000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "23f9ac66-62a9-4f76-b500-afe1440f6536",
      code: 825,
      name: "Sidi Brahim",
      postalCode: "825000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0d1ee09d-45cf-4164-9171-f348e5a3a223",
      code: 826,
      name: "Sidi Chaib",
      postalCode: "826000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6de3865a-93c9-40a9-96f2-0df93b4b6fa2",
      code: 827,
      name: "Sidi Dahou Zairs",
      postalCode: "827000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "fbec9e98-4b5b-4c42-902d-56000172a82c",
      code: 828,
      name: "Sidi Hamadouche",
      postalCode: "828000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c35c9ad8-a1d0-4046-8024-bebfcd9539be",
      code: 829,
      name: "Sidi Khaled",
      postalCode: "829000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "432dfe75-39d7-45d5-9a45-a21638326576",
      code: 830,
      name: "Sidi Lahcene",
      postalCode: "830000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c29ca49c-2f09-4b54-8c64-6782e1a95d43",
      code: 831,
      name: "Sidi Yacoub",
      postalCode: "831000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7ab99ba1-5288-4305-aade-95193431e0f9",
      code: 832,
      name: "Tabia",
      postalCode: "832000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3e3530f9-f5dd-42a0-869b-2bc5d6934efe",
      code: 833,
      name: "Taoudmout",
      postalCode: "833000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "909f25fa-cd14-4312-a068-414a9e6874bd",
      code: 834,
      name: "Tefessour",
      postalCode: "834000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6bc57e11-05f5-475a-8f0a-1dd931fec662",
      code: 835,
      name: "Teghalimet",
      postalCode: "835000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a1f569cf-df70-40e4-a601-e2f5e2797959",
      code: 836,
      name: "Telagh",
      postalCode: "836000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "46d04806-79bd-443c-9abe-90abd07cfa8b",
      code: 837,
      name: "Tenira",
      postalCode: "837000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "270e25c3-3aa5-45ef-8356-15ded7b5b90f",
      code: 838,
      name: "Tessala",
      postalCode: "838000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d9dc7c74-c916-4c0b-b9fe-f68ab8b17ecf",
      code: 839,
      name: "Tilmouni",
      postalCode: "839000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3f45e21a-d169-42e1-ae59-4b54edfb9cb4",
      code: 840,
      name: "Zerouala",
      postalCode: "840000",
      level: "commune",
      parentId: "2cec2b2a-cc37-480a-9183-59fdfdb65cd4",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "87513f21-5aa8-4854-a657-28ae9b91bd12",
      code: 841,
      name: "Ain El Berda",
      postalCode: "841000",
      level: "commune",
      parentId: "3fd318e8-7c24-480c-a106-21f6c842583d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2502606d-9da3-4a23-b502-5ef9ebc584eb",
      code: 842,
      name: "Annaba",
      postalCode: "842000",
      level: "commune",
      parentId: "3fd318e8-7c24-480c-a106-21f6c842583d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "da871166-80f7-4b9b-bd3a-e75ede3206e7",
      code: 843,
      name: "Berrahal",
      postalCode: "843000",
      level: "commune",
      parentId: "3fd318e8-7c24-480c-a106-21f6c842583d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7aea0a2e-41c0-4ca6-811c-bf58461aea5f",
      code: 844,
      name: "Chetaibi",
      postalCode: "844000",
      level: "commune",
      parentId: "3fd318e8-7c24-480c-a106-21f6c842583d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a0de1145-79bb-49a2-9744-0c218ce2c119",
      code: 845,
      name: "Cheurfa",
      postalCode: "845000",
      level: "commune",
      parentId: "3fd318e8-7c24-480c-a106-21f6c842583d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d8bf8ec0-8441-43d7-a7bd-df09f6821aed",
      code: 846,
      name: "El Bouni",
      postalCode: "846000",
      level: "commune",
      parentId: "3fd318e8-7c24-480c-a106-21f6c842583d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "199ae70d-f5cd-4776-8ee8-5d672fb87e34",
      code: 847,
      name: "El Eulma",
      postalCode: "847000",
      level: "commune",
      parentId: "3fd318e8-7c24-480c-a106-21f6c842583d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d3100549-3387-4593-99f0-bf03f3dab100",
      code: 848,
      name: "El Hadjar",
      postalCode: "848000",
      level: "commune",
      parentId: "3fd318e8-7c24-480c-a106-21f6c842583d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ee4dd723-e34c-4cea-9862-f01c2f447d11",
      code: 849,
      name: "Oued El Aneb",
      postalCode: "849000",
      level: "commune",
      parentId: "3fd318e8-7c24-480c-a106-21f6c842583d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e3121eae-bebc-471c-8a44-84b675bb42e7",
      code: 850,
      name: "Seraidi",
      postalCode: "850000",
      level: "commune",
      parentId: "3fd318e8-7c24-480c-a106-21f6c842583d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "90f3fc73-6fb5-49d6-87dd-bd49a7187276",
      code: 851,
      name: "Sidi Amar",
      postalCode: "851000",
      level: "commune",
      parentId: "3fd318e8-7c24-480c-a106-21f6c842583d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8befd98f-f6b0-4c3f-b4ce-faf437ade43e",
      code: 852,
      name: "Treat",
      postalCode: "852000",
      level: "commune",
      parentId: "3fd318e8-7c24-480c-a106-21f6c842583d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "caf8d454-8af1-4e2b-8c59-1c582881162b",
      code: 853,
      name: "Ain Ben Beida",
      postalCode: "853000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d618bfb2-a729-4e4f-916d-59ca0cf8cd5f",
      code: 854,
      name: "Ain Larbi",
      postalCode: "854000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4378455f-0fd8-4a04-832b-e1814aa1c997",
      code: 855,
      name: "Ain Makhlouf",
      postalCode: "855000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "52de75f8-11b8-423c-87b8-651e12aa8a08",
      code: 856,
      name: "Ain Regada",
      postalCode: "856000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a29f68d7-9eb9-4b36-b86f-4abf68b835b3",
      code: 857,
      name: "Ain Sandel",
      postalCode: "857000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b40e66dd-4e3a-4730-ac1e-cb5a6ba479ee",
      code: 858,
      name: "Belkheir",
      postalCode: "858000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ed28ed37-f1ba-4fd7-8bda-c727ca0a3a2e",
      code: 859,
      name: "Bendjarah",
      postalCode: "859000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9c563dc8-2186-4100-9b6f-c11fe352423a",
      code: 860,
      name: "Beni Mezline",
      postalCode: "860000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b933243e-175f-49ac-8920-dd18e06246a2",
      code: 861,
      name: "Bordj Sabath",
      postalCode: "861000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "960e5228-6484-4cef-922c-9642621a7198",
      code: 862,
      name: "Bou Hachana",
      postalCode: "862000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d1c77b7e-c919-4d01-97de-1cbe362e5838",
      code: 863,
      name: "Bou Hamdane",
      postalCode: "863000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0c136fee-f675-4f5e-b765-e305d80ce793",
      code: 864,
      name: "Bouati Mahmoud",
      postalCode: "864000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a7c8020c-516e-4d2d-b3ce-0992b8bb2ee2",
      code: 865,
      name: "Bouchegouf",
      postalCode: "865000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ec0528c2-4ee1-431f-a19a-f019c3ab45be",
      code: 866,
      name: "Boumahra Ahmed",
      postalCode: "866000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2846d70f-0e26-4d91-8c3f-72ff403dcc6f",
      code: 867,
      name: "Dahouara",
      postalCode: "867000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7b98a54a-0575-46e8-87cf-7549f68b11e3",
      code: 868,
      name: "Djeballah Khemissi",
      postalCode: "868000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "30e09463-a8ca-43e3-940a-002d4739d2c2",
      code: 869,
      name: "El Fedjoudj",
      postalCode: "869000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "57d3e4c2-dd1b-489c-b37d-e91c8f6397a4",
      code: 870,
      name: "Guelaat Bou Sbaa",
      postalCode: "870000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "97529486-399a-4020-834e-510eb0b4b905",
      code: 871,
      name: "Guelma",
      postalCode: "871000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2e7970e4-81cc-43d9-a50f-c0221eabae6f",
      code: 872,
      name: "Hammam Debagh",
      postalCode: "872000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ec389b6c-d1eb-474b-8e09-7d43ddec877f",
      code: 873,
      name: "Hammam N'bail",
      postalCode: "873000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8a8bcb77-a597-499c-a1f0-9665e7b11d82",
      code: 874,
      name: "Heliopolis",
      postalCode: "874000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "754947d8-a885-4236-a9af-f92d75f6244e",
      code: 875,
      name: "Nechmaya",
      postalCode: "875000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e88b288f-7968-4ace-a598-12cc305533f8",
      code: 876,
      name: "Khezaras",
      postalCode: "876000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f0835646-e309-4d8b-8294-b0bffe0d7611",
      code: 877,
      name: "Medjez Amar",
      postalCode: "877000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e909699a-56f2-4eb6-9879-2b82e593123c",
      code: 878,
      name: "Medjez Sfa",
      postalCode: "878000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "bdc0d559-c0dc-4cab-b743-a3c3e35d6197",
      code: 879,
      name: "Houari Boumedienne",
      postalCode: "879000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b7eb9a21-ee38-41e1-9976-5d1aad94ebdf",
      code: 880,
      name: "Oued Cheham",
      postalCode: "880000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "692c830c-5e8e-4ad8-b887-caf34f8e317b",
      code: 881,
      name: "Oued Ferragha",
      postalCode: "881000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "154fc8ef-f45e-444b-9bef-43176c591627",
      code: 882,
      name: "Oued Zenati",
      postalCode: "882000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ecc61d05-ec6c-4601-aec8-5a19b2f74a24",
      code: 883,
      name: "Ras El Agba",
      postalCode: "883000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "678af5ad-00cf-4504-b1c2-775ef5faf3bf",
      code: 884,
      name: "Roknia",
      postalCode: "884000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "fbe48dc5-dfc7-472b-a176-bf75e2c6f8d4",
      code: 885,
      name: "Sellaoua Announa",
      postalCode: "885000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a4eb840c-93cd-4672-8a28-4c5c1076fba1",
      code: 886,
      name: "Tamlouka",
      postalCode: "886000",
      level: "commune",
      parentId: "2d1e61ff-e2af-4b4d-a592-0a6436c5fffd",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "58050f9a-284e-4fca-b5f5-8234617bc7e2",
      code: 887,
      name: "Ain Abid",
      postalCode: "887000",
      level: "commune",
      parentId: "e9a1e9cf-8475-4768-94cc-0888d094ff47",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "692fa553-6835-476a-bd84-63777da38fcf",
      code: 888,
      name: "Ain Smara",
      postalCode: "888000",
      level: "commune",
      parentId: "e9a1e9cf-8475-4768-94cc-0888d094ff47",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "83839eca-d473-4f51-bb69-0ac8fef0a700",
      code: 889,
      name: "Ben Badis",
      postalCode: "889000",
      level: "commune",
      parentId: "e9a1e9cf-8475-4768-94cc-0888d094ff47",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "bbe82c4e-e72b-4fc6-a604-7962c4757f6f",
      code: 890,
      name: "Beni Hamidane",
      postalCode: "890000",
      level: "commune",
      parentId: "e9a1e9cf-8475-4768-94cc-0888d094ff47",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "62ad6630-4eb8-4c51-85b7-8802b562ddc3",
      code: 891,
      name: "Constantine",
      postalCode: "891000",
      level: "commune",
      parentId: "e9a1e9cf-8475-4768-94cc-0888d094ff47",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "69c44c53-2bb7-44fd-a074-97a500a28511",
      code: 892,
      name: "Didouche Mourad",
      postalCode: "892000",
      level: "commune",
      parentId: "e9a1e9cf-8475-4768-94cc-0888d094ff47",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "07eb43c2-c141-48cd-8334-661717d8d3f0",
      code: 893,
      name: "El Khroub",
      postalCode: "893000",
      level: "commune",
      parentId: "e9a1e9cf-8475-4768-94cc-0888d094ff47",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "52dc3a6b-19be-4510-8544-0b947c7d331e",
      code: 894,
      name: "Hamma Bouziane",
      postalCode: "894000",
      level: "commune",
      parentId: "e9a1e9cf-8475-4768-94cc-0888d094ff47",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "58bbb055-1dd1-4641-b951-60a464d91b04",
      code: 895,
      name: "Ibn Ziad",
      postalCode: "895000",
      level: "commune",
      parentId: "e9a1e9cf-8475-4768-94cc-0888d094ff47",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "eb4514a0-c692-4fd8-922e-488a61f29b2f",
      code: 896,
      name: "Messaoud Boudjeriou",
      postalCode: "896000",
      level: "commune",
      parentId: "e9a1e9cf-8475-4768-94cc-0888d094ff47",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "fddb0a7e-fe60-4841-a072-22a10b417835",
      code: 897,
      name: "Ouled Rahmoun",
      postalCode: "897000",
      level: "commune",
      parentId: "e9a1e9cf-8475-4768-94cc-0888d094ff47",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f7841a41-1023-46fe-a2ed-eb54b3a6504c",
      code: 898,
      name: "Zighoud Youcef",
      postalCode: "898000",
      level: "commune",
      parentId: "e9a1e9cf-8475-4768-94cc-0888d094ff47",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d88005df-fe0f-4154-b21e-11e1e3f32849",
      code: 899,
      name: "Ain Boucif",
      postalCode: "899000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "20bad11c-3a4e-42c0-86e0-21afd28b249c",
      code: 900,
      name: "Ain Ouksir",
      postalCode: "900000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "87a11673-1a2f-4e3b-b68c-629af666c902",
      code: 901,
      name: "Aissaouia",
      postalCode: "901000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "aa40d2ed-389e-46ae-8f5c-3cff16050b83",
      code: 902,
      name: "Aziz",
      postalCode: "902000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "477cb38f-87be-49bf-af01-28558c00fbdb",
      code: 903,
      name: "Baata",
      postalCode: "903000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2a96d9a8-636d-469d-bf40-5b25def92e85",
      code: 904,
      name: "Ben Chicao",
      postalCode: "904000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "583bea30-3523-4cff-b28c-90159a2997b7",
      code: 905,
      name: "Beni Slimane",
      postalCode: "905000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ad23d863-371f-417b-ad15-e6de05ec4baa",
      code: 906,
      name: "Berrouaghia",
      postalCode: "906000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "33bebd53-98e3-4b36-aa08-8f085769ff46",
      code: 907,
      name: "Bir Ben Laabed",
      postalCode: "907000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "db211bee-0fcc-4859-9ab7-e7414ccf1087",
      code: 908,
      name: "Boghar",
      postalCode: "908000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b934deeb-113d-4fb4-8103-5051638438a9",
      code: 909,
      name: "Bouaiche",
      postalCode: "909000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "21d05e88-26b9-4173-8ecb-90f8a85639ec",
      code: 910,
      name: "Bouaichoune",
      postalCode: "910000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b344cd56-8e98-4a08-bd27-5e07f75622d2",
      code: 911,
      name: "Bouchrahil",
      postalCode: "911000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "22c14da8-339f-4558-a046-a69b0746385e",
      code: 912,
      name: "Boughzoul",
      postalCode: "912000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5f1f8833-5efc-471c-b13b-a196cf7cf14e",
      code: 913,
      name: "Bouskene",
      postalCode: "913000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "821b0ca9-527d-47ce-b99f-6975b4f2c6aa",
      code: 914,
      name: "Chabounia",
      postalCode: "914000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "bbcb5320-3659-45a6-b535-09c7eb687032",
      code: 915,
      name: "Chelalet El Adhaoura",
      postalCode: "915000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b0ec9cb3-a770-40fd-ad73-e350a1001a5f",
      code: 916,
      name: "Cheniguel",
      postalCode: "916000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d9390689-a991-4e90-ac14-6a0f6a390826",
      code: 917,
      name: "Derrag",
      postalCode: "917000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "466d9c40-d4e9-46b6-971b-c8eff8465009",
      code: 918,
      name: "Djouab",
      postalCode: "918000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ca9efdac-2188-4581-ac92-178e61dbda2e",
      code: 919,
      name: "Draa Esmar",
      postalCode: "919000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d5967b7f-fd4f-4bd1-ac56-1ff388e091c8",
      code: 920,
      name: "El Azizia",
      postalCode: "920000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e1491ba7-4a69-4274-821a-1142942850c4",
      code: 921,
      name: "El Guelbelkebir",
      postalCode: "921000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9b9ecf3b-602f-4042-ab8c-928933df288f",
      code: 922,
      name: "El Hamdania",
      postalCode: "922000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "cab14803-1fba-4247-aa5b-8891f6f30579",
      code: 923,
      name: "El Haoudane",
      postalCode: "923000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ac866a30-1f1a-41ac-8999-b424df633f83",
      code: 924,
      name: "El Omaria",
      postalCode: "924000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9ce34166-3bc2-46e9-b756-4e4473c5329a",
      code: 925,
      name: "El Ouinet",
      postalCode: "925000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b1f8ab59-e8a5-450c-ad24-ee08b133aff4",
      code: 926,
      name: "Hannacha",
      postalCode: "926000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ba400a41-0151-4bf5-805d-2cdd799f9ad0",
      code: 927,
      name: "Kef Lakhdar",
      postalCode: "927000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5fe58113-73bd-4455-ac49-8d8f7431e4a6",
      code: 928,
      name: "Khams Djouamaa",
      postalCode: "928000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "915b57fd-cce7-4dca-9d6e-cb95ff21f605",
      code: 929,
      name: "Ksar El Boukhari",
      postalCode: "929000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6d0da3a2-e09b-4071-82c2-c3e4685b6bd8",
      code: 930,
      name: "Maghraoua",
      postalCode: "930000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "60f4499d-cead-453c-bc3a-5b19201d2627",
      code: 931,
      name: "Medea",
      postalCode: "931000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0ed5585e-ff85-4561-8244-e301a7e1fe76",
      code: 932,
      name: "Medjebar",
      postalCode: "932000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6aa738f6-d8aa-4fad-8541-d0338010bd69",
      code: 933,
      name: "Mezerana",
      postalCode: "933000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "94fac03b-9e48-43e1-bd6c-ddcbb53579c6",
      code: 934,
      name: "M'fatha",
      postalCode: "934000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5a4bcb0c-3b2f-41c6-965e-993ab0b60cf4",
      code: 935,
      name: "Mihoub",
      postalCode: "935000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c489a319-b08a-4c96-b60b-3da8e236de3f",
      code: 936,
      name: "Ouamri",
      postalCode: "936000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "532590d7-2d73-4a38-90d1-2c6261da6402",
      code: 937,
      name: "Oued Harbil",
      postalCode: "937000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f4af6720-a110-44e4-87a2-b4c3d98ad8ff",
      code: 938,
      name: "Ouled Antar",
      postalCode: "938000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4f956de9-1995-4cda-ac65-8fe3ccfaaa11",
      code: 939,
      name: "Ouled Bouachra",
      postalCode: "939000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b544e218-b0d6-49b4-b24a-9863cb32b930",
      code: 940,
      name: "Ouled Brahim",
      postalCode: "940000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "fe3dfd0d-c990-448d-b0eb-586d1a1c45c7",
      code: 941,
      name: "Ouled Deid",
      postalCode: "941000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "93d03b52-1316-4c79-be8f-3c9129e9a047",
      code: 942,
      name: "Ouled Emaaraf",
      postalCode: "942000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d642c3a5-4733-4aa8-a254-a00ba1908e11",
      code: 943,
      name: "Ouled Hellal",
      postalCode: "943000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "913a628e-e9bf-43a9-a16e-30ef447b0074",
      code: 944,
      name: "Oum El Djellil",
      postalCode: "944000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c4224090-4d03-49b3-9fc1-6af7ce639448",
      code: 945,
      name: "Ouzera",
      postalCode: "945000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "22104b79-cb2b-4a39-9436-3fbbfbc43f1b",
      code: 946,
      name: "Rebaia",
      postalCode: "946000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "10b059f5-b0a1-4332-a5f5-79a90105b268",
      code: 947,
      name: "Saneg",
      postalCode: "947000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6fc51630-b618-465f-a7be-646a82c3c349",
      code: 948,
      name: "Sedraya",
      postalCode: "948000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "556448e9-76a6-4832-81af-537717a44a4d",
      code: 949,
      name: "Seghouane",
      postalCode: "949000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b25369b0-32a0-43db-84f9-3403f26f8f7c",
      code: 950,
      name: "Si Mahdjoub",
      postalCode: "950000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4a9c0150-9773-4e94-a36c-13f87c9531de",
      code: 951,
      name: "Sidi Demed",
      postalCode: "951000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ce776f24-2384-4b4f-8694-b42e9b187768",
      code: 952,
      name: "Sidi Naamane",
      postalCode: "952000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a5d36518-4b81-4c73-8262-6ea7a16da69a",
      code: 953,
      name: "Sidi Rabie",
      postalCode: "953000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "44a66e1c-1c10-469e-a776-ba8e634a23ff",
      code: 954,
      name: "Sidi Zahar",
      postalCode: "954000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "54b8b9fb-d192-41a3-9e5b-fa653ae1b4c2",
      code: 955,
      name: "Sidi Ziane",
      postalCode: "955000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "72fe035a-8509-47ad-b94a-c63699de41b0",
      code: 956,
      name: "Souagui",
      postalCode: "956000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c00992bc-2cce-449f-ad22-6570f7d60a00",
      code: 957,
      name: "Tablat",
      postalCode: "957000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "352e5e62-8b32-4c58-b2e2-b9cf06162bc8",
      code: 958,
      name: "Tafraout",
      postalCode: "958000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "73e70f24-98f3-4971-93d2-1544e21b3a1e",
      code: 959,
      name: "Tamesguida",
      postalCode: "959000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "abe39925-edc8-4979-8f40-beb2752c2d55",
      code: 960,
      name: "Tizi Mahdi",
      postalCode: "960000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a951d103-9cc4-4e72-abb7-010344b4a1fd",
      code: 961,
      name: "Tletat Ed Douair",
      postalCode: "961000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7b322b02-6028-4507-bccb-c8022fe92ee8",
      code: 962,
      name: "Zoubiria",
      postalCode: "962000",
      level: "commune",
      parentId: "0e0f2d43-6d78-47dd-8bb7-0f2771cb97ff",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3ad9b6e7-5de7-4ed4-a0e8-e8395a2dec01",
      code: 963,
      name: "Achaacha",
      postalCode: "963000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "882d4151-7bad-4175-8b48-d2ee905af0ec",
      code: 964,
      name: "Ain-Boudinar",
      postalCode: "964000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "38e24819-502b-42c5-ac06-f94e41dfe477",
      code: 965,
      name: "Ain-Nouissy",
      postalCode: "965000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "46cc1dee-c764-4917-b6b1-c5415333677f",
      code: 966,
      name: "Ain-Sidi Cherif",
      postalCode: "966000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4cf36535-cdf8-48bf-b01d-3ecebbeeca32",
      code: 967,
      name: "Ain-Tedles",
      postalCode: "967000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8efff8ee-5507-48b5-9b39-1ace6e558aa2",
      code: 968,
      name: "Benabdelmalek Ramdane",
      postalCode: "968000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "488e6364-be1a-46ba-b29b-9681e22c142a",
      code: 969,
      name: "Bouguirat",
      postalCode: "969000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "684075e2-b3f3-4d16-8000-f87ced04c1bb",
      code: 970,
      name: "Fornaka",
      postalCode: "970000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4d6b7a2b-f9ed-4cbd-81ef-0c21d79ff5ac",
      code: 971,
      name: "Hadjadj",
      postalCode: "971000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "49794495-d49d-4634-828e-df17c406b4f4",
      code: 972,
      name: "Hassi Mameche",
      postalCode: "972000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "00de4a9d-6350-4d23-bae4-f9951f663884",
      code: 973,
      name: "Hassiane",
      postalCode: "973000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8325e645-cd34-4f7a-b7f9-0e9db94f6851",
      code: 974,
      name: "Khadra",
      postalCode: "974000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "26778095-61af-4f5d-9ccf-373e9edc6f37",
      code: 975,
      name: "Kheir-Eddine",
      postalCode: "975000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "22720961-8611-4997-8c83-652d2e377b04",
      code: 976,
      name: "Mansourah",
      postalCode: "976000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0c5d4839-6f9a-4ff8-af6a-e5ff1a641a62",
      code: 977,
      name: "Mazagran",
      postalCode: "977000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f99b838c-be56-4780-9a0c-f5c5c963979e",
      code: 978,
      name: "Mesra",
      postalCode: "978000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8e6d1e0e-6687-42d9-88c5-fd880db27145",
      code: 979,
      name: "Mostaganem",
      postalCode: "979000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d4f6424e-72d0-4e33-9a33-02264c3e4a1d",
      code: 980,
      name: "Nekmaria",
      postalCode: "980000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b52ac4eb-35b8-4727-bad3-63b72d7c45b3",
      code: 981,
      name: "Oued El Kheir",
      postalCode: "981000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ee512832-3f07-4b2f-85ac-7ac0815ab9ef",
      code: 982,
      name: "Ouled Boughalem",
      postalCode: "982000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e0b043a6-5c54-418a-8716-616afa83272e",
      code: 983,
      name: "Ouled-Maalah",
      postalCode: "983000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c8f18efa-9690-496a-81b5-86b19aa93ba7",
      code: 984,
      name: "Safsaf",
      postalCode: "984000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1c4838c0-6842-479f-a2fd-7b6e7f9923a6",
      code: 985,
      name: "Sayada",
      postalCode: "985000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5e289c66-8b28-4652-900a-8901b135b124",
      code: 986,
      name: "Sidi Ali",
      postalCode: "986000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "25f962b6-3d17-40d2-b3cb-bdde8578ab3d",
      code: 987,
      name: "Sidi Belaattar",
      postalCode: "987000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a99f1ede-5332-4699-9a42-5787e210756f",
      code: 988,
      name: "Sidi-Lakhdar",
      postalCode: "988000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8d258577-4bbe-4dfc-9bcd-b7bba0a857f3",
      code: 989,
      name: "Sirat",
      postalCode: "989000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "22ed5a19-fef7-47c9-a573-07c9c1d32060",
      code: 990,
      name: "Souaflia",
      postalCode: "990000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "66597f85-ab55-4ee5-8247-73b8b2914c61",
      code: 991,
      name: "Sour",
      postalCode: "991000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "35d180ce-eeb1-4903-9c3b-2c5034f51770",
      code: 992,
      name: "Stidia",
      postalCode: "992000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8b31236c-fb58-4b57-ae8c-db49767f3a01",
      code: 993,
      name: "Tazgait",
      postalCode: "993000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ebe71c99-98be-48ff-b753-dffc6de1bff5",
      code: 994,
      name: "Touahria",
      postalCode: "994000",
      level: "commune",
      parentId: "d7175ca6-6dd7-4dfb-a399-d388e782473a",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ea91a704-20ff-4894-90b0-f3a66f7b0e3c",
      code: 995,
      name: "Ain El Hadjel",
      postalCode: "995000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c56be9a2-e577-4d0e-876a-1d1c07a75140",
      code: 996,
      name: "Ain El Melh",
      postalCode: "996000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d6456fcb-8ef0-449f-b838-3dc2c2fba257",
      code: 997,
      name: "Ain Fares",
      postalCode: "997000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "56609c0f-ee67-492d-8f8a-f8d16d323fbb",
      code: 998,
      name: "Ain Khadra",
      postalCode: "998000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "864ab6ef-4eb4-4e52-94ec-f60f455f2492",
      code: 999,
      name: "Ain Rich",
      postalCode: "999000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "90713ca9-6ab3-4f33-9b25-cecb8a5906a6",
      code: 1000,
      name: "Belaiba",
      postalCode: "1000000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "afa3cff2-b9bb-4183-aabb-a068a96f339f",
      code: 1001,
      name: "Ben Srour",
      postalCode: "1001000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "43eae687-31d3-4777-89c3-781cb1c98a4a",
      code: 1002,
      name: "Beni Ilmane",
      postalCode: "1002000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a6153ce7-6060-4809-901a-587f7c927ddb",
      code: 1003,
      name: "Benzouh",
      postalCode: "1003000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1e5471d0-05ec-4afd-b9b4-2ce17417a994",
      code: 1004,
      name: "Berhoum",
      postalCode: "1004000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "41cae774-8795-4591-af60-b2c020194ec0",
      code: 1005,
      name: "Bir Foda",
      postalCode: "1005000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1dfbaa3d-3222-4125-b19c-8cd4fe996a3b",
      code: 1006,
      name: "Bou Saada",
      postalCode: "1006000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "85152552-0dcd-4a13-84a6-945e912ae0d9",
      code: 1007,
      name: "Bouti Sayeh",
      postalCode: "1007000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "135143e4-634f-4d71-bb67-1260c69e1c36",
      code: 1008,
      name: "Chellal",
      postalCode: "1008000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0c9a652f-9c89-4193-8291-08bb399d0b7e",
      code: 1009,
      name: "Dehahna",
      postalCode: "1009000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "fab0e0f7-eb0d-4760-8668-fb995b2e0b69",
      code: 1010,
      name: "Djebel Messaad",
      postalCode: "1010000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5e19bfae-03ac-4d9f-ad66-8554f4236f57",
      code: 1011,
      name: "El Hamel",
      postalCode: "1011000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e9f4c18d-1b37-4134-bbd8-d490de7f7a92",
      code: 1012,
      name: "El Houamed",
      postalCode: "1012000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c3489146-ba18-4c82-9e35-314e4818e465",
      code: 1013,
      name: "Hammam Dalaa",
      postalCode: "1013000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "399dbc2b-6c3c-41ee-8964-3e7298d3fde5",
      code: 1014,
      name: "Khettouti Sed-El-Jir",
      postalCode: "1014000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1aaa3ebd-fdf3-4755-890b-bdafb5f3a4f1",
      code: 1015,
      name: "Khoubana",
      postalCode: "1015000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f4584483-f1a8-4886-8c58-13a2636b68fe",
      code: 1016,
      name: "Maadid",
      postalCode: "1016000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ffba089c-8651-46c8-b7a7-73f36c0ae338",
      code: 1017,
      name: "Maarif",
      postalCode: "1017000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "cc5be4b6-48d9-4871-a464-f69d5736d0a3",
      code: 1018,
      name: "Magra",
      postalCode: "1018000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6e61cd9a-a92d-42bc-b471-ea547512ca8a",
      code: 1019,
      name: "M'cif",
      postalCode: "1019000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8c02bb5f-3a2e-4151-a8b3-14055fba16c3",
      code: 1020,
      name: "Medjedel",
      postalCode: "1020000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "88b46e1f-de32-485d-9e95-6467839760e8",
      code: 1021,
      name: "Menaa",
      postalCode: "1021000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ed1407b1-710d-40b0-9cd5-5d2b27791b5a",
      code: 1022,
      name: "Mohamed Boudiaf",
      postalCode: "1022000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6e2e1a3b-41c2-4dff-840e-3bee147a511c",
      code: 1023,
      name: "M'sila",
      postalCode: "1023000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "36e80155-c9d3-4635-bc5f-5dde276ca8ac",
      code: 1024,
      name: "M'tarfa",
      postalCode: "1024000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e270f065-29d9-4f9b-ae0f-df2e5d0b0c1e",
      code: 1025,
      name: "Ouanougha",
      postalCode: "1025000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "96bbb4f4-8f1b-4022-af5c-2ba2fb7822d2",
      code: 1026,
      name: "Ouled Addi Guebala",
      postalCode: "1026000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1d0153ae-f594-4ce0-a001-6350b5a1b83a",
      code: 1027,
      name: "Ouled Derradj",
      postalCode: "1027000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a70eee09-8b97-4da7-a71a-747e4be0164f",
      code: 1028,
      name: "Ouled Madhi",
      postalCode: "1028000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "13951668-9f92-432d-8a8a-723d32ddf20c",
      code: 1029,
      name: "Ouled Mansour",
      postalCode: "1029000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b7a6e1d5-d189-44d6-aee6-a1f36f9d2745",
      code: 1030,
      name: "Ouled Sidi Brahim",
      postalCode: "1030000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ab2f23e6-3c00-4601-acf1-86cb85b6c450",
      code: 1031,
      name: "Ouled Slimane",
      postalCode: "1031000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "be1c92b3-a56d-421b-9a83-a25bfee89c98",
      code: 1032,
      name: "Oulteme",
      postalCode: "1032000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "461039f6-bade-4315-810d-f3c953f349d4",
      code: 1033,
      name: "Sidi Aissa",
      postalCode: "1033000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ef039d13-e522-4815-b97e-e900adca5443",
      code: 1034,
      name: "Sidi Ameur",
      postalCode: "1034000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f9b9d40f-6181-49cc-bc56-a4439b9f763f",
      code: 1035,
      name: "Sidi Hadjeres",
      postalCode: "1035000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4ffc9b66-4d9d-41a2-8ae5-9f19ea860669",
      code: 1036,
      name: "Sidi M'hamed",
      postalCode: "1036000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "953c6323-be72-4577-861e-7246f82fc563",
      code: 1037,
      name: "Slim",
      postalCode: "1037000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6a469732-2fc2-4932-99a8-7ee6fec477e9",
      code: 1038,
      name: "Souamaa",
      postalCode: "1038000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "29af778d-db83-477b-a7d9-64b49ff450cf",
      code: 1039,
      name: "Tamsa",
      postalCode: "1039000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "58dccca0-7c84-41b3-b0a2-0649f95d5d93",
      code: 1040,
      name: "Tarmount",
      postalCode: "1040000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6d8aad2f-5c00-4fcf-8bd6-2b4611122558",
      code: 1041,
      name: "Zarzour",
      postalCode: "1041000",
      level: "commune",
      parentId: "75ca308d-ab36-44e2-9702-2e2300a57b8c",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "92685c61-8b7a-43f4-a17f-e2a784acb432",
      code: 1042,
      name: "Ain Fares",
      postalCode: "1042000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "05470409-2767-4698-aec2-166b3d181470",
      code: 1043,
      name: "Ain Fekan",
      postalCode: "1043000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "88209170-68a5-40bc-a8ee-3e9245f16bf9",
      code: 1044,
      name: "Ain Ferah",
      postalCode: "1044000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d3a1a7f0-46ca-4fa2-97dd-99636da62aa3",
      code: 1045,
      name: "Ain Frass",
      postalCode: "1045000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "35df3755-0a86-4822-b313-acb43837eaa4",
      code: 1046,
      name: "Alaimia",
      postalCode: "1046000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "fa2c5481-00fe-4e12-995f-f44245dd8d5b",
      code: 1047,
      name: "Aouf",
      postalCode: "1047000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "07a5de6e-6f25-4213-9823-cbc3eb8ada13",
      code: 1048,
      name: "Benian",
      postalCode: "1048000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4063db3f-1ae2-4b4c-a48e-07c244e39952",
      code: 1049,
      name: "Bou Henni",
      postalCode: "1049000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "729f77d9-de05-4a0d-8f38-a85d381f7224",
      code: 1050,
      name: "Bouhanifia",
      postalCode: "1050000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3bfb1765-92b6-4f72-b44c-a23f7f3fc0cd",
      code: 1051,
      name: "Chorfa",
      postalCode: "1051000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "76ec1d81-c6b1-4388-af6b-c92851870041",
      code: 1052,
      name: "El Bordj",
      postalCode: "1052000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "040c4b19-b618-4f2a-b3a4-95b547df7fd1",
      code: 1053,
      name: "El Gaada",
      postalCode: "1053000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4364b3cc-094b-4596-8c58-0373836bc478",
      code: 1054,
      name: "El Ghomri",
      postalCode: "1054000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c73fb1e8-9a9c-455d-972c-0c3e3b9fcd1b",
      code: 1055,
      name: "El Gueitena",
      postalCode: "1055000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "07d923f0-c785-43be-8bc7-e14697da36e1",
      code: 1056,
      name: "El Hachem",
      postalCode: "1056000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2d8fabd5-0057-4d67-ae72-1d240808204e",
      code: 1057,
      name: "El Keurt",
      postalCode: "1057000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6ce5c24b-0213-422c-a679-64c9089a58a2",
      code: 1058,
      name: "El Mamounia",
      postalCode: "1058000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "74d15ac6-e5d0-4634-a851-50e3f9a01b2b",
      code: 1059,
      name: "El Menaouer",
      postalCode: "1059000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "26c5948d-d46f-4705-8f9e-c3ca352b36a9",
      code: 1060,
      name: "Ferraguig",
      postalCode: "1060000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "255b88cd-9bbb-4cda-ae8d-8eb5085383b7",
      code: 1061,
      name: "Froha",
      postalCode: "1061000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "72a22407-677a-4a75-903e-655a3a508a5b",
      code: 1062,
      name: "Gharrous",
      postalCode: "1062000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9111b643-5279-4beb-94a6-7b05e97f9af6",
      code: 1063,
      name: "Ghriss",
      postalCode: "1063000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d8e1afe0-f521-4c0c-8a64-da7dd058cfa4",
      code: 1064,
      name: "Guerdjoum",
      postalCode: "1064000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2951b799-574b-4ca7-94f8-f25a4806aea9",
      code: 1065,
      name: "Hacine",
      postalCode: "1065000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "914cbbe7-af5f-4da7-9665-56a7588f068d",
      code: 1066,
      name: "Khalouia",
      postalCode: "1066000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "730ff2f7-8c61-4b6b-bc51-37a58a4c1b8d",
      code: 1067,
      name: "Makhda",
      postalCode: "1067000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "48b69301-0025-47c1-a0c8-770c11fe29a1",
      code: 1068,
      name: "Maoussa",
      postalCode: "1068000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "85739045-b15e-42be-8512-2e25b371e6d1",
      code: 1069,
      name: "Mascara",
      postalCode: "1069000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "44de7903-f316-4210-8b73-ae7b7491669e",
      code: 1070,
      name: "Matemore",
      postalCode: "1070000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "46d9b3ee-9379-45b1-b9ff-e4ef58df4455",
      code: 1071,
      name: "Mocta-Douz",
      postalCode: "1071000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "61e304f8-c02d-4d89-bbe3-8d2695afaf12",
      code: 1072,
      name: "Mohammadia",
      postalCode: "1072000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1ffa1ca2-1fb8-4dab-b69e-6aa6f8fdfd6b",
      code: 1073,
      name: "Nesmot",
      postalCode: "1073000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ec2a3821-e93d-4ba1-9d3f-4c5ddf28db98",
      code: 1074,
      name: "Oggaz",
      postalCode: "1074000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "552ff12d-c901-48ea-8b40-d152bf2b0f32",
      code: 1075,
      name: "Oued El Abtal",
      postalCode: "1075000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "58c29d29-103c-453c-84cc-3330c6d13da8",
      code: 1076,
      name: "Oued Taria",
      postalCode: "1076000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9a06fa7b-b6ab-421f-8ed0-7d01cf123ffb",
      code: 1077,
      name: "Ras El Ain Amirouche",
      postalCode: "1077000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "99768bf1-ce5b-4aae-8095-eb13f6fa8d0b",
      code: 1078,
      name: "Sedjerara",
      postalCode: "1078000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f3eea1ed-75d1-4283-b0b6-2e090ed4bb84",
      code: 1079,
      name: "Sehailia",
      postalCode: "1079000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6723d0a8-410f-4d58-921b-1954f68d2950",
      code: 1080,
      name: "Sidi Abdeldjebar",
      postalCode: "1080000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "53536ed8-0786-4774-851f-722c29060b05",
      code: 1081,
      name: "Sidi Abdelmoumene",
      postalCode: "1081000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c72f8cc7-0c5e-4894-9a79-3edae8704d50",
      code: 1082,
      name: "Sidi Boussaid",
      postalCode: "1082000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "91ad4f12-590e-47f4-8c79-db3ca0cfe7e3",
      code: 1083,
      name: "Sidi Kada",
      postalCode: "1083000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e2de74e3-9111-43c5-9178-954fa94a6869",
      code: 1084,
      name: "Sig",
      postalCode: "1084000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "63ba4333-4148-4c0a-8da8-8f942e2cecd0",
      code: 1085,
      name: "Tighennif",
      postalCode: "1085000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "07f12615-09d9-4c9c-ab23-bda3280cffff",
      code: 1086,
      name: "Tizi",
      postalCode: "1086000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "92e94839-b1d6-4e9f-8aaa-3f399d0b2e11",
      code: 1087,
      name: "Zahana",
      postalCode: "1087000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "dbc0a912-40d7-4e5d-9107-992f34f5b601",
      code: 1088,
      name: "Zelamta",
      postalCode: "1088000",
      level: "commune",
      parentId: "a17a6482-3f48-4948-aaf2-8a653c4c1110",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "99d3dde3-8e1e-49f4-bdfb-5fa5bfa71930",
      code: 1089,
      name: "Ain Beida",
      postalCode: "1089000",
      level: "commune",
      parentId: "ada333a0-708d-476e-a97d-fd70fe661b09",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ad7acf9e-7a5d-487a-a0c5-7c4541db477f",
      code: 1090,
      name: "Benaceur",
      postalCode: "1090000",
      level: "commune",
      parentId: "442d8a1c-2e12-4a8a-9c7e-8618aac20280",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b255c07e-bc6f-4cb2-8bb2-0f1a6dbb4858",
      code: 1091,
      name: "Blidet Amor",
      postalCode: "1091000",
      level: "commune",
      parentId: "442d8a1c-2e12-4a8a-9c7e-8618aac20280",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "919c3384-d79d-46ea-8072-574208297611",
      code: 1092,
      name: "El Alia",
      postalCode: "1092000",
      level: "commune",
      parentId: "442d8a1c-2e12-4a8a-9c7e-8618aac20280",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ba74b2cd-5587-4af0-be9a-b28af5112d16",
      code: 1093,
      name: "El Borma",
      postalCode: "1093000",
      level: "commune",
      parentId: "ada333a0-708d-476e-a97d-fd70fe661b09",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8afbc70f-c1e5-4d59-97da-e235a0a7295b",
      code: 1094,
      name: "El-Hadjira",
      postalCode: "1094000",
      level: "commune",
      parentId: "442d8a1c-2e12-4a8a-9c7e-8618aac20280",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "652241bf-96ad-4bd4-9c16-37c27c80fdf5",
      code: 1095,
      name: "Hassi Ben Abdellah",
      postalCode: "1095000",
      level: "commune",
      parentId: "ada333a0-708d-476e-a97d-fd70fe661b09",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4c482c26-4bc3-4ccc-8034-c6acb036f0d8",
      code: 1096,
      name: "Hassi Messaoud",
      postalCode: "1096000",
      level: "commune",
      parentId: "ada333a0-708d-476e-a97d-fd70fe661b09",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c1baa34c-efdb-48c5-8877-1e6b376a1eca",
      code: 1097,
      name: "Megarine",
      postalCode: "1097000",
      level: "commune",
      parentId: "442d8a1c-2e12-4a8a-9c7e-8618aac20280",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "cc446925-83f1-4696-be6b-e1e9a5cf49b6",
      code: 1098,
      name: "M'naguer",
      postalCode: "1098000",
      level: "commune",
      parentId: "442d8a1c-2e12-4a8a-9c7e-8618aac20280",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f0280de1-428a-4982-b0d7-af298b7e2f43",
      code: 1099,
      name: "Nezla",
      postalCode: "1099000",
      level: "commune",
      parentId: "442d8a1c-2e12-4a8a-9c7e-8618aac20280",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3169784f-d413-483e-92aa-6aaa540b0ec9",
      code: 1100,
      name: "N'goussa",
      postalCode: "1100000",
      level: "commune",
      parentId: "ada333a0-708d-476e-a97d-fd70fe661b09",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "afb70861-2255-45dc-a0ee-c2c94b5cf9ba",
      code: 1101,
      name: "Ouargla",
      postalCode: "1101000",
      level: "commune",
      parentId: "ada333a0-708d-476e-a97d-fd70fe661b09",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b0e0a757-e1f6-42e3-af4b-ab3ba1f4edc5",
      code: 1102,
      name: "Rouissat",
      postalCode: "1102000",
      level: "commune",
      parentId: "ada333a0-708d-476e-a97d-fd70fe661b09",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "51b68bb1-1f0b-42d6-8d2d-ad7e4830609f",
      code: 1103,
      name: "Sidi Khouiled",
      postalCode: "1103000",
      level: "commune",
      parentId: "ada333a0-708d-476e-a97d-fd70fe661b09",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d861b312-676f-4322-b53e-07f8839ffb71",
      code: 1104,
      name: "Sidi Slimane",
      postalCode: "1104000",
      level: "commune",
      parentId: "442d8a1c-2e12-4a8a-9c7e-8618aac20280",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c0a255ee-9f6c-4be2-8773-a0f59d88496d",
      code: 1105,
      name: "Taibet",
      postalCode: "1105000",
      level: "commune",
      parentId: "442d8a1c-2e12-4a8a-9c7e-8618aac20280",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "cce43555-728f-4308-a07e-9262f3c04015",
      code: 1106,
      name: "Tebesbest",
      postalCode: "1106000",
      level: "commune",
      parentId: "442d8a1c-2e12-4a8a-9c7e-8618aac20280",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9a9b6ecc-47a2-4eec-925c-a010272ec12d",
      code: 1107,
      name: "Temacine",
      postalCode: "1107000",
      level: "commune",
      parentId: "442d8a1c-2e12-4a8a-9c7e-8618aac20280",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d80ba60b-0e10-4c62-b63a-39f1da6e6755",
      code: 1108,
      name: "Touggourt",
      postalCode: "1108000",
      level: "commune",
      parentId: "442d8a1c-2e12-4a8a-9c7e-8618aac20280",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e06f2f3c-5e98-40bb-8def-2c15975e7c2d",
      code: 1109,
      name: "Zaouia El Abidia",
      postalCode: "1109000",
      level: "commune",
      parentId: "442d8a1c-2e12-4a8a-9c7e-8618aac20280",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9b2f9979-9870-4702-9f67-8a5f4efb5847",
      code: 1110,
      name: "Ain Biya",
      postalCode: "1110000",
      level: "commune",
      parentId: "e772eb46-276a-4f41-bae7-3b67e1bdc616",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b8aa215e-f321-4e2d-8c4b-ae5bf04f7b98",
      code: 1111,
      name: "Ain Kerma",
      postalCode: "1111000",
      level: "commune",
      parentId: "e772eb46-276a-4f41-bae7-3b67e1bdc616",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d925d8c3-f1f7-4009-931c-fdd5c59fe4f4",
      code: 1112,
      name: "Ain Turk",
      postalCode: "1112000",
      level: "commune",
      parentId: "e772eb46-276a-4f41-bae7-3b67e1bdc616",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d328c01c-3d5a-4e7e-ab13-f40445f8b23b",
      code: 1113,
      name: "Arzew",
      postalCode: "1113000",
      level: "commune",
      parentId: "e772eb46-276a-4f41-bae7-3b67e1bdc616",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "019a5f9a-6f1b-4d1c-8936-4fcfd4a5f567",
      code: 1114,
      name: "Ben Freha",
      postalCode: "1114000",
      level: "commune",
      parentId: "e772eb46-276a-4f41-bae7-3b67e1bdc616",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ba763684-9edd-4288-8a0a-51abc317448d",
      code: 1115,
      name: "Bethioua",
      postalCode: "1115000",
      level: "commune",
      parentId: "e772eb46-276a-4f41-bae7-3b67e1bdc616",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "27de8511-4e20-4e01-8a42-6c636cf8a3a1",
      code: 1116,
      name: "Bir El Djir",
      postalCode: "1116000",
      level: "commune",
      parentId: "e772eb46-276a-4f41-bae7-3b67e1bdc616",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e3429d9c-0aae-4c43-a537-d5d0d4eeed18",
      code: 1117,
      name: "Boufatis",
      postalCode: "1117000",
      level: "commune",
      parentId: "e772eb46-276a-4f41-bae7-3b67e1bdc616",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9a4786a2-094d-47f4-ac28-ed84df44079e",
      code: 1118,
      name: "Bousfer",
      postalCode: "1118000",
      level: "commune",
      parentId: "e772eb46-276a-4f41-bae7-3b67e1bdc616",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "568d078c-bef0-4fb2-84f6-b5d95f4520a3",
      code: 1119,
      name: "Boutlelis",
      postalCode: "1119000",
      level: "commune",
      parentId: "e772eb46-276a-4f41-bae7-3b67e1bdc616",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "837dd3c8-99ef-4796-8d81-d8a0064d786f",
      code: 1120,
      name: "El Ancor",
      postalCode: "1120000",
      level: "commune",
      parentId: "e772eb46-276a-4f41-bae7-3b67e1bdc616",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c725cd6b-94e6-419c-889f-ba1f83774259",
      code: 1121,
      name: "El Braya",
      postalCode: "1121000",
      level: "commune",
      parentId: "e772eb46-276a-4f41-bae7-3b67e1bdc616",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "20caef9e-83d6-4afe-950b-0e76129d97d9",
      code: 1122,
      name: "El Kerma",
      postalCode: "1122000",
      level: "commune",
      parentId: "e772eb46-276a-4f41-bae7-3b67e1bdc616",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7b4c83b6-7afa-44c7-9d50-002f40ccd11e",
      code: 1123,
      name: "Es Senia",
      postalCode: "1123000",
      level: "commune",
      parentId: "e772eb46-276a-4f41-bae7-3b67e1bdc616",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5112b974-da4a-48c4-aa91-9f0a1d60008f",
      code: 1124,
      name: "Gdyel",
      postalCode: "1124000",
      level: "commune",
      parentId: "e772eb46-276a-4f41-bae7-3b67e1bdc616",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8f4f7bc0-3fd6-4fea-b824-0a390e80564a",
      code: 1125,
      name: "Hassi Ben Okba",
      postalCode: "1125000",
      level: "commune",
      parentId: "e772eb46-276a-4f41-bae7-3b67e1bdc616",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2846165e-8b62-40d3-ae11-7babeba7f7d5",
      code: 1126,
      name: "Hassi Bounif",
      postalCode: "1126000",
      level: "commune",
      parentId: "e772eb46-276a-4f41-bae7-3b67e1bdc616",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c1e9defa-ed10-4a26-99ba-cfeb086bb01d",
      code: 1127,
      name: "Hassi Mefsoukh",
      postalCode: "1127000",
      level: "commune",
      parentId: "e772eb46-276a-4f41-bae7-3b67e1bdc616",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2e79daae-d50a-4000-a657-92e13fef5ac6",
      code: 1128,
      name: "Marsat El Hadjadj",
      postalCode: "1128000",
      level: "commune",
      parentId: "e772eb46-276a-4f41-bae7-3b67e1bdc616",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ea29b856-0a0d-435c-8672-fa627ae7e2f7",
      code: 1129,
      name: "Mers El Kebir",
      postalCode: "1129000",
      level: "commune",
      parentId: "e772eb46-276a-4f41-bae7-3b67e1bdc616",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7bf10081-c00a-4c42-80a9-cc3a29cd2b15",
      code: 1130,
      name: "Messerghin",
      postalCode: "1130000",
      level: "commune",
      parentId: "e772eb46-276a-4f41-bae7-3b67e1bdc616",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d43a3c18-2d6a-4063-a980-c419e53f19a9",
      code: 1131,
      name: "Oran",
      postalCode: "1131000",
      level: "commune",
      parentId: "e772eb46-276a-4f41-bae7-3b67e1bdc616",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3bf6d0e8-3492-498f-9fa6-b5a1f913731c",
      code: 1132,
      name: "Oued Tlelat",
      postalCode: "1132000",
      level: "commune",
      parentId: "e772eb46-276a-4f41-bae7-3b67e1bdc616",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "89028961-8e95-4ba3-80dc-f2dc6b6141ff",
      code: 1133,
      name: "Sidi Ben Yebka",
      postalCode: "1133000",
      level: "commune",
      parentId: "e772eb46-276a-4f41-bae7-3b67e1bdc616",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5d2d9fa7-fe21-4a2a-a2ec-5fa665719ec5",
      code: 1134,
      name: "Sidi Chami",
      postalCode: "1134000",
      level: "commune",
      parentId: "e772eb46-276a-4f41-bae7-3b67e1bdc616",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "14e367f9-be7b-4812-a739-2867034bf16a",
      code: 1135,
      name: "Tafraoui",
      postalCode: "1135000",
      level: "commune",
      parentId: "e772eb46-276a-4f41-bae7-3b67e1bdc616",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b7775fd7-e42c-41c4-9569-c4814ecb6572",
      code: 1136,
      name: "Ain El Orak",
      postalCode: "1136000",
      level: "commune",
      parentId: "dca8b699-ce8b-4ad7-b8f2-560e63911383",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b9c61f1c-7f1d-470b-a435-60ffc339e288",
      code: 1137,
      name: "Arbaouat",
      postalCode: "1137000",
      level: "commune",
      parentId: "dca8b699-ce8b-4ad7-b8f2-560e63911383",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b22b45a4-d2f3-4e1f-93df-478f58a28787",
      code: 1138,
      name: "Boualem",
      postalCode: "1138000",
      level: "commune",
      parentId: "dca8b699-ce8b-4ad7-b8f2-560e63911383",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "875e88be-d980-4d9b-9d6f-6042ab8667ff",
      code: 1139,
      name: "Bougtoub",
      postalCode: "1139000",
      level: "commune",
      parentId: "dca8b699-ce8b-4ad7-b8f2-560e63911383",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b14f762b-12c0-4281-95bc-a7548fdf2968",
      code: 1140,
      name: "Boussemghoun",
      postalCode: "1140000",
      level: "commune",
      parentId: "dca8b699-ce8b-4ad7-b8f2-560e63911383",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b86e0a27-28b8-4b43-83c9-ad461f783433",
      code: 1141,
      name: "Brezina",
      postalCode: "1141000",
      level: "commune",
      parentId: "dca8b699-ce8b-4ad7-b8f2-560e63911383",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "36b00e2b-5b85-4484-ad7c-6411a19d5712",
      code: 1142,
      name: "Cheguig",
      postalCode: "1142000",
      level: "commune",
      parentId: "dca8b699-ce8b-4ad7-b8f2-560e63911383",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0b600df1-9185-4427-860c-f0be965f4977",
      code: 1143,
      name: "Chellala",
      postalCode: "1143000",
      level: "commune",
      parentId: "dca8b699-ce8b-4ad7-b8f2-560e63911383",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2df29ae5-6ee7-40b6-834a-21876f7a3cca",
      code: 1144,
      name: "El Bayadh",
      postalCode: "1144000",
      level: "commune",
      parentId: "dca8b699-ce8b-4ad7-b8f2-560e63911383",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "64ed94a2-243a-4e6f-b1b2-ebaef402231e",
      code: 1145,
      name: "Labiodh Sidi Cheikh",
      postalCode: "1145000",
      level: "commune",
      parentId: "dca8b699-ce8b-4ad7-b8f2-560e63911383",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "dd9d5b9f-8c75-4648-adde-52f415da84ca",
      code: 1146,
      name: "El Bnoud",
      postalCode: "1146000",
      level: "commune",
      parentId: "dca8b699-ce8b-4ad7-b8f2-560e63911383",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c310eed3-c8c9-4c22-8464-9c370df7b69f",
      code: 1147,
      name: "El Kheiter",
      postalCode: "1147000",
      level: "commune",
      parentId: "dca8b699-ce8b-4ad7-b8f2-560e63911383",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "236ed28e-f51c-4107-85ba-a4309153df9e",
      code: 1148,
      name: "El Mehara",
      postalCode: "1148000",
      level: "commune",
      parentId: "dca8b699-ce8b-4ad7-b8f2-560e63911383",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "bdfb24d1-7c94-4649-a715-8921e29e19f5",
      code: 1149,
      name: "Ghassoul",
      postalCode: "1149000",
      level: "commune",
      parentId: "dca8b699-ce8b-4ad7-b8f2-560e63911383",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1f5f0166-7c93-4862-9134-2b238c096b99",
      code: 1150,
      name: "Kef El Ahmar",
      postalCode: "1150000",
      level: "commune",
      parentId: "dca8b699-ce8b-4ad7-b8f2-560e63911383",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "38768753-45f7-4056-816e-9bbb080c0b12",
      code: 1151,
      name: "Krakda",
      postalCode: "1151000",
      level: "commune",
      parentId: "dca8b699-ce8b-4ad7-b8f2-560e63911383",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "57e40674-a80b-4377-a8a8-8b711a2dc2cb",
      code: 1152,
      name: "Rogassa",
      postalCode: "1152000",
      level: "commune",
      parentId: "dca8b699-ce8b-4ad7-b8f2-560e63911383",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "da24fd54-9e06-4ee0-8cff-cbcc01e397c1",
      code: 1153,
      name: "Sidi Ameur",
      postalCode: "1153000",
      level: "commune",
      parentId: "dca8b699-ce8b-4ad7-b8f2-560e63911383",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "aeb958b7-704a-4c11-9e72-d9ff67f0a658",
      code: 1154,
      name: "Sidi Slimane",
      postalCode: "1154000",
      level: "commune",
      parentId: "dca8b699-ce8b-4ad7-b8f2-560e63911383",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8f350900-9a27-463c-a94b-552551d2c860",
      code: 1155,
      name: "Sidi Tiffour",
      postalCode: "1155000",
      level: "commune",
      parentId: "dca8b699-ce8b-4ad7-b8f2-560e63911383",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f121abc5-e907-49de-b054-48754d7281c3",
      code: 1156,
      name: "Stitten",
      postalCode: "1156000",
      level: "commune",
      parentId: "dca8b699-ce8b-4ad7-b8f2-560e63911383",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7057247a-99c4-43f1-8238-c224e77718fa",
      code: 1157,
      name: "Tousmouline",
      postalCode: "1157000",
      level: "commune",
      parentId: "dca8b699-ce8b-4ad7-b8f2-560e63911383",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "829fb594-0570-4683-a9fd-bb6df5ce0776",
      code: 1164,
      name: "Ain Taghrout",
      postalCode: "1164000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "937e94d3-17de-4f90-a4ed-fd8322abfe88",
      code: 1165,
      name: "Ain Tesra",
      postalCode: "1165000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9f3a78cb-791f-4ea1-aca2-9e44de1a4e2e",
      code: 1166,
      name: "B. B. Arreridj",
      postalCode: "1166000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a53e46ce-df07-4aba-add9-15fd0968cea8",
      code: 1167,
      name: "Belimour",
      postalCode: "1167000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "19323f60-7e3e-4c72-a93b-7fba8926b5b5",
      code: 1168,
      name: "Ben Daoud",
      postalCode: "1168000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "009c0cb5-69b0-4827-9a32-ce5dbe42c0a8",
      code: 1169,
      name: "Bir Kasdali",
      postalCode: "1169000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b9eb768d-111f-496b-9509-18aa46096255",
      code: 1170,
      name: "Bordj Ghedir",
      postalCode: "1170000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e1479dd8-ad46-4fe5-8eba-f246bce689f5",
      code: 1171,
      name: "Bordj Zemmoura",
      postalCode: "1171000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6018578d-9955-485a-ba0a-8c70c339006a",
      code: 1172,
      name: "Colla",
      postalCode: "1172000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "72884827-f626-4df2-9d5f-c4acb68c400e",
      code: 1173,
      name: "Djaafra",
      postalCode: "1173000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "21a37dfb-b6a3-4730-8a2f-542c2946d30f",
      code: 1174,
      name: "El Euch",
      postalCode: "1174000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9dc8ee81-8034-4d7e-a865-ee6d513a27fc",
      code: 1175,
      name: "El Achir",
      postalCode: "1175000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e1f3ac96-2b54-4adb-a50f-bc737f61abe5",
      code: 1176,
      name: "El Annasseur",
      postalCode: "1176000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "877b3103-5c46-4e43-9080-c0f56c16d5fb",
      code: 1177,
      name: "Elhammadia",
      postalCode: "1177000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "57e2d017-56a9-4d1c-93b9-5b175f8fe3c5",
      code: 1178,
      name: "El Main",
      postalCode: "1178000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2e3b123a-e174-462f-b9bd-31d561778cc7",
      code: 1179,
      name: "El M'hir",
      postalCode: "1179000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "caa041cc-a920-439f-87d6-2e816eb1deac",
      code: 1180,
      name: "Ghailasa",
      postalCode: "1180000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b3f55775-3654-4562-98a1-5f7d8a4ca5c8",
      code: 1181,
      name: "Haraza",
      postalCode: "1181000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0e469d98-cb43-4c15-9e91-5bbaf23e3996",
      code: 1182,
      name: "Hasnaoua",
      postalCode: "1182000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4d3c708d-443e-430c-9e8c-00264b2e4575",
      code: 1183,
      name: "Khelil",
      postalCode: "1183000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6748f371-776d-4d82-87a0-88c2be21477c",
      code: 1184,
      name: "Ksour",
      postalCode: "1184000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9257591f-724a-4fcd-9f6c-78e87e0d97ca",
      code: 1185,
      name: "Mansoura",
      postalCode: "1185000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "79088da0-e289-4f90-938b-f418375fb809",
      code: 1186,
      name: "Medjana",
      postalCode: "1186000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d4833df5-ac03-454b-a025-21f9c2d1df50",
      code: 1187,
      name: "Ouled Brahem",
      postalCode: "1187000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7a941cac-fd25-4879-ae83-43ec6f0b9888",
      code: 1188,
      name: "Ouled Dahmane",
      postalCode: "1188000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "65b2bc97-5ce9-4936-b5ac-94c61b5f0702",
      code: 1189,
      name: "Ouled Sidi-Brahim",
      postalCode: "1189000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c214af73-d7d5-474c-a8b8-9b3a6c143773",
      code: 1190,
      name: "Rabta",
      postalCode: "1190000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "42868e22-8b49-4eba-ae52-8a6f66353c22",
      code: 1191,
      name: "Ras El Oued",
      postalCode: "1191000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4b998b43-3f01-48bb-8ce9-f413ab04e411",
      code: 1192,
      name: "Sidi-Embarek",
      postalCode: "1192000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "becd4eaf-998e-4b11-b282-f7cb3bb929b6",
      code: 1193,
      name: "Tefreg",
      postalCode: "1193000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a20d582d-a845-4fca-bcee-1a8fc56090ad",
      code: 1194,
      name: "Taglait",
      postalCode: "1194000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "bf1b30c3-8749-4800-b6a4-49a82268cd38",
      code: 1195,
      name: "Tassamert",
      postalCode: "1195000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "169c6038-8e67-406f-9d1c-7983a0d6ec7a",
      code: 1196,
      name: "Teniet En Nasr",
      postalCode: "1196000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "691f0fcc-34ee-4526-8dee-1c7be686fc60",
      code: 1197,
      name: "Tixter",
      postalCode: "1197000",
      level: "commune",
      parentId: "80d1b557-03b2-4073-a8c2-89a8712a7fc8",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "855fa14f-1ffb-4919-8814-584e0f1ad242",
      code: 1198,
      name: "Afir",
      postalCode: "1198000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0b7ea8b2-0ddf-42e2-99b3-a595843d4ae3",
      code: 1199,
      name: "Ammal",
      postalCode: "1199000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ab821aca-18c7-487f-8b67-bb9cda74c0db",
      code: 1200,
      name: "Baghlia",
      postalCode: "1200000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "337f0471-70aa-4e1b-b7af-29983ba6c6cb",
      code: 1201,
      name: "Ben Choud",
      postalCode: "1201000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "286ce6b5-d29b-406e-9721-529ea49163ca",
      code: 1202,
      name: "Beni Amrane",
      postalCode: "1202000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d695c97f-fd2b-4061-8a41-beb6ec73a907",
      code: 1203,
      name: "Bordj Menaiel",
      postalCode: "1203000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "31d316f1-67ec-4e29-917e-cce4c341a4c1",
      code: 1204,
      name: "Boudouaou",
      postalCode: "1204000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d80f9c4f-74c0-4c6a-b994-2baca3acccbc",
      code: 1205,
      name: "Boudouaou El Bahri",
      postalCode: "1205000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "514b858a-e885-4ae8-a763-f463895a4a5d",
      code: 1206,
      name: "Boumerdes",
      postalCode: "1206000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0e14ad02-8bcd-490f-8d2e-ab65db222312",
      code: 1207,
      name: "Bouzegza Keddara",
      postalCode: "1207000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "37976834-6a63-4074-b923-7663f32fdd03",
      code: 1208,
      name: "Chabet El Ameur",
      postalCode: "1208000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5a12dc12-d791-4992-a791-56dcf3d31f09",
      code: 1209,
      name: "Corso",
      postalCode: "1209000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6eb90e5f-bbf6-4ca4-a6d9-b3ea8bb3552a",
      code: 1210,
      name: "Dellys",
      postalCode: "1210000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b78b602c-38d5-4c5e-9821-840814494210",
      code: 1211,
      name: "Djinet",
      postalCode: "1211000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "36c40888-1123-4f54-8cc2-60a898de39f6",
      code: 1212,
      name: "El Kharrouba",
      postalCode: "1212000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "bf494d7c-1d9a-4862-8d2a-db0daa33b05c",
      code: 1213,
      name: "Hammedi",
      postalCode: "1213000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b42567d7-ea5e-4bde-8b3b-afd9b1c63a5e",
      code: 1214,
      name: "Isser",
      postalCode: "1214000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "db62074e-473d-449b-a240-84b0838ea65b",
      code: 1215,
      name: "Khemis El Khechna",
      postalCode: "1215000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8eda7324-3d3b-408f-beb7-7626e80cb0c4",
      code: 1216,
      name: "Larbatache",
      postalCode: "1216000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "384a8798-b00c-4794-afc0-df07d2bcc148",
      code: 1217,
      name: "Leghata",
      postalCode: "1217000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "03e66d30-d981-499d-8742-cce591a7805d",
      code: 1218,
      name: "Naciria",
      postalCode: "1218000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2d6071b3-02c8-410c-b706-50e5658c253a",
      code: 1219,
      name: "Ouled Aissa",
      postalCode: "1219000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7942759b-bcce-4f4d-bf42-a091bd78a32a",
      code: 1220,
      name: "Ouled Hedadj",
      postalCode: "1220000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4bb620d8-8ddf-41cb-9d1d-5ec0d9d747a0",
      code: 1221,
      name: "Ouled Moussa",
      postalCode: "1221000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "56d4d794-fd4a-4384-b13f-365cead309a9",
      code: 1222,
      name: "Si Mustapha",
      postalCode: "1222000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a098e6b1-c4a2-4c64-8664-cb0260e4004a",
      code: 1223,
      name: "Sidi Daoud",
      postalCode: "1223000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d9516b64-3d19-4d71-afdf-4f426fec0091",
      code: 1224,
      name: "Souk El Had",
      postalCode: "1224000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e2b40595-1d46-49d3-9e73-ef2d7e2e43eb",
      code: 1225,
      name: "Taourga",
      postalCode: "1225000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "896841bb-4763-49f8-9de0-4c3761c5b34b",
      code: 1226,
      name: "Thenia",
      postalCode: "1226000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7377ac2c-102f-4c8b-b5cf-79ff63f17a9e",
      code: 1227,
      name: "Tidjelabine",
      postalCode: "1227000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "597389de-2c0a-4163-bea6-4bdab78dfbd8",
      code: 1228,
      name: "Timezrit",
      postalCode: "1228000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "cbcba443-456b-458e-ac57-ba35ac9dec9d",
      code: 1229,
      name: "Zemmouri",
      postalCode: "1229000",
      level: "commune",
      parentId: "f823492c-f79d-4c2d-befe-933bf9917a65",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "64fbb730-f8e7-4250-9726-bdde08e69a68",
      code: 1230,
      name: "Ain El Assel",
      postalCode: "1230000",
      level: "commune",
      parentId: "e6f4b09c-f63e-42af-92bc-dab9b422c34d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "72c468cc-ffaf-42c2-91ff-041723707c5a",
      code: 1231,
      name: "Ain Kerma",
      postalCode: "1231000",
      level: "commune",
      parentId: "e6f4b09c-f63e-42af-92bc-dab9b422c34d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "64f76198-6c48-4ea9-a009-6f651e56a177",
      code: 1232,
      name: "Asfour",
      postalCode: "1232000",
      level: "commune",
      parentId: "e6f4b09c-f63e-42af-92bc-dab9b422c34d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0f818e8f-f275-455a-9646-1f8ea305386e",
      code: 1233,
      name: "Ben M Hidi",
      postalCode: "1233000",
      level: "commune",
      parentId: "e6f4b09c-f63e-42af-92bc-dab9b422c34d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1692d0e5-04f3-4350-9eba-528040d6b2d7",
      code: 1234,
      name: "Berrihane",
      postalCode: "1234000",
      level: "commune",
      parentId: "e6f4b09c-f63e-42af-92bc-dab9b422c34d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8cf4cda4-22dc-4e13-9a5b-ce6dae972c30",
      code: 1235,
      name: "Besbes",
      postalCode: "1235000",
      level: "commune",
      parentId: "e6f4b09c-f63e-42af-92bc-dab9b422c34d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0b3d3941-9aee-44d9-b7ab-5abb857e5ef3",
      code: 1236,
      name: "Bougous",
      postalCode: "1236000",
      level: "commune",
      parentId: "e6f4b09c-f63e-42af-92bc-dab9b422c34d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "39b38162-e449-44f1-b7e9-abfd111b4d35",
      code: 1237,
      name: "Bouhadjar",
      postalCode: "1237000",
      level: "commune",
      parentId: "e6f4b09c-f63e-42af-92bc-dab9b422c34d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "dd0276d6-6b94-4328-94e8-d1f43b2ba2d3",
      code: 1238,
      name: "Bouteldja",
      postalCode: "1238000",
      level: "commune",
      parentId: "e6f4b09c-f63e-42af-92bc-dab9b422c34d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "525edc10-50fd-4ee6-8cf5-f7f961e23f6b",
      code: 1239,
      name: "Chebaita Mokhtar",
      postalCode: "1239000",
      level: "commune",
      parentId: "e6f4b09c-f63e-42af-92bc-dab9b422c34d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c64656ff-d8cb-4d1b-80e8-d0fd69976351",
      code: 1240,
      name: "Chefia",
      postalCode: "1240000",
      level: "commune",
      parentId: "e6f4b09c-f63e-42af-92bc-dab9b422c34d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5d62b8f7-f394-4d22-92d0-9be13da944c4",
      code: 1241,
      name: "Chihani",
      postalCode: "1241000",
      level: "commune",
      parentId: "e6f4b09c-f63e-42af-92bc-dab9b422c34d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "753e313d-d022-4e8e-bc67-a35b59f2f283",
      code: 1242,
      name: "Drean",
      postalCode: "1242000",
      level: "commune",
      parentId: "e6f4b09c-f63e-42af-92bc-dab9b422c34d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9d67fbe4-17fb-48b5-8a0e-eb881fc5e541",
      code: 1243,
      name: "Echatt",
      postalCode: "1243000",
      level: "commune",
      parentId: "e6f4b09c-f63e-42af-92bc-dab9b422c34d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b4ebd153-d4e9-4a3d-9ba5-32a9fecb1952",
      code: 1244,
      name: "El Aioun",
      postalCode: "1244000",
      level: "commune",
      parentId: "e6f4b09c-f63e-42af-92bc-dab9b422c34d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3f2ff519-fd3f-4f4c-8ec0-938a3e9a6085",
      code: 1245,
      name: "El Kala",
      postalCode: "1245000",
      level: "commune",
      parentId: "e6f4b09c-f63e-42af-92bc-dab9b422c34d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "befd6576-9d6f-4e47-a3e2-28c14ee31e91",
      code: 1246,
      name: "El Tarf",
      postalCode: "1246000",
      level: "commune",
      parentId: "e6f4b09c-f63e-42af-92bc-dab9b422c34d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b8efd10f-66ad-48ee-a0a3-47b05defb4a7",
      code: 1247,
      name: "Hammam Beni Salah",
      postalCode: "1247000",
      level: "commune",
      parentId: "e6f4b09c-f63e-42af-92bc-dab9b422c34d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "65aa0b60-bb25-4c2b-9274-9d72969c3b86",
      code: 1248,
      name: "Lac Des Oiseaux",
      postalCode: "1248000",
      level: "commune",
      parentId: "e6f4b09c-f63e-42af-92bc-dab9b422c34d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "725b92b4-48b4-4eb2-aab7-f1293436b7a4",
      code: 1249,
      name: "Oued Zitoun",
      postalCode: "1249000",
      level: "commune",
      parentId: "e6f4b09c-f63e-42af-92bc-dab9b422c34d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "bbc739d3-190a-47c4-9c76-bddc1ccbd879",
      code: 1250,
      name: "Raml Souk",
      postalCode: "1250000",
      level: "commune",
      parentId: "e6f4b09c-f63e-42af-92bc-dab9b422c34d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "35d1c4c5-4a92-45d0-b4fd-e83da514f61f",
      code: 1251,
      name: "Souarekh",
      postalCode: "1251000",
      level: "commune",
      parentId: "e6f4b09c-f63e-42af-92bc-dab9b422c34d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a338e49b-e702-4159-b7f9-9a4243684b96",
      code: 1252,
      name: "Zerizer",
      postalCode: "1252000",
      level: "commune",
      parentId: "e6f4b09c-f63e-42af-92bc-dab9b422c34d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ac2c7ea1-47a5-46fa-888a-2cb3c3544499",
      code: 1253,
      name: "Zitouna",
      postalCode: "1253000",
      level: "commune",
      parentId: "e6f4b09c-f63e-42af-92bc-dab9b422c34d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "93d914c9-f3a7-4220-b8da-22032f533677",
      code: 1256,
      name: "Ammari",
      postalCode: "1256000",
      level: "commune",
      parentId: "fb1a9f7a-81a2-4825-af92-79f9d187637f",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "978f352e-732d-4982-a989-33e4835db114",
      code: 1257,
      name: "Beni Chaib",
      postalCode: "1257000",
      level: "commune",
      parentId: "fb1a9f7a-81a2-4825-af92-79f9d187637f",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "23aafef1-a231-4869-9b93-16b3631ab3a4",
      code: 1258,
      name: "Beni Lahcene",
      postalCode: "1258000",
      level: "commune",
      parentId: "fb1a9f7a-81a2-4825-af92-79f9d187637f",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3b7a76fb-b550-4ef8-9082-241234300ec1",
      code: 1259,
      name: "Bordj Bounaama",
      postalCode: "1259000",
      level: "commune",
      parentId: "fb1a9f7a-81a2-4825-af92-79f9d187637f",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f8b8e443-23e1-4e18-b55a-1d916d110363",
      code: 1260,
      name: "Bordj El Emir Abdelkader",
      postalCode: "1260000",
      level: "commune",
      parentId: "fb1a9f7a-81a2-4825-af92-79f9d187637f",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e95828ac-e575-44b7-a4b9-5b6f45821418",
      code: 1261,
      name: "Boucaid",
      postalCode: "1261000",
      level: "commune",
      parentId: "fb1a9f7a-81a2-4825-af92-79f9d187637f",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "67b6b02b-b37f-4844-9af2-a1ebf8086ba2",
      code: 1262,
      name: "Khemisti",
      postalCode: "1262000",
      level: "commune",
      parentId: "fb1a9f7a-81a2-4825-af92-79f9d187637f",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "86d143ad-cb5d-4d14-a0b2-d67bfcb8cd09",
      code: 1263,
      name: "Larbaa",
      postalCode: "1263000",
      level: "commune",
      parentId: "fb1a9f7a-81a2-4825-af92-79f9d187637f",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "faa3af4b-76d7-483a-a89d-38da557328b7",
      code: 1264,
      name: "Lardjem",
      postalCode: "1264000",
      level: "commune",
      parentId: "fb1a9f7a-81a2-4825-af92-79f9d187637f",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "20854f31-678d-42c5-bf86-d1ae52f7666d",
      code: 1265,
      name: "Layoune",
      postalCode: "1265000",
      level: "commune",
      parentId: "fb1a9f7a-81a2-4825-af92-79f9d187637f",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "719050a1-af7b-498c-8337-9608079aaa88",
      code: 1266,
      name: "Lazharia",
      postalCode: "1266000",
      level: "commune",
      parentId: "fb1a9f7a-81a2-4825-af92-79f9d187637f",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "47f38e09-e25d-4c52-9210-8f57ca4067c7",
      code: 1267,
      name: "Maacem",
      postalCode: "1267000",
      level: "commune",
      parentId: "fb1a9f7a-81a2-4825-af92-79f9d187637f",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "21dcdc8a-8549-45a3-bc87-1d4275846396",
      code: 1268,
      name: "Melaab",
      postalCode: "1268000",
      level: "commune",
      parentId: "fb1a9f7a-81a2-4825-af92-79f9d187637f",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8fff98e4-f6fd-422d-9192-72fada01476a",
      code: 1269,
      name: "Ouled Bessam",
      postalCode: "1269000",
      level: "commune",
      parentId: "fb1a9f7a-81a2-4825-af92-79f9d187637f",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2a4af93f-7616-4d77-8ae8-4e8bb1594e24",
      code: 1270,
      name: "Sidi Abed",
      postalCode: "1270000",
      level: "commune",
      parentId: "fb1a9f7a-81a2-4825-af92-79f9d187637f",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f0bcf452-c134-4487-8270-2780db962952",
      code: 1271,
      name: "Sidi Boutouchent",
      postalCode: "1271000",
      level: "commune",
      parentId: "fb1a9f7a-81a2-4825-af92-79f9d187637f",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "bac6cc24-ddec-4000-9310-81c4fd8f0b1a",
      code: 1272,
      name: "Sidi Lantri",
      postalCode: "1272000",
      level: "commune",
      parentId: "fb1a9f7a-81a2-4825-af92-79f9d187637f",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "999a79ba-5ce9-4caf-8a55-bfa51b431081",
      code: 1273,
      name: "Sidi Slimane",
      postalCode: "1273000",
      level: "commune",
      parentId: "fb1a9f7a-81a2-4825-af92-79f9d187637f",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c6915f0a-dba2-49ef-84c3-79405d863ad1",
      code: 1274,
      name: "Tamellahet",
      postalCode: "1274000",
      level: "commune",
      parentId: "fb1a9f7a-81a2-4825-af92-79f9d187637f",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d6ff9d26-780a-4a3b-8d21-703ba7a13039",
      code: 1275,
      name: "Theniet El Had",
      postalCode: "1275000",
      level: "commune",
      parentId: "fb1a9f7a-81a2-4825-af92-79f9d187637f",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "feb4275d-ced4-4233-b10f-8615dfa399c3",
      code: 1276,
      name: "Tissemsilt",
      postalCode: "1276000",
      level: "commune",
      parentId: "fb1a9f7a-81a2-4825-af92-79f9d187637f",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1f13f1d2-adf3-42d1-8571-436a6e0bfad2",
      code: 1277,
      name: "Youssoufia",
      postalCode: "1277000",
      level: "commune",
      parentId: "fb1a9f7a-81a2-4825-af92-79f9d187637f",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f8d32886-ee60-42cc-a6a8-05f744ddc030",
      code: 1278,
      name: "Bayadha",
      postalCode: "1278000",
      level: "commune",
      parentId: "cd82549a-b1f7-48c1-9a25-2f3f05b80b1d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7e3f5a86-7d93-4ddf-8c4a-bb7898f68b74",
      code: 1279,
      name: "Ben Guecha",
      postalCode: "1279000",
      level: "commune",
      parentId: "cd82549a-b1f7-48c1-9a25-2f3f05b80b1d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1536821c-54be-42dc-9d4a-e5b38a5ac4f8",
      code: 1280,
      name: "Debila",
      postalCode: "1280000",
      level: "commune",
      parentId: "cd82549a-b1f7-48c1-9a25-2f3f05b80b1d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b8a02fdc-314a-4ba5-bb4b-d9d6ed496661",
      code: 1281,
      name: "Djamaa",
      postalCode: "1281000",
      level: "commune",
      parentId: "eabb6505-5eef-479f-b6a3-36ba282d5237",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: false,
      },
    },
    {
      id: "d9eacd8a-ba63-4e02-9224-70d700a30700",
      code: 1282,
      name: "Douar El Maa",
      postalCode: "1282000",
      level: "commune",
      parentId: "cd82549a-b1f7-48c1-9a25-2f3f05b80b1d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "27e887df-6336-414d-925d-ca7ab98d4de7",
      code: 1283,
      name: "El Ogla",
      postalCode: "1283000",
      level: "commune",
      parentId: "cd82549a-b1f7-48c1-9a25-2f3f05b80b1d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9ccc4f48-dc49-4f29-812d-308d3a6ac95b",
      code: 1284,
      name: "El-M'ghaier",
      postalCode: "1284000",
      level: "commune",
      parentId: "eabb6505-5eef-479f-b6a3-36ba282d5237",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: false,
      },
    },
    {
      id: "25551e68-ea40-4df7-9630-7ace25b29fba",
      code: 1285,
      name: "El-Oued",
      postalCode: "1285000",
      level: "commune",
      parentId: "cd82549a-b1f7-48c1-9a25-2f3f05b80b1d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "54864b78-b5e1-45bd-8f94-28ada3716c3e",
      code: 1286,
      name: "Guemar",
      postalCode: "1286000",
      level: "commune",
      parentId: "cd82549a-b1f7-48c1-9a25-2f3f05b80b1d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "83ad393d-ef98-4777-8d34-1a86a1fb6082",
      code: 1287,
      name: "Hamraia",
      postalCode: "1287000",
      level: "commune",
      parentId: "cd82549a-b1f7-48c1-9a25-2f3f05b80b1d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "26e69b08-d272-4611-8e2d-8b62b5178937",
      code: 1288,
      name: "Hassani Abdelkrim",
      postalCode: "1288000",
      level: "commune",
      parentId: "cd82549a-b1f7-48c1-9a25-2f3f05b80b1d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "930e3052-514f-4d83-8522-6b34fed7401d",
      code: 1289,
      name: "Hassi Khalifa",
      postalCode: "1289000",
      level: "commune",
      parentId: "cd82549a-b1f7-48c1-9a25-2f3f05b80b1d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "146ae075-0f2b-4f72-be5f-910f33d7a3c2",
      code: 1290,
      name: "Kouinine",
      postalCode: "1290000",
      level: "commune",
      parentId: "cd82549a-b1f7-48c1-9a25-2f3f05b80b1d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0ebc7714-cddd-4ecf-98c8-e5d9d937b0a1",
      code: 1291,
      name: "Magrane",
      postalCode: "1291000",
      level: "commune",
      parentId: "cd82549a-b1f7-48c1-9a25-2f3f05b80b1d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "db3b832a-3592-4854-8470-75794b6ea63e",
      code: 1292,
      name: "Mih Ouansa",
      postalCode: "1292000",
      level: "commune",
      parentId: "cd82549a-b1f7-48c1-9a25-2f3f05b80b1d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "957e3677-6b16-4002-beb0-cf08cc8e58d6",
      code: 1293,
      name: "M'rara",
      postalCode: "1293000",
      level: "commune",
      parentId: "eabb6505-5eef-479f-b6a3-36ba282d5237",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: false,
      },
    },
    {
      id: "f93fb920-dce5-4872-b991-930e88439ff4",
      code: 1294,
      name: "Nakhla",
      postalCode: "1294000",
      level: "commune",
      parentId: "cd82549a-b1f7-48c1-9a25-2f3f05b80b1d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "cd38cad2-6af1-42fb-9028-3f260c79ba1d",
      code: 1295,
      name: "Oued El Alenda",
      postalCode: "1295000",
      level: "commune",
      parentId: "cd82549a-b1f7-48c1-9a25-2f3f05b80b1d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "77ec7626-4855-4447-b444-4833d82a9810",
      code: 1296,
      name: "Oum Touyour",
      postalCode: "1296000",
      level: "commune",
      parentId: "eabb6505-5eef-479f-b6a3-36ba282d5237",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: false,
      },
    },
    {
      id: "e2790706-b132-4ff6-983f-6b0f8cadecba",
      code: 1297,
      name: "Ourmes",
      postalCode: "1297000",
      level: "commune",
      parentId: "cd82549a-b1f7-48c1-9a25-2f3f05b80b1d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3b10a00c-98a0-4663-9c3c-318243f1f5e9",
      code: 1298,
      name: "Reguiba",
      postalCode: "1298000",
      level: "commune",
      parentId: "cd82549a-b1f7-48c1-9a25-2f3f05b80b1d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6c9a3e31-528c-483a-8385-a0c691a67fca",
      code: 1299,
      name: "Robbah",
      postalCode: "1299000",
      level: "commune",
      parentId: "cd82549a-b1f7-48c1-9a25-2f3f05b80b1d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "af527555-492c-45e0-84b5-031173540263",
      code: 1300,
      name: "Sidi Amrane",
      postalCode: "1300000",
      level: "commune",
      parentId: "eabb6505-5eef-479f-b6a3-36ba282d5237",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: false,
      },
    },
    {
      id: "f91fa346-0a5e-4033-92e5-efa2957a81ab",
      code: 1301,
      name: "Sidi Aoun",
      postalCode: "1301000",
      level: "commune",
      parentId: "cd82549a-b1f7-48c1-9a25-2f3f05b80b1d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "58aa886c-7e61-4f69-9f0e-6cd25c3856e9",
      code: 1302,
      name: "Sidi Khelil",
      postalCode: "1302000",
      level: "commune",
      parentId: "eabb6505-5eef-479f-b6a3-36ba282d5237",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: false,
      },
    },
    {
      id: "078e4aa8-7175-41f5-89e3-b8fe136b6344",
      code: 1303,
      name: "Still",
      postalCode: "1303000",
      level: "commune",
      parentId: "eabb6505-5eef-479f-b6a3-36ba282d5237",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: false,
      },
    },
    {
      id: "af0657fa-2d35-43e3-873b-b00a2139b59b",
      code: 1304,
      name: "Taghzout",
      postalCode: "1304000",
      level: "commune",
      parentId: "cd82549a-b1f7-48c1-9a25-2f3f05b80b1d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f803c076-25e6-4f58-91c2-e01c1ef0afd8",
      code: 1305,
      name: "Taleb Larbi",
      postalCode: "1305000",
      level: "commune",
      parentId: "cd82549a-b1f7-48c1-9a25-2f3f05b80b1d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "eb799c9e-d566-4d05-8747-a73636c7386f",
      code: 1306,
      name: "Tenedla",
      postalCode: "1306000",
      level: "commune",
      parentId: "eabb6505-5eef-479f-b6a3-36ba282d5237",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: false,
      },
    },
    {
      id: "a01cfb75-a047-4aeb-8a42-63b1a01966a4",
      code: 1307,
      name: "Trifaoui",
      postalCode: "1307000",
      level: "commune",
      parentId: "cd82549a-b1f7-48c1-9a25-2f3f05b80b1d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "21d698fd-e19a-490e-9b0e-bff68e314340",
      code: 1308,
      name: "Ain Touila",
      postalCode: "1308000",
      level: "commune",
      parentId: "d4549528-8327-4a3f-9732-5a5462c84b8d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5eeaa3ff-f27f-4ff4-a9d3-efca1d4cc3ba",
      code: 1309,
      name: "Babar",
      postalCode: "1309000",
      level: "commune",
      parentId: "d4549528-8327-4a3f-9732-5a5462c84b8d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f5110906-de18-409a-9377-62db2334577c",
      code: 1310,
      name: "Baghai",
      postalCode: "1310000",
      level: "commune",
      parentId: "d4549528-8327-4a3f-9732-5a5462c84b8d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b3707650-575a-4e17-9ef2-49b90879bd32",
      code: 1311,
      name: "Bouhmama",
      postalCode: "1311000",
      level: "commune",
      parentId: "d4549528-8327-4a3f-9732-5a5462c84b8d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "cdfbc041-70c5-4d02-855f-2eefb7c4bfc1",
      code: 1312,
      name: "Chechar",
      postalCode: "1312000",
      level: "commune",
      parentId: "d4549528-8327-4a3f-9732-5a5462c84b8d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "129d54db-8178-4eea-9cd1-30016e25a458",
      code: 1313,
      name: "Chelia",
      postalCode: "1313000",
      level: "commune",
      parentId: "d4549528-8327-4a3f-9732-5a5462c84b8d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c541df88-6ebe-48d4-aacf-01dbb679de22",
      code: 1314,
      name: "Djellal",
      postalCode: "1314000",
      level: "commune",
      parentId: "d4549528-8327-4a3f-9732-5a5462c84b8d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "dc143c66-f4c0-4a38-b6fc-cad0913a3e96",
      code: 1315,
      name: "El Hamma",
      postalCode: "1315000",
      level: "commune",
      parentId: "d4549528-8327-4a3f-9732-5a5462c84b8d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c340eea2-c481-4873-a7de-478f7e30537f",
      code: 1316,
      name: "El Mahmal",
      postalCode: "1316000",
      level: "commune",
      parentId: "d4549528-8327-4a3f-9732-5a5462c84b8d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "da2ea24d-27f7-4cff-b6be-186e5f58595b",
      code: 1317,
      name: "El Oueldja",
      postalCode: "1317000",
      level: "commune",
      parentId: "d4549528-8327-4a3f-9732-5a5462c84b8d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "31b040a3-b166-4200-ada0-551da305c36c",
      code: 1318,
      name: "Ensigha",
      postalCode: "1318000",
      level: "commune",
      parentId: "d4549528-8327-4a3f-9732-5a5462c84b8d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "74970395-8553-4010-bc41-e51ba62b8e76",
      code: 1319,
      name: "Kais",
      postalCode: "1319000",
      level: "commune",
      parentId: "d4549528-8327-4a3f-9732-5a5462c84b8d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "cf82b27f-8196-4028-8aa7-663de94d6cac",
      code: 1320,
      name: "Khenchela",
      postalCode: "1320000",
      level: "commune",
      parentId: "d4549528-8327-4a3f-9732-5a5462c84b8d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c14c8df1-9a36-41c5-aacc-9d9f9a4b5d99",
      code: 1321,
      name: "Khirane",
      postalCode: "1321000",
      level: "commune",
      parentId: "d4549528-8327-4a3f-9732-5a5462c84b8d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ba8005da-94a5-4229-b764-667bf23f2bd3",
      code: 1322,
      name: "M'sara",
      postalCode: "1322000",
      level: "commune",
      parentId: "d4549528-8327-4a3f-9732-5a5462c84b8d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5f32e1d9-b4c6-4b5d-98cc-d07deba606eb",
      code: 1323,
      name: "M'toussa",
      postalCode: "1323000",
      level: "commune",
      parentId: "d4549528-8327-4a3f-9732-5a5462c84b8d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "088e71ca-e5a4-4685-8f62-c6f729b9cbdb",
      code: 1324,
      name: "Ouled Rechache",
      postalCode: "1324000",
      level: "commune",
      parentId: "d4549528-8327-4a3f-9732-5a5462c84b8d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "68981ffa-b5a4-4030-bfb1-910adbb9d758",
      code: 1325,
      name: "Remila",
      postalCode: "1325000",
      level: "commune",
      parentId: "d4549528-8327-4a3f-9732-5a5462c84b8d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8ff8a62e-c065-4454-87ff-41fd5494a1cc",
      code: 1326,
      name: "Tamza",
      postalCode: "1326000",
      level: "commune",
      parentId: "d4549528-8327-4a3f-9732-5a5462c84b8d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "02521687-2e1f-4bfe-ab1b-503378b50182",
      code: 1327,
      name: "Taouzianat",
      postalCode: "1327000",
      level: "commune",
      parentId: "d4549528-8327-4a3f-9732-5a5462c84b8d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ae7b19a6-44cb-4374-9ddb-a9280f2f0c69",
      code: 1328,
      name: "Yabous",
      postalCode: "1328000",
      level: "commune",
      parentId: "d4549528-8327-4a3f-9732-5a5462c84b8d",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "182f2416-1dc1-4422-a5bc-05fad9d61b9a",
      code: 1329,
      name: "Ain Soltane",
      postalCode: "1329000",
      level: "commune",
      parentId: "56d30b7a-465a-462c-bc2a-3e132c89be63",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6e1b0752-aeaf-48ba-81ea-e7d15484fde5",
      code: 1330,
      name: "Ain Zana",
      postalCode: "1330000",
      level: "commune",
      parentId: "56d30b7a-465a-462c-bc2a-3e132c89be63",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "46b157ba-30a1-403e-af44-623392ba5cb4",
      code: 1331,
      name: "Bir Bouhouche",
      postalCode: "1331000",
      level: "commune",
      parentId: "56d30b7a-465a-462c-bc2a-3e132c89be63",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4538d832-f40a-49da-b077-7da96273ebdf",
      code: 1332,
      name: "Drea",
      postalCode: "1332000",
      level: "commune",
      parentId: "56d30b7a-465a-462c-bc2a-3e132c89be63",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1035d6f4-0c7a-454c-8603-b1600dc3b7ba",
      code: 1333,
      name: "Haddada",
      postalCode: "1333000",
      level: "commune",
      parentId: "56d30b7a-465a-462c-bc2a-3e132c89be63",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "00d65b7e-e438-4ccb-978e-d195d9ae0a19",
      code: 1334,
      name: "Hanencha",
      postalCode: "1334000",
      level: "commune",
      parentId: "56d30b7a-465a-462c-bc2a-3e132c89be63",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b2c4f1ab-8194-4a56-9bd1-aa368dfb0b94",
      code: 1335,
      name: "Khedara",
      postalCode: "1335000",
      level: "commune",
      parentId: "56d30b7a-465a-462c-bc2a-3e132c89be63",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3abddd43-99e8-4421-8d93-515954261a40",
      code: 1336,
      name: "Khemissa",
      postalCode: "1336000",
      level: "commune",
      parentId: "56d30b7a-465a-462c-bc2a-3e132c89be63",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7dc0cdf2-fcab-445d-abfd-dc749c708f9a",
      code: 1337,
      name: "Machroha",
      postalCode: "1337000",
      level: "commune",
      parentId: "56d30b7a-465a-462c-bc2a-3e132c89be63",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7b248bfb-9124-4c58-b9cf-a2ae444636fd",
      code: 1338,
      name: "M'daourouche",
      postalCode: "1338000",
      level: "commune",
      parentId: "56d30b7a-465a-462c-bc2a-3e132c89be63",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8087062f-e797-4589-b99b-019ebfc2abab",
      code: 1339,
      name: "Merahna",
      postalCode: "1339000",
      level: "commune",
      parentId: "56d30b7a-465a-462c-bc2a-3e132c89be63",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2c05259a-26b3-4a62-ac1b-f1df4e7873c9",
      code: 1340,
      name: "Oued Kebrit",
      postalCode: "1340000",
      level: "commune",
      parentId: "56d30b7a-465a-462c-bc2a-3e132c89be63",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "513390d5-b969-4466-b729-c9bd2902a326",
      code: 1341,
      name: "Ouled Driss",
      postalCode: "1341000",
      level: "commune",
      parentId: "56d30b7a-465a-462c-bc2a-3e132c89be63",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b1e85585-8be6-4d21-ac90-5e8be2442f0d",
      code: 1342,
      name: "Ouled Moumen",
      postalCode: "1342000",
      level: "commune",
      parentId: "56d30b7a-465a-462c-bc2a-3e132c89be63",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7e0bd259-56bf-4d84-bd0b-16095fe87e22",
      code: 1343,
      name: "Oum El Adhaim",
      postalCode: "1343000",
      level: "commune",
      parentId: "56d30b7a-465a-462c-bc2a-3e132c89be63",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3812fd3c-7b62-43a9-a08c-a0bf935e0b4b",
      code: 1344,
      name: "Ouillen",
      postalCode: "1344000",
      level: "commune",
      parentId: "56d30b7a-465a-462c-bc2a-3e132c89be63",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6d036193-70c2-4203-ad97-b0afeab205e7",
      code: 1345,
      name: "Ragouba",
      postalCode: "1345000",
      level: "commune",
      parentId: "56d30b7a-465a-462c-bc2a-3e132c89be63",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "59115311-4641-4bae-81b2-eb8ec70e6467",
      code: 1346,
      name: "Safel El Ouiden",
      postalCode: "1346000",
      level: "commune",
      parentId: "56d30b7a-465a-462c-bc2a-3e132c89be63",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0bc12ecf-a1fb-4803-94d8-e481ec9f7328",
      code: 1347,
      name: "Sedrata",
      postalCode: "1347000",
      level: "commune",
      parentId: "56d30b7a-465a-462c-bc2a-3e132c89be63",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "46dce544-af0f-41ce-b015-d02f57d3bbd9",
      code: 1348,
      name: "Sidi Fredj",
      postalCode: "1348000",
      level: "commune",
      parentId: "56d30b7a-465a-462c-bc2a-3e132c89be63",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7026923a-e8ed-4da6-8340-c60c2866bdaf",
      code: 1349,
      name: "Souk Ahras",
      postalCode: "1349000",
      level: "commune",
      parentId: "56d30b7a-465a-462c-bc2a-3e132c89be63",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1385240e-bf9e-4dae-a765-c0d509f09ad5",
      code: 1350,
      name: "Taoura",
      postalCode: "1350000",
      level: "commune",
      parentId: "56d30b7a-465a-462c-bc2a-3e132c89be63",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b15682d2-01e9-468f-affc-fb028474f420",
      code: 1351,
      name: "Terraguelt",
      postalCode: "1351000",
      level: "commune",
      parentId: "56d30b7a-465a-462c-bc2a-3e132c89be63",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ea5c71bd-4fa1-4d5d-bc18-9dff945fc474",
      code: 1352,
      name: "Tiffech",
      postalCode: "1352000",
      level: "commune",
      parentId: "56d30b7a-465a-462c-bc2a-3e132c89be63",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c1fd6615-3bfc-4b36-8c6e-c20408fa3c29",
      code: 1353,
      name: "Zaarouria",
      postalCode: "1353000",
      level: "commune",
      parentId: "56d30b7a-465a-462c-bc2a-3e132c89be63",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ba4beadd-2ab8-4de0-882c-a52839d15555",
      code: 1354,
      name: "Zouabi",
      postalCode: "1354000",
      level: "commune",
      parentId: "56d30b7a-465a-462c-bc2a-3e132c89be63",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "76e9b29f-e27e-4615-ab7e-93c28576a522",
      code: 1355,
      name: "Aghbal",
      postalCode: "1355000",
      level: "commune",
      parentId: "1435179a-6dbb-4d9c-a186-c521b2a57319",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "10d74997-2735-47e9-89f0-cf8417901205",
      code: 1356,
      name: "Ahmer El Ain",
      postalCode: "1356000",
      level: "commune",
      parentId: "1435179a-6dbb-4d9c-a186-c521b2a57319",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c58b2009-0939-4f91-aaf4-0efd15f26ed3",
      code: 1357,
      name: "Ain Tagourait",
      postalCode: "1357000",
      level: "commune",
      parentId: "1435179a-6dbb-4d9c-a186-c521b2a57319",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6c48b169-5b5e-4149-8007-62ef9820c8a1",
      code: 1358,
      name: "Attatba",
      postalCode: "1358000",
      level: "commune",
      parentId: "1435179a-6dbb-4d9c-a186-c521b2a57319",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ddd00871-0be8-487f-9daa-0c2cf8ee3335",
      code: 1359,
      name: "Beni Mileuk",
      postalCode: "1359000",
      level: "commune",
      parentId: "1435179a-6dbb-4d9c-a186-c521b2a57319",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "026e8108-72cd-4887-84ad-a1d69b92886f",
      code: 1360,
      name: "Bou Haroun",
      postalCode: "1360000",
      level: "commune",
      parentId: "1435179a-6dbb-4d9c-a186-c521b2a57319",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "537da345-0b6e-4f03-aaa7-fb81b74126b6",
      code: 1361,
      name: "Bou Ismail",
      postalCode: "1361000",
      level: "commune",
      parentId: "1435179a-6dbb-4d9c-a186-c521b2a57319",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6f2c209b-6d03-47b0-b9ee-fc75791cf1cc",
      code: 1362,
      name: "Bourkika",
      postalCode: "1362000",
      level: "commune",
      parentId: "1435179a-6dbb-4d9c-a186-c521b2a57319",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c1af4926-c441-4d13-93bd-50ed613f5f12",
      code: 1363,
      name: "Chaiba",
      postalCode: "1363000",
      level: "commune",
      parentId: "1435179a-6dbb-4d9c-a186-c521b2a57319",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "909f5491-e4f8-4785-900d-b5238a4608a6",
      code: 1364,
      name: "Cherchell",
      postalCode: "1364000",
      level: "commune",
      parentId: "1435179a-6dbb-4d9c-a186-c521b2a57319",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b92c309d-045f-4834-b542-a5dc6ba0f7d7",
      code: 1365,
      name: "Damous",
      postalCode: "1365000",
      level: "commune",
      parentId: "1435179a-6dbb-4d9c-a186-c521b2a57319",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "615372aa-9249-40cb-a503-48fd650c1839",
      code: 1366,
      name: "Douaouda",
      postalCode: "1366000",
      level: "commune",
      parentId: "1435179a-6dbb-4d9c-a186-c521b2a57319",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3c8152b9-9de1-4d28-8520-85dca9169975",
      code: 1367,
      name: "Fouka",
      postalCode: "1367000",
      level: "commune",
      parentId: "1435179a-6dbb-4d9c-a186-c521b2a57319",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2caf24f5-7845-490b-b53b-e0abb6f9a4a3",
      code: 1368,
      name: "Gouraya",
      postalCode: "1368000",
      level: "commune",
      parentId: "1435179a-6dbb-4d9c-a186-c521b2a57319",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0b5d9884-c4ac-44b9-8977-c39fd7590bc8",
      code: 1369,
      name: "Hadjout",
      postalCode: "1369000",
      level: "commune",
      parentId: "1435179a-6dbb-4d9c-a186-c521b2a57319",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8e142846-4b3d-40a1-b959-33a902a4923e",
      code: 1370,
      name: "Hadjret Ennous",
      postalCode: "1370000",
      level: "commune",
      parentId: "1435179a-6dbb-4d9c-a186-c521b2a57319",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e78c72e1-6e95-4a6c-b814-3a4fcddaa802",
      code: 1371,
      name: "Khemisti",
      postalCode: "1371000",
      level: "commune",
      parentId: "1435179a-6dbb-4d9c-a186-c521b2a57319",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e3312aa7-c123-4bf1-a634-199d6f89b591",
      code: 1372,
      name: "Kolea",
      postalCode: "1372000",
      level: "commune",
      parentId: "1435179a-6dbb-4d9c-a186-c521b2a57319",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "26ecd8a1-7c84-4c4e-9e55-e9e2e6a31b27",
      code: 1373,
      name: "Larhat",
      postalCode: "1373000",
      level: "commune",
      parentId: "1435179a-6dbb-4d9c-a186-c521b2a57319",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "03f45179-6f7a-4050-9bbe-914a9c520c91",
      code: 1374,
      name: "Menaceur",
      postalCode: "1374000",
      level: "commune",
      parentId: "1435179a-6dbb-4d9c-a186-c521b2a57319",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6103d7b7-159d-4a4a-96a4-a5c0b20a7181",
      code: 1375,
      name: "Merad",
      postalCode: "1375000",
      level: "commune",
      parentId: "1435179a-6dbb-4d9c-a186-c521b2a57319",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "faa41994-27c4-43be-b8fd-ca72ecf4cf7c",
      code: 1376,
      name: "Messelmoun",
      postalCode: "1376000",
      level: "commune",
      parentId: "1435179a-6dbb-4d9c-a186-c521b2a57319",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "805d5910-400b-4b90-9a48-98d2a275bd94",
      code: 1377,
      name: "Nador",
      postalCode: "1377000",
      level: "commune",
      parentId: "1435179a-6dbb-4d9c-a186-c521b2a57319",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "92b5e8ac-a6a5-4ac4-81f3-fbafa6870c27",
      code: 1378,
      name: "Sidi Ghiles",
      postalCode: "1378000",
      level: "commune",
      parentId: "1435179a-6dbb-4d9c-a186-c521b2a57319",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8f153103-3e76-41f4-a4c9-387c2b16172f",
      code: 1379,
      name: "Sidi Rached",
      postalCode: "1379000",
      level: "commune",
      parentId: "1435179a-6dbb-4d9c-a186-c521b2a57319",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8fbb06b4-9dd1-41c8-9cd5-04976ae0ed83",
      code: 1380,
      name: "Sidi Semiane",
      postalCode: "1380000",
      level: "commune",
      parentId: "1435179a-6dbb-4d9c-a186-c521b2a57319",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4d62bf2a-36a4-4b46-8bd1-38790249d37e",
      code: 1381,
      name: "Sidi-Amar",
      postalCode: "1381000",
      level: "commune",
      parentId: "1435179a-6dbb-4d9c-a186-c521b2a57319",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3b0d300d-a978-462e-9ea5-92bd6bb74567",
      code: 1382,
      name: "Tipaza",
      postalCode: "1382000",
      level: "commune",
      parentId: "1435179a-6dbb-4d9c-a186-c521b2a57319",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7ab0be66-fe19-4601-b03c-c972c118bced",
      code: 1383,
      name: "Ahmed Rachedi",
      postalCode: "1383000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b0e3272f-0093-46b4-8936-a3412a5133d7",
      code: 1384,
      name: "Ain Beida Harriche",
      postalCode: "1384000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3e0ff32a-d712-41b1-8ad1-5a71b9ab895b",
      code: 1385,
      name: "Ain Mellouk",
      postalCode: "1385000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9bb456ef-d0e7-4a8e-8074-70c5775f111e",
      code: 1386,
      name: "Ain Tine",
      postalCode: "1386000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b5112363-397f-499f-869f-41674a309711",
      code: 1387,
      name: "Amira Arres",
      postalCode: "1387000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4116c0ee-cf0c-493b-960d-4216e8fa79fc",
      code: 1388,
      name: "Benyahia Abderrahmane",
      postalCode: "1388000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "1f1f789c-9e05-4cd6-a17e-b1f7879bb264",
      code: 1389,
      name: "Bouhatem",
      postalCode: "1389000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "aefacdce-3df6-4927-9b18-c0896c341211",
      code: 1390,
      name: "Chelghoum Laid",
      postalCode: "1390000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "bc80e8a8-2859-4139-a128-83972049a6e2",
      code: 1391,
      name: "Chigara",
      postalCode: "1391000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f3b1bfe6-04bb-4068-a450-5df52b1856a4",
      code: 1392,
      name: "Derrahi Bousselah",
      postalCode: "1392000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2cb3cd91-8a17-4427-bc2a-86f0fe5db07b",
      code: 1393,
      name: "El Ayadi Barbes",
      postalCode: "1393000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2f655daa-94a3-402a-b5e9-2a11c6cfd849",
      code: 1394,
      name: "El Mechira",
      postalCode: "1394000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "825b754a-342d-4fcd-af79-7925d0e6022d",
      code: 1395,
      name: "Ferdjioua",
      postalCode: "1395000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "99a8a0ed-f6ca-4790-b395-9f60aff9c937",
      code: 1396,
      name: "Grarem Gouga",
      postalCode: "1396000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b4f877f3-6d34-4010-8731-c479cbd17309",
      code: 1397,
      name: "Hamala",
      postalCode: "1397000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "00f73d0e-a315-461c-b860-9fd15b5abf31",
      code: 1398,
      name: "Mila",
      postalCode: "1398000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3e80eadd-3275-4c0d-814b-7b95b44b3f53",
      code: 1399,
      name: "Minar Zarza",
      postalCode: "1399000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "089d4654-7d9c-4666-b29f-c3602ed5f395",
      code: 1400,
      name: "Oued Athmenia",
      postalCode: "1400000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6137bd04-59f0-481f-a8fa-564187208c55",
      code: 1401,
      name: "Oued Endja",
      postalCode: "1401000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ce3a00cf-70bb-4631-9b04-62f1fa0bd109",
      code: 1402,
      name: "Oued Seguen",
      postalCode: "1402000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "49bc42e8-b813-4ccc-9938-33e3bdf4c6d5",
      code: 1403,
      name: "Ouled Khalouf",
      postalCode: "1403000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "700a5b85-9fbf-4d66-980c-1d492f966324",
      code: 1404,
      name: "Rouached",
      postalCode: "1404000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3584e96d-8091-44b1-9a6b-0706246d9666",
      code: 1405,
      name: "Sidi Khelifa",
      postalCode: "1405000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0987d129-197f-4c54-9030-0f836cf2ee15",
      code: 1406,
      name: "Sidi Merouane",
      postalCode: "1406000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "268a4ea5-0629-473d-951b-f5b7d0d142c1",
      code: 1407,
      name: "Tadjenanet",
      postalCode: "1407000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6a3597b6-b572-4e1f-8a7a-ddcc99cb45d5",
      code: 1408,
      name: "Tassadane Haddada",
      postalCode: "1408000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "11b3867d-a1a6-4165-9d3e-77b0d3096c64",
      code: 1409,
      name: "Teleghma",
      postalCode: "1409000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0bbef0ce-dfa9-4d3a-b762-527507aa9664",
      code: 1410,
      name: "Terrai Bainen",
      postalCode: "1410000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e12e3440-8c71-4220-817d-c4f1071babbb",
      code: 1411,
      name: "Tassala Lematai",
      postalCode: "1411000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "02675a99-0dbe-42aa-a03f-6a219fff64b0",
      code: 1412,
      name: "Tiberguent",
      postalCode: "1412000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "fcdb7399-b9ac-4ebd-bb94-9a8f9e55eebf",
      code: 1413,
      name: "Yahia Beniguecha",
      postalCode: "1413000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e6ef5bc4-99f9-4137-9908-fcdd6be7a657",
      code: 1414,
      name: "Zeghaia",
      postalCode: "1414000",
      level: "commune",
      parentId: "0c8476c5-bbe4-46e4-80e5-67d3501195cc",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "91f9a87b-eed8-4919-a613-64d892963936",
      code: 1415,
      name: "Ain-Benian",
      postalCode: "1415000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "76d6dedd-abae-46fe-a9df-22a7dc580368",
      code: 1416,
      name: "Ain-Bouyahia",
      postalCode: "1416000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "997e7a95-bc11-405e-bce3-2814e0ed7f32",
      code: 1417,
      name: "Ain-Defla",
      postalCode: "1417000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "fbf8df21-abe7-431c-9891-14e3f4d52bc6",
      code: 1418,
      name: "Ain-Lechiakh",
      postalCode: "1418000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c8270671-ede9-4357-80eb-0e8665ddbc9f",
      code: 1419,
      name: "Ain-Soltane",
      postalCode: "1419000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "28e2949c-12bc-4b85-b82e-7eeb2f6f9f47",
      code: 1420,
      name: "Ain-Torki",
      postalCode: "1420000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a2087636-e6dc-4cd9-8a02-59d1ef896fc4",
      code: 1421,
      name: "Arib",
      postalCode: "1421000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5c5668f8-a15e-4472-a61f-8ca8eb8130fe",
      code: 1422,
      name: "Birbouche",
      postalCode: "1422000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7decb5ca-9c2d-4fe0-823b-86eeb72224de",
      code: 1423,
      name: "Bathia",
      postalCode: "1423000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "64041db6-98af-47fb-9f67-87e52561137f",
      code: 1424,
      name: "Belaas",
      postalCode: "1424000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "aee21694-3b78-4da0-91d2-65eb9644959d",
      code: 1425,
      name: "Ben Allal",
      postalCode: "1425000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ae0e559a-84e0-4f3c-83b4-2f12e98afc10",
      code: 1426,
      name: "Bir-Ould-Khelifa",
      postalCode: "1426000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "da0ee969-1903-4330-a4a5-afbe724822e5",
      code: 1427,
      name: "Bordj-Emir-Khaled",
      postalCode: "1427000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "dded2442-d7c4-4b26-9afa-b43395af2b3b",
      code: 1428,
      name: "Boumedfaa",
      postalCode: "1428000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d134c058-7b2a-407c-aca4-6ccebbd4301c",
      code: 1429,
      name: "Bourached",
      postalCode: "1429000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "358adb18-5bbf-4f7a-9c61-ea4f225fc38c",
      code: 1430,
      name: "Djelida",
      postalCode: "1430000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5408bd4f-39d6-456a-b25b-a07becaaa339",
      code: 1431,
      name: "Djemaa Ouled Cheikh",
      postalCode: "1431000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "36f1830e-5cb9-4fe5-8c36-fe072a4222ba",
      code: 1432,
      name: "Djendel",
      postalCode: "1432000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f2530fb5-06db-49cd-ba6b-131f49faa68e",
      code: 1433,
      name: "El-Abadia",
      postalCode: "1433000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a47ed3d9-a1ba-460a-9811-943c41c7c63d",
      code: 1434,
      name: "El-Amra",
      postalCode: "1434000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "addabbb8-7bf8-4707-9b75-e605a7bdae2c",
      code: 1435,
      name: "El-Attaf",
      postalCode: "1435000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3ef97e13-244f-49ba-b6b4-cc62e2587a8a",
      code: 1436,
      name: "El-Maine",
      postalCode: "1436000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f566d1b3-a965-4707-ae2a-c0ccbe6f69c9",
      code: 1437,
      name: "Hammam-Righa",
      postalCode: "1437000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ae28b5a7-5e81-4afd-a672-9182602f714f",
      code: 1438,
      name: "Hassania",
      postalCode: "1438000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "64fa88be-329c-4e5e-9a1d-b47f1884d661",
      code: 1439,
      name: "Hoceinia",
      postalCode: "1439000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "bc393e93-df80-4490-bb31-4a48a4afcb4a",
      code: 1440,
      name: "Khemis-Miliana",
      postalCode: "1440000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5302194b-4007-4d21-9dac-622dbc3bdb9d",
      code: 1441,
      name: "Mekhatria",
      postalCode: "1441000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5272b135-8b96-4834-bc32-6356bb0db9c3",
      code: 1442,
      name: "Miliana",
      postalCode: "1442000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "57fc71c1-46d7-468c-8c34-9a86dfe04980",
      code: 1443,
      name: "Oued Chorfa",
      postalCode: "1443000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d8694884-ccbb-48dc-bbca-6795e34f1568",
      code: 1444,
      name: "Oued Djemaa",
      postalCode: "1444000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "61e0ea97-535e-46da-a569-8f4ed7450c2a",
      code: 1445,
      name: "Rouina",
      postalCode: "1445000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8d8ef924-d721-42a7-856e-449549b23af5",
      code: 1446,
      name: "Sidi-Lakhdar",
      postalCode: "1446000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "afc348b3-6511-442a-aa84-ace68b5f13b0",
      code: 1447,
      name: "Tacheta Zegagha",
      postalCode: "1447000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4fe95ba2-de9a-46cf-8821-46700ca137e4",
      code: 1448,
      name: "Tarik-Ibn-Ziad",
      postalCode: "1448000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a489da80-cf86-4df3-9413-734d36c6fcac",
      code: 1449,
      name: "Tiberkanine",
      postalCode: "1449000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0e2789c1-b771-4237-8066-7a159dee973f",
      code: 1450,
      name: "Zeddine",
      postalCode: "1450000",
      level: "commune",
      parentId: "8d2d130f-460c-4867-85ef-641341a4d586",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "67ea1b1c-2b66-4524-aebc-c004b896cd45",
      code: 1451,
      name: "Ain Ben Khelil",
      postalCode: "1451000",
      level: "commune",
      parentId: "ecdf0888-0470-4b2f-beb8-24c99b6fc9cb",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "85623f9a-1628-41e5-a5a6-45e1ee6887f4",
      code: 1452,
      name: "Ain Sefra",
      postalCode: "1452000",
      level: "commune",
      parentId: "ecdf0888-0470-4b2f-beb8-24c99b6fc9cb",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "12e9b4f0-f15c-43c0-8b0d-6a33e870d940",
      code: 1453,
      name: "Asla",
      postalCode: "1453000",
      level: "commune",
      parentId: "ecdf0888-0470-4b2f-beb8-24c99b6fc9cb",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d19ed357-1561-4599-b4d3-3f1fac428ffc",
      code: 1454,
      name: "Djenienne Bourezg",
      postalCode: "1454000",
      level: "commune",
      parentId: "ecdf0888-0470-4b2f-beb8-24c99b6fc9cb",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7d4b4f3c-12f2-4873-913b-63b3cccb785a",
      code: 1455,
      name: "El Biodh",
      postalCode: "1455000",
      level: "commune",
      parentId: "ecdf0888-0470-4b2f-beb8-24c99b6fc9cb",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "fa5dcda6-4dbb-4b21-9b49-d5773b454c7d",
      code: 1456,
      name: "Kasdir",
      postalCode: "1456000",
      level: "commune",
      parentId: "ecdf0888-0470-4b2f-beb8-24c99b6fc9cb",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ea0f756e-c61c-42d4-a737-8a4a26136468",
      code: 1457,
      name: "Makmen Ben Amar",
      postalCode: "1457000",
      level: "commune",
      parentId: "ecdf0888-0470-4b2f-beb8-24c99b6fc9cb",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "57d85a47-e51d-4dd8-9602-30f8472ace40",
      code: 1458,
      name: "Mecheria",
      postalCode: "1458000",
      level: "commune",
      parentId: "ecdf0888-0470-4b2f-beb8-24c99b6fc9cb",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d0bc00aa-a38e-46d6-90be-ed2f0cc879a3",
      code: 1459,
      name: "Moghrar",
      postalCode: "1459000",
      level: "commune",
      parentId: "ecdf0888-0470-4b2f-beb8-24c99b6fc9cb",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c9e7430c-c2dc-42d3-a188-2914c3f81bfe",
      code: 1460,
      name: "Naama",
      postalCode: "1460000",
      level: "commune",
      parentId: "ecdf0888-0470-4b2f-beb8-24c99b6fc9cb",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a1fb6c7b-737d-4bdf-86ea-68337ebf92a3",
      code: 1461,
      name: "Sfissifa",
      postalCode: "1461000",
      level: "commune",
      parentId: "ecdf0888-0470-4b2f-beb8-24c99b6fc9cb",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "fb1f4590-2dc3-47f3-8b8c-6a50506c714f",
      code: 1462,
      name: "Tiout",
      postalCode: "1462000",
      level: "commune",
      parentId: "ecdf0888-0470-4b2f-beb8-24c99b6fc9cb",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "edb0a7de-5077-4c75-876e-b734fbafbf81",
      code: 1463,
      name: "Aghlal",
      postalCode: "1463000",
      level: "commune",
      parentId: "fc460ec5-3e71-489c-b95b-e5301ea68341",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d597e281-9114-4a8b-b97e-0ee6ea001913",
      code: 1464,
      name: "Ain El Arbaa",
      postalCode: "1464000",
      level: "commune",
      parentId: "fc460ec5-3e71-489c-b95b-e5301ea68341",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d53d8d1a-d65d-4e04-a44a-cf8bddf30460",
      code: 1465,
      name: "Ain Kihal",
      postalCode: "1465000",
      level: "commune",
      parentId: "fc460ec5-3e71-489c-b95b-e5301ea68341",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3484bddb-c3f0-4d7a-a23d-0ff5324a588b",
      code: 1466,
      name: "Ain Temouchent",
      postalCode: "1466000",
      level: "commune",
      parentId: "fc460ec5-3e71-489c-b95b-e5301ea68341",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5268ec3d-ff2a-4b9c-973d-bc3bb2d0034a",
      code: 1467,
      name: "Ain Tolba",
      postalCode: "1467000",
      level: "commune",
      parentId: "fc460ec5-3e71-489c-b95b-e5301ea68341",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2d37d6c2-1414-4ab3-8593-6df270c7cb14",
      code: 1468,
      name: "Aoubellil",
      postalCode: "1468000",
      level: "commune",
      parentId: "fc460ec5-3e71-489c-b95b-e5301ea68341",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8727eade-228c-4222-803d-bf4206a6d3a1",
      code: 1469,
      name: "Beni Saf",
      postalCode: "1469000",
      level: "commune",
      parentId: "fc460ec5-3e71-489c-b95b-e5301ea68341",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "46c3da9a-07f3-4c38-882e-64394ecc9c23",
      code: 1470,
      name: "Bouzedjar",
      postalCode: "1470000",
      level: "commune",
      parentId: "fc460ec5-3e71-489c-b95b-e5301ea68341",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "13777741-f48c-4a55-b44d-9ced8d877b01",
      code: 1471,
      name: "Chaabat El Ham",
      postalCode: "1471000",
      level: "commune",
      parentId: "fc460ec5-3e71-489c-b95b-e5301ea68341",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6724882c-2f20-4658-aa29-f8b0f8000248",
      code: 1472,
      name: "Chentouf",
      postalCode: "1472000",
      level: "commune",
      parentId: "fc460ec5-3e71-489c-b95b-e5301ea68341",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d1e0441e-95c9-4e15-826f-68f7f849e526",
      code: 1473,
      name: "El Amria",
      postalCode: "1473000",
      level: "commune",
      parentId: "fc460ec5-3e71-489c-b95b-e5301ea68341",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6109dbc3-7e86-4cc4-8fb3-c317fd9b6ce7",
      code: 1474,
      name: "El Maleh",
      postalCode: "1474000",
      level: "commune",
      parentId: "fc460ec5-3e71-489c-b95b-e5301ea68341",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3a201cfa-cec4-4ffe-a467-e070c83469e3",
      code: 1475,
      name: "El Messaid",
      postalCode: "1475000",
      level: "commune",
      parentId: "fc460ec5-3e71-489c-b95b-e5301ea68341",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9492c4e7-e1f4-4a50-9dce-dc1dddb26e63",
      code: 1476,
      name: "Emir Abdelkader",
      postalCode: "1476000",
      level: "commune",
      parentId: "fc460ec5-3e71-489c-b95b-e5301ea68341",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "25530400-d9a6-4533-909a-8ff7b1d5454b",
      code: 1477,
      name: "Hammam Bou Hadjar",
      postalCode: "1477000",
      level: "commune",
      parentId: "fc460ec5-3e71-489c-b95b-e5301ea68341",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "cf631e6a-2a29-4e41-a613-cca9e51ec84c",
      code: 1478,
      name: "Hassasna",
      postalCode: "1478000",
      level: "commune",
      parentId: "fc460ec5-3e71-489c-b95b-e5301ea68341",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0a17968d-6ef3-421c-84cb-df71feb46fa7",
      code: 1479,
      name: "Hassi El Ghella",
      postalCode: "1479000",
      level: "commune",
      parentId: "fc460ec5-3e71-489c-b95b-e5301ea68341",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "20d04a8f-38a8-4e37-bd11-7eb854bac8a0",
      code: 1480,
      name: "Oued Berkeche",
      postalCode: "1480000",
      level: "commune",
      parentId: "fc460ec5-3e71-489c-b95b-e5301ea68341",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3f1b8094-6911-43f8-8d17-79d67c8f46a5",
      code: 1481,
      name: "Oued Sebbah",
      postalCode: "1481000",
      level: "commune",
      parentId: "fc460ec5-3e71-489c-b95b-e5301ea68341",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5cca4d98-f335-42a6-87e4-fc2af8594986",
      code: 1482,
      name: "Ouled Boudjemaa",
      postalCode: "1482000",
      level: "commune",
      parentId: "fc460ec5-3e71-489c-b95b-e5301ea68341",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "5591c6f3-e34e-496a-a36f-3696c1660bd7",
      code: 1483,
      name: "Ouled Kihal",
      postalCode: "1483000",
      level: "commune",
      parentId: "fc460ec5-3e71-489c-b95b-e5301ea68341",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0acb12e4-6c59-4455-a90c-d58fdbd894b8",
      code: 1484,
      name: "Oulhaca El Gheraba",
      postalCode: "1484000",
      level: "commune",
      parentId: "fc460ec5-3e71-489c-b95b-e5301ea68341",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "80eb4dd5-c367-4209-8cdc-6f4bb34f091a",
      code: 1485,
      name: "Sidi Ben Adda",
      postalCode: "1485000",
      level: "commune",
      parentId: "fc460ec5-3e71-489c-b95b-e5301ea68341",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d59a44b0-7f1e-428b-9888-f6bc8c433a7a",
      code: 1486,
      name: "Sidi Boumediene",
      postalCode: "1486000",
      level: "commune",
      parentId: "fc460ec5-3e71-489c-b95b-e5301ea68341",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d29b4b2b-250d-47b2-b08d-15faefa0db05",
      code: 1487,
      name: "Sidi Ouriache",
      postalCode: "1487000",
      level: "commune",
      parentId: "fc460ec5-3e71-489c-b95b-e5301ea68341",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f668d9fb-cace-461a-83cb-670d8dccb04b",
      code: 1488,
      name: "Sidi Safi",
      postalCode: "1488000",
      level: "commune",
      parentId: "fc460ec5-3e71-489c-b95b-e5301ea68341",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "efb167f8-702e-4efd-8b06-a87601906a20",
      code: 1489,
      name: "Tamzoura",
      postalCode: "1489000",
      level: "commune",
      parentId: "fc460ec5-3e71-489c-b95b-e5301ea68341",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d8fc1f52-f46d-406e-b56b-446ec91a62e3",
      code: 1490,
      name: "Terga",
      postalCode: "1490000",
      level: "commune",
      parentId: "fc460ec5-3e71-489c-b95b-e5301ea68341",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0cf353d1-251b-4fb3-8673-c299230463ea",
      code: 1491,
      name: "Berriane",
      postalCode: "1491000",
      level: "commune",
      parentId: "e7b51620-74f4-4748-85c5-216fb9b01b03",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9d5cb420-02e5-46e3-978c-59d737ab9f5b",
      code: 1492,
      name: "Bounoura",
      postalCode: "1492000",
      level: "commune",
      parentId: "e7b51620-74f4-4748-85c5-216fb9b01b03",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "215bc577-dcf3-4cbb-9b25-d402e63afd22",
      code: 1493,
      name: "Dhayet Bendhahoua",
      postalCode: "1493000",
      level: "commune",
      parentId: "e7b51620-74f4-4748-85c5-216fb9b01b03",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8121e78e-652b-4c19-aaa5-2b0ed6974ecf",
      code: 1494,
      name: "El Atteuf",
      postalCode: "1494000",
      level: "commune",
      parentId: "e7b51620-74f4-4748-85c5-216fb9b01b03",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a6a436bd-e8e5-4bd7-8b7c-a91906222143",
      code: 1495,
      name: "El Meniaa",
      postalCode: "1495000",
      level: "commune",
      parentId: "3d19d427-08f3-492c-a1d0-e7ace3516ed2",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: false,
      },
    },
    {
      id: "f4f46fef-964c-4f71-97ed-90761487cce5",
      code: 1496,
      name: "Ghardaia",
      postalCode: "1496000",
      level: "commune",
      parentId: "e7b51620-74f4-4748-85c5-216fb9b01b03",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f9bbf127-197b-495b-806a-cc5453fbc234",
      code: 1497,
      name: "El Guerrara",
      postalCode: "1497000",
      level: "commune",
      parentId: "e7b51620-74f4-4748-85c5-216fb9b01b03",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6d26ddae-19db-426d-b503-0f37d6bdf200",
      code: 1498,
      name: "Hassi Fehal",
      postalCode: "1498000",
      level: "commune",
      parentId: "3d19d427-08f3-492c-a1d0-e7ace3516ed2",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: false,
      },
    },
    {
      id: "3070f992-882e-4c3e-ade0-099b20291aad",
      code: 1499,
      name: "Hassi Gara",
      postalCode: "1499000",
      level: "commune",
      parentId: "3d19d427-08f3-492c-a1d0-e7ace3516ed2",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: false,
      },
    },
    {
      id: "d59fd20b-4e99-4b38-ab26-a925d6d06b11",
      code: 1500,
      name: "Mansoura",
      postalCode: "1500000",
      level: "commune",
      parentId: "e7b51620-74f4-4748-85c5-216fb9b01b03",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "678a414f-6e31-47ba-a793-15b2032ceb57",
      code: 1501,
      name: "Metlili",
      postalCode: "1501000",
      level: "commune",
      parentId: "e7b51620-74f4-4748-85c5-216fb9b01b03",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "393d892e-2166-4dcd-9212-c7a5f557047d",
      code: 1502,
      name: "Sebseb",
      postalCode: "1502000",
      level: "commune",
      parentId: "e7b51620-74f4-4748-85c5-216fb9b01b03",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3b296d3b-dee8-40a9-b761-d5159e0c34e7",
      code: 1503,
      name: "Zelfana",
      postalCode: "1503000",
      level: "commune",
      parentId: "e7b51620-74f4-4748-85c5-216fb9b01b03",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f8e77c72-7538-4dcc-bbdd-967387c8878d",
      code: 1504,
      name: "Ain Rahma",
      postalCode: "1504000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "983df327-8c37-4a47-b130-d0b2bf688889",
      code: 1505,
      name: "Ain-Tarek",
      postalCode: "1505000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2074edfc-7578-4f14-8682-2433c0f0db85",
      code: 1506,
      name: "Ammi Moussa",
      postalCode: "1506000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "557e3fda-ff83-4f1d-899c-c2f83987103c",
      code: 1507,
      name: "Belaassel Bouzagza",
      postalCode: "1507000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "9206b10a-2f3e-4ecb-9370-1a70291bbdfe",
      code: 1508,
      name: "Bendaoud",
      postalCode: "1508000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d1fb9554-d299-4dba-81ff-4d707ec168f2",
      code: 1509,
      name: "Beni Dergoun",
      postalCode: "1509000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e14f270a-69ba-4aa4-b38d-ded7f35c6d6b",
      code: 1510,
      name: "Beni Zentis",
      postalCode: "1510000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "b9ba5f88-858f-4db5-a3d4-ba981046b734",
      code: 1511,
      name: "Dar Ben Abdelah",
      postalCode: "1511000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f9ba0c78-5b86-4b05-b960-9eacef4251ff",
      code: 1512,
      name: "Djidiouia",
      postalCode: "1512000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "743342a8-2115-4f94-8920-522540b30359",
      code: 1513,
      name: "El Hassi",
      postalCode: "1513000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d5b92e5f-6efe-4a8e-939a-8bdd42b203d5",
      code: 1514,
      name: "El H'madna",
      postalCode: "1514000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "83b203f7-9b30-45f0-ac09-9c85f44eec9d",
      code: 1515,
      name: "El Ouldja",
      postalCode: "1515000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "de13d7c2-459d-48a3-8e9c-d6595edfbf24",
      code: 1516,
      name: "El-Guettar",
      postalCode: "1516000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "0920780f-1d92-4610-a908-3a23b355a4de",
      code: 1517,
      name: "El-Matmar",
      postalCode: "1517000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ee6803e2-942d-4226-8149-caf48cf161f2",
      code: 1518,
      name: "Had Echkalla",
      postalCode: "1518000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "cf1dfcbf-7807-4c50-ae66-226d5f93fa16",
      code: 1519,
      name: "Hamri",
      postalCode: "1519000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "ccfae0b1-43cc-4bb1-85c8-9ebcd1a9512c",
      code: 1520,
      name: "Kalaa",
      postalCode: "1520000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "336a5eb9-6116-471a-9f96-97c24c9b423d",
      code: 1521,
      name: "Lahlef",
      postalCode: "1521000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "998627bf-d759-4d74-af12-d909b865452b",
      code: 1522,
      name: "Mazouna",
      postalCode: "1522000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "8d374457-b249-4d84-acd2-7a6537dfb48f",
      code: 1523,
      name: "Mediouna",
      postalCode: "1523000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "a1b8b580-41dd-4261-90e7-82e1af031b03",
      code: 1524,
      name: "Mendes",
      postalCode: "1524000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "948e8ccc-9abb-4d56-a621-510efe2c0b85",
      code: 1525,
      name: "Merdja Sidi Abed",
      postalCode: "1525000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "f63d1a66-94ac-4b8c-a13a-387eb23ff39b",
      code: 1526,
      name: "Ouarizane",
      postalCode: "1526000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "4408b73c-ce23-4546-ae76-feab1823a81e",
      code: 1527,
      name: "Oued El Djemaa",
      postalCode: "1527000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d6e45abd-dcba-439f-b316-d727b3d417a0",
      code: 1528,
      name: "Oued Essalem",
      postalCode: "1528000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "e2df915e-badb-4527-8329-0cc1d9ee9195",
      code: 1529,
      name: "Oued-Rhiou",
      postalCode: "1529000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d9bc703f-e4d2-4fbe-a73a-4a07650614d2",
      code: 1530,
      name: "Ouled Aiche",
      postalCode: "1530000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "7e893b4f-9d20-40aa-9935-72ce0f6b896c",
      code: 1531,
      name: "Ouled Sidi Mihoub",
      postalCode: "1531000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "aa154e04-2724-4e3a-a973-b79c37f5e776",
      code: 1532,
      name: "Ramka",
      postalCode: "1532000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "67796560-db4e-4ad2-9942-14e5c2697719",
      code: 1533,
      name: "Relizane",
      postalCode: "1533000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "d8feac60-1890-4b35-b92a-fe288441a685",
      code: 1534,
      name: "Sidi Khettab",
      postalCode: "1534000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "6dc53d9a-23e9-44bd-9c25-9269ad9855b0",
      code: 1535,
      name: "Sidi Lazreg",
      postalCode: "1535000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "676cc2cb-b3b1-4956-a008-b09bd147866a",
      code: 1536,
      name: "Sidi M'hamed Benali",
      postalCode: "1536000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "63e3d6e1-e77e-4e78-8ae7-f60de8cb7ce7",
      code: 1537,
      name: "Sidi M'hamed Benaouda",
      postalCode: "1537000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "3133caca-d747-4b71-95cf-7f090eab3c63",
      code: 1538,
      name: "Sidi Saada",
      postalCode: "1538000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "aaf4eeb6-44b3-4dc0-bba2-b06ec244c31c",
      code: 1539,
      name: "Souk El Had",
      postalCode: "1539000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "c0d0ed17-e525-4e18-9e4d-240f3aa693a2",
      code: 1540,
      name: "Yellel",
      postalCode: "1540000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
    {
      id: "2ec848f4-7f62-4751-b0c6-7c6d4c4367f1",
      code: 1541,
      name: "Zemmoura",
      postalCode: "1541000",
      level: "commune",
      parentId: "ad58c5ee-868d-4acb-8f03-409f97a10370",
      delivery: {
        hasHomeDelivery: true,
        hasPickupPoint: true,
      },
    },
  ],
};
